
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9346"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9346"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("ebcW3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a52c207aab93bf4f$export$2e2bcd8739ae039);

var $66mQQ = parcelRequire("66mQQ");

var $38qqf = parcelRequire("38qqf");

var $iCFRA = parcelRequire("iCFRA");

var $5vTfu = parcelRequire("5vTfu");

var $ezj1P = parcelRequire("ezj1P");

var $flUkq = parcelRequire("flUkq");

var $ceNev = parcelRequire("ceNev");

var $4hMrQ = parcelRequire("4hMrQ");

var $j48cx = parcelRequire("j48cx");
/**
 * @typedef {Object} Mgrs
 * @property {(lonlat: [number, number]) => string} forward
 * @property {(mgrsString: string) => [number, number, number, number]} inverse
 * @property {(mgrsString: string) => [number, number]} toPoint
 */ /**
 * @typedef {import('./defs').ProjectionDefinition} ProjectionDefinition
 * @typedef {import('./core').TemplateCoordinates} TemplateCoordinates
 * @typedef {import('./core').InterfaceCoordinates} InterfaceCoordinates
 * @typedef {import('./core').Converter} Converter
 * @typedef {import('./Proj').DatumDefinition} DatumDefinition
 */ /**
 * @template {import('./core').TemplateCoordinates} T
 * @type {core<T> & {defaultDatum: string, Proj: typeof Proj, WGS84: Proj, Point: typeof Point, toPoint: typeof common, defs: typeof defs, nadgrid: typeof nadgrid, transform: typeof transform, mgrs: Mgrs, version: string}}
 */ const $a52c207aab93bf4f$var$proj4 = Object.assign((0, $66mQQ.default), {
    defaultDatum: 'WGS84',
    Proj: $38qqf.default,
    WGS84: new (0, $38qqf.default)('WGS84'),
    Point: $iCFRA.default,
    toPoint: (0, $5vTfu.default),
    defs: $ezj1P.default,
    nadgrid: $flUkq.default,
    transform: $ceNev.default,
    mgrs: $4hMrQ.default,
    version: '__VERSION__'
});
(0, $j48cx.default)($a52c207aab93bf4f$var$proj4);
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = $a52c207aab93bf4f$var$proj4;

});
parcelRegister("66mQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $471507637a3ff861$export$2e2bcd8739ae039);

var $38qqf = parcelRequire("38qqf");

var $ceNev = parcelRequire("ceNev");
var $471507637a3ff861$var$wgs84 = (0, $38qqf.default)('WGS84');
/**
 * @typedef {{x: number, y: number, z?: number, m?: number}} InterfaceCoordinates
 */ /**
 * @typedef {Array<number> | InterfaceCoordinates} TemplateCoordinates
 */ /**
 * @typedef {Object} Converter
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {proj} [oProj]
 */ /**
 * @typedef {Object} PROJJSONDefinition
 * @property {string} [$schema]
 * @property {string} type
 * @property {string} [name]
 * @property {{authority: string, code: number}} [id]
 * @property {string} [scope]
 * @property {string} [area]
 * @property {{south_latitude: number, west_longitude: number, north_latitude: number, east_longitude: number}} [bbox]
 * @property {PROJJSONDefinition[]} [components]
 * @property {{type: string, name: string}} [datum]
 * @property {{
 *   name: string,
 *   members: Array<{
 *     name: string,
 *     id?: {authority: string, code: number}
 *   }>,
 *   ellipsoid?: {
 *     name: string,
 *     semi_major_axis: number,
 *     inverse_flattening?: number
 *   },
 *   accuracy?: string,
 *   id?: {authority: string, code: number}
 * }} [datum_ensemble]
 * @property {{
 *   subtype: string,
 *   axis: Array<{
 *     name: string,
 *     abbreviation?: string,
 *     direction: string,
 *     unit: string
 *   }>
 * }} [coordinate_system]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string
 *   }>
 * }} [conversion]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string,
 *     type?: string,
 *     file_name?: string
 *   }>
 * }} [transformation]
 */ /**
 * @template {TemplateCoordinates} T
 * @param {proj} from
 * @param {proj} to
 * @param {T} coords
 * @param {boolean} [enforceAxis]
 * @returns {T}
 */ function $471507637a3ff861$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $ceNev.default)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (typeof transformedArray.z === 'number') return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.slice(3));
                else return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.slice(3));
            } else return /** @type {T} */ [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.slice(2));
        } else return /** @type {T} */ [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $ceNev.default)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return /** @type {T} */ out;
        keys.forEach(function(key) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (key === 'x' || key === 'y' || key === 'z') return;
            } else {
                if (key === 'x' || key === 'y') return;
            }
            out[key] = coords[key];
        });
        return /** @type {T} */ out;
    }
}
/**
 * @param {proj | string | PROJJSONDefinition | Converter} item
 * @returns {import('./Proj').default}
 */ function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $38qqf.default)) return item;
    if (typeof item === 'object' && 'oProj' in item) return item.oProj;
    return (0, $38qqf.default)(/** @type {string | PROJJSONDefinition} */ item);
}
/**
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @param {string | PROJJSONDefinition | proj} fromProjOrToProj
 * @param {string | PROJJSONDefinition | proj | TemplateCoordinates} [toProjOrCoord]
 * @param {T} [coord]
 * @returns {T|Converter}
 */ function $471507637a3ff861$var$proj4(fromProjOrToProj, toProjOrCoord, coord) {
    /** @type {proj} */ var fromProj;
    /** @type {proj} */ var toProj;
    var single = false;
    /** @type {Converter} */ var obj;
    if (typeof toProjOrCoord === 'undefined') {
        toProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof /** @type {?} */ toProjOrCoord.x !== 'undefined' || Array.isArray(toProjOrCoord)) {
        coord = /** @type {?} */ toProjOrCoord;
        toProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    if (!fromProj) fromProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
    if (!toProj) toProj = $471507637a3ff861$var$checkProj(/** @type {string | PROJJSONDefinition | proj } */ toProjOrCoord);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ forward: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ inverse: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;

});
parcelRegister("38qqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24869d6338533b3b$export$2e2bcd8739ae039);

var $giDQh = parcelRequire("giDQh");

var $cWauz = parcelRequire("cWauz");

var $1Wo5P = parcelRequire("1Wo5P");

var $d8b9d = parcelRequire("d8b9d");

var $gMdFS = parcelRequire("gMdFS");

var $3MCqb = parcelRequire("3MCqb");

var $hzXAi = parcelRequire("hzXAi");

var $flUkq = parcelRequire("flUkq");
/**
 * @typedef {Object} DatumDefinition
 * @property {number} datum_type - The type of datum.
 * @property {number} a - Semi-major axis of the ellipsoid.
 * @property {number} b - Semi-minor axis of the ellipsoid.
 * @property {number} es - Eccentricity squared of the ellipsoid.
 * @property {number} ep2 - Second eccentricity squared of the ellipsoid.
 */ /**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} srsCode
 * @param {(errorMessage?: string, instance?: Projection) => void} [callback]
 */ function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.forward = null;
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.inverse = null;
    /** @type {function(): void} */ this.init = null;
    /** @type {string} */ this.name;
    /** @type {Array<string>} */ this.names = null;
    /** @type {string} */ this.title;
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $giDQh.default)(srsCode);
    if (typeof json !== 'object') {
        callback('Could not parse to valid json: ' + srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback('Could not get projection name from: ' + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = (0, $hzXAi.default)((0, $gMdFS.default), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $d8b9d.sphere)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $d8b9d.eccentricity)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $flUkq.getNadgrids)(json.nadgrids);
    /** @type {DatumDefinition} */ var datumObj = json.datum || (0, $3MCqb.default)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $cWauz.default)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $cWauz.default)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    if ('init' in this && typeof this.init === 'function') this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $1Wo5P.default);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;

});
parcelRegister("giDQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddd3b9c0d2064cd$export$2e2bcd8739ae039);

var $ezj1P = parcelRequire("ezj1P");

var $7UVTv = parcelRequire("7UVTv");

var $7zrM7 = parcelRequire("7zrM7");

var $hzXAi = parcelRequire("hzXAi");
function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === 'string';
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $ezj1P.default);
}
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return code.indexOf('+') !== 0 && code.indexOf('[') !== -1 || typeof code === 'object' && !('srsCode' in code);
}
var $bddd3b9c0d2064cd$var$codes = [
    '3857',
    '900913',
    '3785',
    '102113'
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $hzXAi.default)(item, 'authority');
    if (!auth) return;
    var code = (0, $hzXAi.default)(auth, 'epsg');
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $hzXAi.default)(item, 'extension');
    if (!ext) return;
    return (0, $hzXAi.default)(ext, 'proj4');
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === '+';
}
/**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} code
 * @returns {import('./defs').ProjectionDefinition}
 */ function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        // check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $ezj1P.default)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $7UVTv.default)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $ezj1P.default)['EPSG:3857'];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $7zrM7.default)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $7zrM7.default)(code);
    } else if (!('projName' in code)) return (0, $7UVTv.default)(code);
    else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;

});
parcelRegister("ezj1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b3183caccb3297$export$2e2bcd8739ae039);

var $cR6T8 = parcelRequire("cR6T8");

var $7zrM7 = parcelRequire("7zrM7");

var $7UVTv = parcelRequire("7UVTv");
/**
 * @typedef {Object} ProjectionDefinition
 * @property {string} title
 * @property {string} [projName]
 * @property {string} [ellps]
 * @property {import('./Proj.js').DatumDefinition} [datum]
 * @property {string} [datumName]
 * @property {number} [rf]
 * @property {number} [lat0]
 * @property {number} [lat1]
 * @property {number} [lat2]
 * @property {number} [lat_ts]
 * @property {number} [long0]
 * @property {number} [long1]
 * @property {number} [long2]
 * @property {number} [alpha]
 * @property {number} [longc]
 * @property {number} [x0]
 * @property {number} [y0]
 * @property {number} [k0]
 * @property {number} [a]
 * @property {number} [b]
 * @property {true} [R_A]
 * @property {number} [zone]
 * @property {true} [utmSouth]
 * @property {string|Array<number>} [datum_params]
 * @property {number} [to_meter]
 * @property {string} [units]
 * @property {number} [from_greenwich]
 * @property {string} [datumCode]
 * @property {string} [nadgrids]
 * @property {string} [axis]
 * @property {boolean} [sphere]
 * @property {number} [rectified_grid_angle]
 * @property {boolean} [approx]
 * @property {boolean} [over]
 * @property {string} [projStr]
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 */ /**
 * @overload
 * @param {string} name
 * @param {string|ProjectionDefinition|import('./core.js').PROJJSONDefinition} projection
 * @returns {void}
 */ /**
 * @overload
 * @param {Array<[string, string]>} name
 * @returns {Array<ProjectionDefinition|undefined>}
 */ /**
 * @overload
 * @param {string} name
 * @returns {ProjectionDefinition}
 */ /**
 * @param {string | Array<Array<string>> | Partial<Record<'EPSG'|'ESRI'|'IAU2000', ProjectionDefinition>>} name
 * @returns {ProjectionDefinition | Array<ProjectionDefinition|undefined> | void}
 */ function $a9b3183caccb3297$var$defs(name) {
    /* global console */ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
            if (def.charAt(0) === '+') $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7zrM7.default)(arguments[1]);
            else $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7UVTv.default)(arguments[1]);
        } else if (def && typeof def === 'object' && !('projName' in def)) // PROJJSON
        $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7UVTv.default)(arguments[1]);
        else {
            $a9b3183caccb3297$var$defs[/** @type {string} */ name] = def;
            if (!def) delete $a9b3183caccb3297$var$defs[/** @type {string} */ name];
        }
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) return $a9b3183caccb3297$var$defs.apply(that, v);
            else return $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === 'string') {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ('EPSG' in name) $a9b3183caccb3297$var$defs['EPSG:' + name.EPSG] = name;
        else if ('ESRI' in name) $a9b3183caccb3297$var$defs['ESRI:' + name.ESRI] = name;
        else if ('IAU2000' in name) $a9b3183caccb3297$var$defs['IAU2000:' + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $cR6T8.default)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;

});
parcelRegister("cR6T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95bfc720255032a6$export$2e2bcd8739ae039);
function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees');
    defs('EPSG:4269', '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees');
    defs('EPSG:3857', '+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs');
    // UTM WGS84
    for(var i = 1; i <= 60; ++i){
        defs('EPSG:' + (32600 + i), '+proj=utm +zone=' + i + ' +datum=WGS84 +units=m');
        defs('EPSG:' + (32700 + i), '+proj=utm +zone=' + i + ' +south +datum=WGS84 +units=m');
    }
    defs('EPSG:5041', '+title=WGS 84 / UPS North (E,N) +proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs('EPSG:5042', '+title=WGS 84 / UPS South (E,N) +proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs.WGS84 = defs['EPSG:4326'];
    defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs['EPSG:3857'];
    defs['EPSG:900913'] = defs['EPSG:3857'];
    defs['EPSG:102113'] = defs['EPSG:3857'];
}

});

parcelRegister("7zrM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $583158df16d3522c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $gyWgF = parcelRequire("gyWgF");

var $6CY0Z = parcelRequire("6CY0Z");

var $hzXAi = parcelRequire("hzXAi");
function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    /** @type {import('./defs').ProjectionDefinition} */ var self = {};
    var paramObj = defData.split('+').map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        /** @type {Array<?>} */ var split = a.split('=');
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v) * (0, $gyVUi.D2R);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(',').map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $hzXAi.default)((0, $6CY0Z.default), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $hzXAi.default)((0, $gyWgF.default), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === '@null') self.datumCode = 'none';
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = 'ewnsud';
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        },
        over: function() {
            self.over = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === 'function') paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === 'string' && self.datumCode !== 'WGS84') self.datumCode = self.datumCode.toLowerCase();
    self['projStr'] = defData;
    return self;
}

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $c0ecbd71ed29ee86$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $c0ecbd71ed29ee86$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $c0ecbd71ed29ee86$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $c0ecbd71ed29ee86$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$83d26ae02793dd10 = 3;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});

parcelRegister("gyWgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ed0517e336f22b$export$2e2bcd8739ae039);
var $c0ed0517e336f22b$var$primeMeridian = {};
$c0ed0517e336f22b$var$primeMeridian.greenwich = 0.0; // "0dE",
$c0ed0517e336f22b$var$primeMeridian.lisbon = -9.131906111111; // "9d07'54.862\"W",
$c0ed0517e336f22b$var$primeMeridian.paris = 2.337229166667; // "2d20'14.025\"E",
$c0ed0517e336f22b$var$primeMeridian.bogota = -74.080916666667; // "74d04'51.3\"W",
$c0ed0517e336f22b$var$primeMeridian.madrid = -3.687938888889; // "3d41'16.58\"W",
$c0ed0517e336f22b$var$primeMeridian.rome = 12.452333333333; // "12d27'8.4\"E",
$c0ed0517e336f22b$var$primeMeridian.bern = 7.439583333333; // "7d26'22.5\"E",
$c0ed0517e336f22b$var$primeMeridian.jakarta = 106.807719444444; // "106d48'27.79\"E",
$c0ed0517e336f22b$var$primeMeridian.ferro = -17.666666666667; // "17d40'W",
$c0ed0517e336f22b$var$primeMeridian.brussels = 4.367975; // "4d22'4.71\"E",
$c0ed0517e336f22b$var$primeMeridian.stockholm = 18.058277777778; // "18d3'29.8\"E",
$c0ed0517e336f22b$var$primeMeridian.athens = 23.7163375; // "23d42'58.815\"E",
$c0ed0517e336f22b$var$primeMeridian.oslo = 10.722916666667; // "10d43'22.5\"E"
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = $c0ed0517e336f22b$var$primeMeridian;

});

parcelRegister("6CY0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d34d8675ead8d22$export$2e2bcd8739ae039);
var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    mm: {
        to_meter: 0.001
    },
    cm: {
        to_meter: 0.01
    },
    ft: {
        to_meter: 0.3048
    },
    'us-ft': {
        to_meter: 1200 / 3937
    },
    fath: {
        to_meter: 1.8288
    },
    kmi: {
        to_meter: 1852
    },
    'us-ch': {
        to_meter: 20.1168402336805
    },
    'us-mi': {
        to_meter: 1609.34721869444
    },
    km: {
        to_meter: 1000
    },
    'ind-ft': {
        to_meter: 0.30479841
    },
    'ind-yd': {
        to_meter: 0.91439523
    },
    mi: {
        to_meter: 1609.344
    },
    yd: {
        to_meter: 0.9144
    },
    ch: {
        to_meter: 20.1168
    },
    link: {
        to_meter: 0.201168
    },
    dm: {
        to_meter: 0.1
    },
    in: {
        to_meter: 0.0254
    },
    'ind-ch': {
        to_meter: 20.11669506
    },
    'us-in': {
        to_meter: 0.025400050800101
    },
    'us-yd': {
        to_meter: 0.914401828803658
    }
};

});

parcelRegister("hzXAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc3ecc4732a4173$export$2e2bcd8739ae039);
var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
        if (processedKey === lkey) return obj[testkey];
    }
}

});


parcelRegister("7UVTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3aabf591259c07$export$2e2bcd8739ae039);

var $5uKqK = parcelRequire("5uKqK");

var $ad1Gh = parcelRequire("ad1Gh");

var $6Pz8X = parcelRequire("6Pz8X");

var $7SVqc = parcelRequire("7SVqc");

var $hwbbo = parcelRequire("hwbbo");

var $am47V = parcelRequire("am47V");
var $5c3aabf591259c07$var$knownTypes = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if ($5c3aabf591259c07$var$knownTypes.indexOf(key) !== -1) $5c3aabf591259c07$var$setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === 'object') $5c3aabf591259c07$var$cleanWKT(wkt[key]);
    }
}
function $5c3aabf591259c07$var$setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ':' + wkt.AUTHORITY[authority];
    }
    if (wkt.type === 'GEOGCS') wkt.projName = 'longlat';
    else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === 'object') wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = '';
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf('north') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north') axisOrder += 'n';
            else if (axis[0].indexOf('south') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south') axisOrder += 's';
            else if (axis[0].indexOf('east') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east') axisOrder += 'e';
            else if (axis[0].indexOf('west') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west') axisOrder += 'w';
        }
        if (axisOrder.length === 2) axisOrder += 'u';
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') wkt.units = 'meter';
        if (wkt.UNIT.convert) {
            if (wkt.type === 'GEOGCS') {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === 'd_') wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === 'new_zealand_1949') wkt.datumCode = 'nzgd49';
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
            if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') wkt.sphere = true;
            wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') wkt.datumCode = 'rnb72';
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
            if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') wkt.ellps = 'intl';
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf('osgb_1936')) wkt.datumCode = 'osgb36';
        if (~wkt.datumCode.indexOf('osni_1952')) wkt.datumCode = 'osni52';
        if (~wkt.datumCode.indexOf('tm65') || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) wkt.datumCode = 'ire65';
        if (wkt.datumCode === 'ch1903+') wkt.datumCode = 'ch1903';
        if (~wkt.datumCode.indexOf('israel')) wkt.datumCode = 'isr93';
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    if (wkt.rectified_grid_angle) wkt.rectified_grid_angle = (0, $am47V.d2r)(wkt.rectified_grid_angle);
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            'standard_parallel_1',
            'Standard_Parallel_1'
        ],
        [
            'standard_parallel_1',
            'Latitude of 1st standard parallel'
        ],
        [
            'standard_parallel_2',
            'Standard_Parallel_2'
        ],
        [
            'standard_parallel_2',
            'Latitude of 2nd standard parallel'
        ],
        [
            'false_easting',
            'False_Easting'
        ],
        [
            'false_easting',
            'False easting'
        ],
        [
            'false-easting',
            'Easting at false origin'
        ],
        [
            'false_northing',
            'False_Northing'
        ],
        [
            'false_northing',
            'False northing'
        ],
        [
            'false_northing',
            'Northing at false origin'
        ],
        [
            'central_meridian',
            'Central_Meridian'
        ],
        [
            'central_meridian',
            'Longitude of natural origin'
        ],
        [
            'central_meridian',
            'Longitude of false origin'
        ],
        [
            'latitude_of_origin',
            'Latitude_Of_Origin'
        ],
        [
            'latitude_of_origin',
            'Central_Parallel'
        ],
        [
            'latitude_of_origin',
            'Latitude of natural origin'
        ],
        [
            'latitude_of_origin',
            'Latitude of false origin'
        ],
        [
            'scale_factor',
            'Scale_Factor'
        ],
        [
            'k0',
            'scale_factor'
        ],
        [
            'latitude_of_center',
            'Latitude_Of_Center'
        ],
        [
            'latitude_of_center',
            'Latitude_of_center'
        ],
        [
            'lat0',
            'latitude_of_center',
            (0, $am47V.d2r)
        ],
        [
            'longitude_of_center',
            'Longitude_Of_Center'
        ],
        [
            'longitude_of_center',
            'Longitude_of_center'
        ],
        [
            'longc',
            'longitude_of_center',
            (0, $am47V.d2r)
        ],
        [
            'x0',
            'false_easting',
            toMeter
        ],
        [
            'y0',
            'false_northing',
            toMeter
        ],
        [
            'long0',
            'central_meridian',
            (0, $am47V.d2r)
        ],
        [
            'lat0',
            'latitude_of_origin',
            (0, $am47V.d2r)
        ],
        [
            'lat0',
            'standard_parallel_1',
            (0, $am47V.d2r)
        ],
        [
            'lat1',
            'standard_parallel_1',
            (0, $am47V.d2r)
        ],
        [
            'lat2',
            'standard_parallel_2',
            (0, $am47V.d2r)
        ],
        [
            'azimuth',
            'Azimuth'
        ],
        [
            'alpha',
            'azimuth',
            (0, $am47V.d2r)
        ],
        [
            'srsCode',
            'name'
        ]
    ];
    list.forEach(renamer);
    (0, $am47V.applyProjectionDefaults)(wkt);
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    if (typeof wkt === 'object') return (0, $hwbbo.transformPROJJSON)(wkt);
    const version = (0, $ad1Gh.detectWKTVersion)(wkt);
    var lisp = (0, $6Pz8X.default)(wkt);
    if (version === 'WKT2') {
        const projjson = (0, $5uKqK.buildPROJJSON)(lisp);
        return (0, $hwbbo.transformPROJJSON)(projjson);
    }
    var type = lisp[0];
    var obj = {};
    (0, $7SVqc.sExpr)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj[type];
}

});
parcelRegister("5uKqK", function(module, exports) {

$parcel$export(module.exports, "buildPROJJSON", () => $4003c53a8a2e570b$export$48d0005f67ba915);

var $g1F38 = parcelRequire("g1F38");

var $7HCiu = parcelRequire("7HCiu");
/**
 * Detects the WKT2 version based on the structure of the WKT.
 * @param {Array} root The root WKT array node.
 * @returns {string} The detected version ("2015" or "2019").
 */ function $4003c53a8a2e570b$var$detectWKT2Version(root) {
    // Check for WKT2-2019-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'USAGE')) return '2019'; // `USAGE` is specific to WKT2-2019
    // Check for WKT2-2015-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'CS')) return '2015'; // `CS` is valid in both, but default to 2015 unless `USAGE` is present
    if (root[0] === 'BOUNDCRS' || root[0] === 'PROJCRS' || root[0] === 'GEOGCRS') return '2015'; // These are valid in both, but default to 2015
    // Default to WKT2-2015 if no specific indicators are found
    return '2015';
}
function $4003c53a8a2e570b$export$48d0005f67ba915(root) {
    const version = $4003c53a8a2e570b$var$detectWKT2Version(root);
    const builder = version === '2019' ? (0, $7HCiu.default) : (0, $g1F38.default);
    return builder.convert(root);
}

});
parcelRegister("g1F38", function(module, exports) {

$parcel$export(module.exports, "default", () => $baac94ed6bfdac10$export$2e2bcd8739ae039);

var $fYQzQ = parcelRequire("fYQzQ");
class $baac94ed6bfdac10$var$PROJJSONBuilder2015 extends (0, $fYQzQ.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Skip `CS` and `USAGE` nodes for WKT2-2015
        if (result.coordinate_system && result.coordinate_system.subtype === 'Cartesian') delete result.coordinate_system;
        if (result.usage) delete result.usage;
        return result;
    }
}
var $baac94ed6bfdac10$export$2e2bcd8739ae039 = $baac94ed6bfdac10$var$PROJJSONBuilder2015;

});
parcelRegister("fYQzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba253e570caf793b$export$2e2bcd8739ae039);
class $ba253e570caf793b$var$PROJJSONBuilderBase {
    static getId(node) {
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        if (idNode && idNode.length >= 3) return {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        };
        return null;
    }
    static convertUnit(node, type = 'unit') {
        if (!node || node.length < 3) return {
            type: type,
            name: 'unknown',
            conversion_factor: null
        };
        const name = node[1];
        const conversionFactor = parseFloat(node[2]) || null;
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        const id = idNode ? {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        } : null;
        return {
            type: type,
            name: name,
            conversion_factor: conversionFactor,
            id: id
        };
    }
    static convertAxis(node) {
        const name = node[1] || 'Unknown';
        // Determine the direction
        let direction;
        const abbreviationMatch = name.match(/^\((.)\)$/); // Match abbreviations like "(E)" or "(N)"
        if (abbreviationMatch) {
            // Use the abbreviation to determine the direction
            const abbreviation = abbreviationMatch[1].toUpperCase();
            if (abbreviation === 'E') direction = 'east';
            else if (abbreviation === 'N') direction = 'north';
            else if (abbreviation === 'U') direction = 'up';
            else throw new Error(`Unknown axis abbreviation: ${abbreviation}`);
        } else // Use the explicit direction provided in the AXIS node
        direction = node[2] ? node[2].toLowerCase() : 'unknown';
        const orderNode = node.find((child)=>Array.isArray(child) && child[0] === 'ORDER');
        const order = orderNode ? parseInt(orderNode[1], 10) : null;
        const unitNode = node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT'));
        const unit = this.convertUnit(unitNode);
        return {
            name: name,
            direction: direction,
            unit: unit,
            order: order
        };
    }
    static extractAxes(node) {
        return node.filter((child)=>Array.isArray(child) && child[0] === 'AXIS').map((axis)=>this.convertAxis(axis)).sort((a, b)=>(a.order || 0) - (b.order || 0)); // Sort by the "order" property
    }
    static convert(node, result = {}) {
        switch(node[0]){
            case 'PROJCRS':
                result.type = 'ProjectedCRS';
                result.name = node[1];
                result.base_crs = node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS')) : null;
                result.conversion = node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION')) : null;
                const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
                if (csNode) result.coordinate_system = {
                    type: csNode[1],
                    axis: this.extractAxes(node)
                };
                const lengthUnitNode = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT');
                if (lengthUnitNode) {
                    const unit = this.convertUnit(lengthUnitNode);
                    result.coordinate_system.unit = unit; // Add unit to coordinate_system
                }
                result.id = this.getId(node);
                break;
            case 'BASEGEOGCRS':
            case 'GEOGCRS':
                result.type = 'GeographicCRS';
                result.name = node[1];
                // Handle DATUM or ENSEMBLE
                const datumOrEnsembleNode = node.find((child)=>Array.isArray(child) && (child[0] === 'DATUM' || child[0] === 'ENSEMBLE'));
                if (datumOrEnsembleNode) {
                    const datumOrEnsemble = this.convert(datumOrEnsembleNode);
                    if (datumOrEnsembleNode[0] === 'ENSEMBLE') result.datum_ensemble = datumOrEnsemble;
                    else result.datum = datumOrEnsemble;
                    const primem = node.find((child)=>Array.isArray(child) && child[0] === 'PRIMEM');
                    if (primem && primem[1] !== 'Greenwich') datumOrEnsemble.prime_meridian = {
                        name: primem[1],
                        longitude: parseFloat(primem[2])
                    };
                }
                result.coordinate_system = {
                    type: 'ellipsoidal',
                    axis: this.extractAxes(node)
                };
                result.id = this.getId(node);
                break;
            case 'DATUM':
                result.type = 'GeodeticReferenceFrame';
                result.name = node[1];
                result.ellipsoid = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID')) : null;
                break;
            case 'ENSEMBLE':
                result.type = 'DatumEnsemble';
                result.name = node[1];
                // Extract ensemble members
                result.members = node.filter((child)=>Array.isArray(child) && child[0] === 'MEMBER').map((member)=>({
                        type: 'DatumEnsembleMember',
                        name: member[1],
                        id: this.getId(member)
                    }));
                // Extract accuracy
                const accuracyNode = node.find((child)=>Array.isArray(child) && child[0] === 'ENSEMBLEACCURACY');
                if (accuracyNode) result.accuracy = parseFloat(accuracyNode[1]);
                // Extract ellipsoid
                const ellipsoidNode = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID');
                if (ellipsoidNode) result.ellipsoid = this.convert(ellipsoidNode); // Convert the ellipsoid node
                // Extract identifier for the ensemble
                result.id = this.getId(node);
                break;
            case 'ELLIPSOID':
                result.type = 'Ellipsoid';
                result.name = node[1];
                result.semi_major_axis = parseFloat(node[2]);
                result.inverse_flattening = parseFloat(node[3]);
                const units = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT'), result) : null;
                break;
            case 'CONVERSION':
                result.type = 'Conversion';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && child[0] === 'PARAMETER').map((param)=>this.convert(param));
                break;
            case 'METHOD':
                result.type = 'Method';
                result.name = node[1];
                result.id = this.getId(node);
                break;
            case 'PARAMETER':
                result.type = 'Parameter';
                result.name = node[1];
                result.value = parseFloat(node[2]);
                result.unit = this.convertUnit(node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT')));
                result.id = this.getId(node);
                break;
            case 'BOUNDCRS':
                result.type = 'BoundCRS';
                // Process SOURCECRS
                const sourceCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'SOURCECRS');
                if (sourceCrsNode) {
                    const sourceCrsContent = sourceCrsNode.find((child)=>Array.isArray(child));
                    result.source_crs = sourceCrsContent ? this.convert(sourceCrsContent) : null;
                }
                // Process TARGETCRS
                const targetCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'TARGETCRS');
                if (targetCrsNode) {
                    const targetCrsContent = targetCrsNode.find((child)=>Array.isArray(child));
                    result.target_crs = targetCrsContent ? this.convert(targetCrsContent) : null;
                }
                // Process ABRIDGEDTRANSFORMATION
                const transformationNode = node.find((child)=>Array.isArray(child) && child[0] === 'ABRIDGEDTRANSFORMATION');
                if (transformationNode) result.transformation = this.convert(transformationNode);
                else result.transformation = null;
                break;
            case 'ABRIDGEDTRANSFORMATION':
                result.type = 'Transformation';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && (child[0] === 'PARAMETER' || child[0] === 'PARAMETERFILE')).map((param)=>{
                    if (param[0] === 'PARAMETER') return this.convert(param);
                    else if (param[0] === 'PARAMETERFILE') return {
                        name: param[1],
                        value: param[2],
                        id: {
                            'authority': 'EPSG',
                            'code': 8656
                        }
                    };
                });
                // Adjust the Scale difference parameter if present
                if (result.parameters.length === 7) {
                    const scaleDifference = result.parameters[6];
                    if (scaleDifference.name === 'Scale difference') scaleDifference.value = Math.round((scaleDifference.value - 1) * 1e12) / 1e6;
                }
                result.id = this.getId(node);
                break;
            case 'AXIS':
                if (!result.coordinate_system) result.coordinate_system = {
                    type: 'unspecified',
                    axis: []
                };
                result.coordinate_system.axis.push(this.convertAxis(node));
                break;
            case 'LENGTHUNIT':
                const unit = this.convertUnit(node, 'LinearUnit');
                if (result.coordinate_system && result.coordinate_system.axis) result.coordinate_system.axis.forEach((axis)=>{
                    if (!axis.unit) axis.unit = unit;
                });
                if (unit.conversion_factor && unit.conversion_factor !== 1) {
                    if (result.semi_major_axis) result.semi_major_axis = {
                        value: result.semi_major_axis,
                        unit: unit
                    };
                }
                break;
            default:
                result.keyword = node[0];
                break;
        }
        return result;
    }
}
var $ba253e570caf793b$export$2e2bcd8739ae039 = $ba253e570caf793b$var$PROJJSONBuilderBase;

});


parcelRegister("7HCiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ba41957df98247$export$2e2bcd8739ae039);

var $fYQzQ = parcelRequire("fYQzQ");
class $59ba41957df98247$var$PROJJSONBuilder2019 extends (0, $fYQzQ.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Handle `CS` node for WKT2-2019
        const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
        if (csNode) result.coordinate_system = {
            subtype: csNode[1],
            axis: this.extractAxes(node)
        };
        // Handle `USAGE` node for WKT2-2019
        const usageNode = node.find((child)=>Array.isArray(child) && child[0] === 'USAGE');
        if (usageNode) {
            const scope = usageNode.find((child)=>Array.isArray(child) && child[0] === 'SCOPE');
            const area = usageNode.find((child)=>Array.isArray(child) && child[0] === 'AREA');
            const bbox = usageNode.find((child)=>Array.isArray(child) && child[0] === 'BBOX');
            result.usage = {};
            if (scope) result.usage.scope = scope[1];
            if (area) result.usage.area = area[1];
            if (bbox) result.usage.bbox = bbox.slice(1);
        }
        return result;
    }
}
var $59ba41957df98247$export$2e2bcd8739ae039 = $59ba41957df98247$var$PROJJSONBuilder2019;

});


parcelRegister("ad1Gh", function(module, exports) {

$parcel$export(module.exports, "detectWKTVersion", () => $76ec6c11849d6ec6$export$9362d65e4771b5d5);
/**
 * Detects whether the WKT string is WKT1 or WKT2.
 * @param {string} wkt The WKT string.
 * @returns {string} The detected version ("WKT1" or "WKT2").
 */ function $76ec6c11849d6ec6$export$9362d65e4771b5d5(wkt) {
    // Normalize the WKT string for easier keyword matching
    const normalizedWKT = wkt.toUpperCase();
    // Check for WKT2-specific keywords
    if (normalizedWKT.includes('PROJCRS') || normalizedWKT.includes('GEOGCRS') || normalizedWKT.includes('BOUNDCRS') || normalizedWKT.includes('VERTCRS') || normalizedWKT.includes('LENGTHUNIT') || normalizedWKT.includes('ANGLEUNIT') || normalizedWKT.includes('SCALEUNIT')) return 'WKT2';
    // Check for WKT1-specific keywords
    if (normalizedWKT.includes('PROJCS') || normalizedWKT.includes('GEOGCS') || normalizedWKT.includes('LOCAL_CS') || normalizedWKT.includes('VERT_CS') || normalizedWKT.includes('UNIT')) return 'WKT1';
    // Default to WKT1 if no specific indicators are found
    return 'WKT1';
}

});

parcelRegister("6Pz8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f92c43f9960a1f4$export$2e2bcd8739ae039);
var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84_]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== 'string') throw new Error('not a string');
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ',') {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === ']') {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = '';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}

});

parcelRegister("7SVqc", function(module, exports) {

$parcel$export(module.exports, "sExpr", () => $5bda1e467f1c2649$export$337bc7a3aef1f775);
function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === 'TOWGS84') {
        obj[key] = v;
        return;
    }
    if (key === 'AXIS') {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case 'SPHEROID':
        case 'ELLIPSOID':
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}

});

parcelRegister("hwbbo", function(module, exports) {

$parcel$export(module.exports, "transformPROJJSON", () => $cc0e197ab4726924$export$b04e619e90585ec3);

var $am47V = parcelRequire("am47V");
// Helper function to process units and to_meter
function $cc0e197ab4726924$var$processUnit(unit) {
    let result = {
        units: null,
        to_meter: undefined
    };
    if (typeof unit === 'string') {
        result.units = unit.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        if (result.units === 'meter') result.to_meter = 1; // Only set to_meter if units are 'meter'
    } else if (unit && unit.name) {
        result.units = unit.name.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        result.to_meter = unit.conversion_factor;
    }
    return result;
}
function $cc0e197ab4726924$var$toValue(valueOrObject) {
    if (typeof valueOrObject === 'object') return valueOrObject.value * valueOrObject.unit.conversion_factor;
    return valueOrObject;
}
function $cc0e197ab4726924$var$calculateEllipsoid(value, result) {
    if (value.ellipsoid.radius) {
        result.a = value.ellipsoid.radius;
        result.rf = 0;
    } else {
        result.a = $cc0e197ab4726924$var$toValue(value.ellipsoid.semi_major_axis);
        if (value.ellipsoid.inverse_flattening !== undefined) result.rf = value.ellipsoid.inverse_flattening;
        else if (value.ellipsoid.semi_major_axis !== undefined && value.ellipsoid.semi_minor_axis !== undefined) result.rf = result.a / (result.a - $cc0e197ab4726924$var$toValue(value.ellipsoid.semi_minor_axis));
    }
}
function $cc0e197ab4726924$export$b04e619e90585ec3(projjson, result = {}) {
    if (!projjson || typeof projjson !== 'object') return projjson; // Return primitive values as-is
    if (projjson.type === 'BoundCRS') {
        $cc0e197ab4726924$export$b04e619e90585ec3(projjson.source_crs, result);
        if (projjson.transformation) {
            if (projjson.transformation.method && projjson.transformation.method.name === 'NTv2') // Set nadgrids to the filename from the parameterfile
            result.nadgrids = projjson.transformation.parameters[0].value;
            else // Populate datum_params if no parameterfile is found
            result.datum_params = projjson.transformation.parameters.map((param)=>param.value);
        }
        return result; // Return early for BoundCRS
    }
    // Handle specific keys in PROJJSON
    Object.keys(projjson).forEach((key)=>{
        const value = projjson[key];
        if (value === null) return;
        switch(key){
            case 'name':
                if (result.srsCode) break;
                result.name = value;
                result.srsCode = value; // Map `name` to `srsCode`
                break;
            case 'type':
                if (value === 'GeographicCRS') result.projName = 'longlat';
                else if (value === 'ProjectedCRS' && projjson.conversion && projjson.conversion.method) result.projName = projjson.conversion.method.name; // Retain original capitalization
                break;
            case 'datum':
            case 'datum_ensemble':
                if (value.ellipsoid) {
                    // Extract ellipsoid properties
                    result.ellps = value.ellipsoid.name;
                    $cc0e197ab4726924$var$calculateEllipsoid(value, result);
                }
                if (value.prime_meridian) result.from_greenwich = value.prime_meridian.longitude * Math.PI / 180; // Convert to radians
                break;
            case 'ellipsoid':
                result.ellps = value.name;
                $cc0e197ab4726924$var$calculateEllipsoid(value, result);
                break;
            case 'prime_meridian':
                result.long0 = (value.longitude || 0) * Math.PI / 180; // Convert to radians
                break;
            case 'coordinate_system':
                if (value.axis) {
                    result.axis = value.axis.map((axis)=>{
                        const direction = axis.direction;
                        if (direction === 'east') return 'e';
                        if (direction === 'north') return 'n';
                        if (direction === 'west') return 'w';
                        if (direction === 'south') return 's';
                        throw new Error(`Unknown axis direction: ${direction}`);
                    }).join('') + 'u'; // Combine into a single string (e.g., "enu")
                    if (value.unit) {
                        const { units: units, to_meter: to_meter } = $cc0e197ab4726924$var$processUnit(value.unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    } else if (value.axis[0] && value.axis[0].unit) {
                        const { units: units, to_meter: to_meter } = $cc0e197ab4726924$var$processUnit(value.axis[0].unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    }
                }
                break;
            case 'id':
                if (value.authority && value.code) result.title = value.authority + ':' + value.code;
                break;
            case 'conversion':
                if (value.method && value.method.name) result.projName = value.method.name; // Retain original capitalization
                if (value.parameters) value.parameters.forEach((param)=>{
                    const paramName = param.name.toLowerCase().replace(/\s+/g, '_');
                    const paramValue = param.value;
                    if (param.unit && param.unit.conversion_factor) result[paramName] = paramValue * param.unit.conversion_factor; // Convert to radians or meters
                    else if (param.unit === 'degree') result[paramName] = paramValue * Math.PI / 180; // Convert to radians
                    else result[paramName] = paramValue;
                });
                break;
            case 'unit':
                if (value.name) {
                    result.units = value.name.toLowerCase();
                    if (result.units === 'metre') result.units = 'meter';
                }
                if (value.conversion_factor) result.to_meter = value.conversion_factor;
                break;
            case 'base_crs':
                $cc0e197ab4726924$export$b04e619e90585ec3(value, result); // Pass `result` directly
                result.datumCode = value.id ? value.id.authority + '_' + value.id.code : value.name; // Set datumCode
                break;
            default:
                break;
        }
    });
    // Additional calculated properties
    if (result.latitude_of_false_origin !== undefined) result.lat0 = result.latitude_of_false_origin; // Already in radians
    if (result.longitude_of_false_origin !== undefined) result.long0 = result.longitude_of_false_origin;
    if (result.latitude_of_standard_parallel !== undefined) {
        result.lat0 = result.latitude_of_standard_parallel;
        result.lat1 = result.latitude_of_standard_parallel;
    }
    if (result.latitude_of_1st_standard_parallel !== undefined) result.lat1 = result.latitude_of_1st_standard_parallel;
    if (result.latitude_of_2nd_standard_parallel !== undefined) result.lat2 = result.latitude_of_2nd_standard_parallel;
    if (result.latitude_of_projection_centre !== undefined) result.lat0 = result.latitude_of_projection_centre;
    if (result.longitude_of_projection_centre !== undefined) result.longc = result.longitude_of_projection_centre;
    if (result.easting_at_false_origin !== undefined) result.x0 = result.easting_at_false_origin;
    if (result.northing_at_false_origin !== undefined) result.y0 = result.northing_at_false_origin;
    if (result.latitude_of_natural_origin !== undefined) result.lat0 = result.latitude_of_natural_origin;
    if (result.longitude_of_natural_origin !== undefined) result.long0 = result.longitude_of_natural_origin;
    if (result.longitude_of_origin !== undefined) result.long0 = result.longitude_of_origin;
    if (result.false_easting !== undefined) result.x0 = result.false_easting;
    if (result.easting_at_projection_centre) result.x0 = result.easting_at_projection_centre;
    if (result.false_northing !== undefined) result.y0 = result.false_northing;
    if (result.northing_at_projection_centre) result.y0 = result.northing_at_projection_centre;
    if (result.standard_parallel_1 !== undefined) result.lat1 = result.standard_parallel_1;
    if (result.standard_parallel_2 !== undefined) result.lat2 = result.standard_parallel_2;
    if (result.scale_factor_at_natural_origin !== undefined) result.k0 = result.scale_factor_at_natural_origin;
    if (result.scale_factor_at_projection_centre !== undefined) result.k0 = result.scale_factor_at_projection_centre;
    if (result.scale_factor_on_pseudo_standard_parallel !== undefined) result.k0 = result.scale_factor_on_pseudo_standard_parallel;
    if (result.azimuth !== undefined) result.alpha = result.azimuth;
    if (result.azimuth_at_projection_centre !== undefined) result.alpha = result.azimuth_at_projection_centre;
    if (result.angle_from_rectified_to_skew_grid) result.rectified_grid_angle = result.angle_from_rectified_to_skew_grid;
    // Apply projection defaults
    (0, $am47V.applyProjectionDefaults)(result);
    return result;
}

});
parcelRegister("am47V", function(module, exports) {

$parcel$export(module.exports, "d2r", () => $789f28efd4cd941a$export$e726aea149b4fd71);
$parcel$export(module.exports, "applyProjectionDefaults", () => $789f28efd4cd941a$export$d6def86a6ec68808);
var $789f28efd4cd941a$var$D2R = 0.01745329251994329577;
function $789f28efd4cd941a$export$e726aea149b4fd71(input) {
    return input * $789f28efd4cd941a$var$D2R;
}
function $789f28efd4cd941a$export$d6def86a6ec68808(wkt) {
    // Normalize projName for WKT2 compatibility
    const normalizedProjName = (wkt.projName || '').toLowerCase().replace(/_/g, ' ');
    if (!wkt.long0 && wkt.longc && (normalizedProjName === 'albers conic equal area' || normalizedProjName === 'lambert azimuthal equal area')) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (normalizedProjName === 'stereographic south pole' || normalizedProjName === 'polar stereographic (variant b)')) {
        wkt.lat0 = $789f28efd4cd941a$export$e726aea149b4fd71(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
        delete wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && (normalizedProjName === 'polar stereographic' || normalizedProjName === 'polar stereographic (variant a)')) {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $789f28efd4cd941a$export$e726aea149b4fd71(wkt.lat0 > 0 ? 90 : -90);
        delete wkt.lat1;
    }
}

});





parcelRegister("cWauz", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b30a4c80088893$export$2e2bcd8739ae039);
function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}

});

parcelRegister("1Wo5P", function(module, exports) {

$parcel$export(module.exports, "getNormalizedProjName", () => $169de593aeaa174c$export$9ee0bb5510679155);
$parcel$export(module.exports, "default", () => $169de593aeaa174c$export$2e2bcd8739ae039);

var $ioIYn = parcelRequire("ioIYn");

var $iMMJV = parcelRequire("iMMJV");
/** @type {Array<Partial<import('./Proj').default>>} */ var $169de593aeaa174c$var$projs = [
    (0, $ioIYn.default),
    (0, $iMMJV.default)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$9ee0bb5510679155(n) {
    return n.replace(/[-\(\)\s]+/g, ' ').trim().replace(/ /g, '_');
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== 'undefined' && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
    n = $169de593aeaa174c$export$9ee0bb5510679155(n);
    if (n in $169de593aeaa174c$var$names && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};

});
parcelRegister("ioIYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64d5a882433f366$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!('x0' in this)) this.x0 = 0;
    if (!('y0' in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0, this.over);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0, this.over);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    'Mercator',
    'Popular Visualisation Pseudo Mercator',
    'Mercator_1SP',
    'Mercator_Auxiliary_Sphere',
    'Mercator_Variant_A',
    'merc'
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};

});
parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x, skipAdjust) {
    if (skipAdjust) return x;
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});
parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});


parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("phi2z has NoConvergence");
    return -9999;
}

});


parcelRegister("iMMJV", function(module, exports) {

$parcel$export(module.exports, "names", () => $dad2845bfa7291b9$export$e4b2ac9215619f8d);
$parcel$export(module.exports, "default", () => $dad2845bfa7291b9$export$2e2bcd8739ae039);
function $dad2845bfa7291b9$export$2cd8252107eb640b() {
// no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    'longlat',
    'identity'
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};

});


parcelRegister("d8b9d", function(module, exports) {

$parcel$export(module.exports, "eccentricity", () => $98f4ab684186b766$export$e3d7bf2ed2a7479f);
$parcel$export(module.exports, "sphere", () => $98f4ab684186b766$export$b2690196de52b050);

var $gyVUi = parcelRequire("gyVUi");

var $bO5FE = parcelRequire("bO5FE");

var $hzXAi = parcelRequire("hzXAi");
const $98f4ab684186b766$var$WGS84 = (0, $bO5FE.default).WGS84; // default ellipsoid
function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $hzXAi.default)((0, $bO5FE.default), ellps);
        if (!ellipse) ellipse = $98f4ab684186b766$var$WGS84;
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}

});
parcelRegister("bO5FE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8988c354f092c217$export$2e2bcd8739ae039);
var $8988c354f092c217$var$ellipsoids = {
    MERIT: {
        a: 6378137,
        rf: 298.257,
        ellipseName: 'MERIT 1983'
    },
    SGS85: {
        a: 6378136,
        rf: 298.257,
        ellipseName: 'Soviet Geodetic System 85'
    },
    GRS80: {
        a: 6378137,
        rf: 298.257222101,
        ellipseName: 'GRS 1980(IUGG, 1980)'
    },
    IAU76: {
        a: 6378140,
        rf: 298.257,
        ellipseName: 'IAU 1976'
    },
    airy: {
        a: 6377563.396,
        b: 6356256.91,
        ellipseName: 'Airy 1830'
    },
    APL4: {
        a: 6378137,
        rf: 298.25,
        ellipseName: 'Appl. Physics. 1965'
    },
    NWL9D: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'Naval Weapons Lab., 1965'
    },
    mod_airy: {
        a: 6377340.189,
        b: 6356034.446,
        ellipseName: 'Modified Airy'
    },
    andrae: {
        a: 6377104.43,
        rf: 300,
        ellipseName: 'Andrae 1876 (Den., Iclnd.)'
    },
    aust_SA: {
        a: 6378160,
        rf: 298.25,
        ellipseName: 'Australian Natl & S. Amer. 1969'
    },
    GRS67: {
        a: 6378160,
        rf: 298.247167427,
        ellipseName: 'GRS 67(IUGG 1967)'
    },
    bessel: {
        a: 6377397.155,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841'
    },
    bess_nam: {
        a: 6377483.865,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841 (Namibia)'
    },
    clrk66: {
        a: 6378206.4,
        b: 6356583.8,
        ellipseName: 'Clarke 1866'
    },
    clrk80: {
        a: 6378249.145,
        rf: 293.4663,
        ellipseName: 'Clarke 1880 mod.'
    },
    clrk80ign: {
        a: 6378249.2,
        b: 6356515,
        rf: 293.4660213,
        ellipseName: 'Clarke 1880 (IGN)'
    },
    clrk58: {
        a: 6378293.645208759,
        rf: 294.2606763692654,
        ellipseName: 'Clarke 1858'
    },
    CPM: {
        a: 6375738.7,
        rf: 334.29,
        ellipseName: 'Comm. des Poids et Mesures 1799'
    },
    delmbr: {
        a: 6376428,
        rf: 311.5,
        ellipseName: 'Delambre 1810 (Belgium)'
    },
    engelis: {
        a: 6378136.05,
        rf: 298.2566,
        ellipseName: 'Engelis 1985'
    },
    evrst30: {
        a: 6377276.345,
        rf: 300.8017,
        ellipseName: 'Everest 1830'
    },
    evrst48: {
        a: 6377304.063,
        rf: 300.8017,
        ellipseName: 'Everest 1948'
    },
    evrst56: {
        a: 6377301.243,
        rf: 300.8017,
        ellipseName: 'Everest 1956'
    },
    evrst69: {
        a: 6377295.664,
        rf: 300.8017,
        ellipseName: 'Everest 1969'
    },
    evrstSS: {
        a: 6377298.556,
        rf: 300.8017,
        ellipseName: 'Everest (Sabah & Sarawak)'
    },
    fschr60: {
        a: 6378166,
        rf: 298.3,
        ellipseName: 'Fischer (Mercury Datum) 1960'
    },
    fschr60m: {
        a: 6378155,
        rf: 298.3,
        ellipseName: 'Fischer 1960'
    },
    fschr68: {
        a: 6378150,
        rf: 298.3,
        ellipseName: 'Fischer 1968'
    },
    helmert: {
        a: 6378200,
        rf: 298.3,
        ellipseName: 'Helmert 1906'
    },
    hough: {
        a: 6378270,
        rf: 297,
        ellipseName: 'Hough'
    },
    intl: {
        a: 6378388,
        rf: 297,
        ellipseName: 'International 1909 (Hayford)'
    },
    kaula: {
        a: 6378163,
        rf: 298.24,
        ellipseName: 'Kaula 1961'
    },
    lerch: {
        a: 6378139,
        rf: 298.257,
        ellipseName: 'Lerch 1979'
    },
    mprts: {
        a: 6397300,
        rf: 191,
        ellipseName: 'Maupertius 1738'
    },
    new_intl: {
        a: 6378157.5,
        b: 6356772.2,
        ellipseName: 'New International 1967'
    },
    plessis: {
        a: 6376523,
        rf: 6355863,
        ellipseName: 'Plessis 1817 (France)'
    },
    krass: {
        a: 6378245,
        rf: 298.3,
        ellipseName: 'Krassovsky, 1942'
    },
    SEasia: {
        a: 6378155,
        b: 6356773.3205,
        ellipseName: 'Southeast Asia'
    },
    walbeck: {
        a: 6376896,
        b: 6355834.8467,
        ellipseName: 'Walbeck'
    },
    WGS60: {
        a: 6378165,
        rf: 298.3,
        ellipseName: 'WGS 60'
    },
    WGS66: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'WGS 66'
    },
    WGS7: {
        a: 6378135,
        rf: 298.26,
        ellipseName: 'WGS 72'
    },
    WGS84: {
        a: 6378137,
        rf: 298.257223563,
        ellipseName: 'WGS 84'
    },
    sphere: {
        a: 6370997,
        b: 6370997,
        ellipseName: 'Normal Sphere (r=6370997)'
    }
};
var $8988c354f092c217$export$2e2bcd8739ae039 = $8988c354f092c217$var$ellipsoids;

});


parcelRegister("gMdFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36bbc8057de3d00$export$2e2bcd8739ae039);
var $c36bbc8057de3d00$var$datums = {
    wgs84: {
        towgs84: '0,0,0',
        ellipse: 'WGS84',
        datumName: 'WGS84'
    },
    ch1903: {
        towgs84: '674.374,15.056,405.346',
        ellipse: 'bessel',
        datumName: 'swiss'
    },
    ggrs87: {
        towgs84: '-199.87,74.79,246.62',
        ellipse: 'GRS80',
        datumName: 'Greek_Geodetic_Reference_System_1987'
    },
    nad83: {
        towgs84: '0,0,0',
        ellipse: 'GRS80',
        datumName: 'North_American_Datum_1983'
    },
    nad27: {
        nadgrids: '@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat',
        ellipse: 'clrk66',
        datumName: 'North_American_Datum_1927'
    },
    potsdam: {
        towgs84: '598.1,73.7,418.2,0.202,0.045,-2.455,6.7',
        ellipse: 'bessel',
        datumName: 'Potsdam Rauenberg 1950 DHDN'
    },
    carthage: {
        towgs84: '-263.0,6.0,431.0',
        ellipse: 'clark80',
        datumName: 'Carthage 1934 Tunisia'
    },
    hermannskogel: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Hermannskogel'
    },
    mgi: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Militar-Geographische Institut'
    },
    osni52: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'airy',
        datumName: 'Irish National'
    },
    ire65: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'mod_airy',
        datumName: 'Ireland 1965'
    },
    rassadiran: {
        towgs84: '-133.63,-157.5,-158.62',
        ellipse: 'intl',
        datumName: 'Rassadiran'
    },
    nzgd49: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993',
        ellipse: 'intl',
        datumName: 'New Zealand Geodetic Datum 1949'
    },
    osgb36: {
        towgs84: '446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894',
        ellipse: 'airy',
        datumName: 'Ordnance Survey of Great Britain 1936'
    },
    s_jtsk: {
        towgs84: '589,76,480',
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
    },
    beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
    },
    gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
    },
    rnb72: {
        towgs84: '106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1',
        ellipse: 'intl',
        datumName: 'Reseau National Belge 1972'
    },
    EPSG_5451: {
        towgs84: '6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649'
    },
    IGNF_LURESG: {
        towgs84: '-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43'
    },
    EPSG_4614: {
        towgs84: '-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065'
    },
    EPSG_4615: {
        towgs84: '-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748'
    },
    ESRI_37241: {
        towgs84: '-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031'
    },
    ESRI_37249: {
        towgs84: '-440.296,58.548,296.265,1.128,10.202,4.559,-0.438'
    },
    ESRI_37245: {
        towgs84: '-511.151,-181.269,139.609,1.05,2.703,1.798,3.071'
    },
    EPSG_4178: {
        towgs84: '24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01'
    },
    EPSG_4622: {
        towgs84: '-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984'
    },
    EPSG_4625: {
        towgs84: '126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227'
    },
    EPSG_5252: {
        towgs84: '0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439'
    },
    EPSG_4314: {
        towgs84: '597.1,71.4,412.1,0.894,0.068,-1.563,7.58'
    },
    EPSG_4282: {
        towgs84: '-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166'
    },
    EPSG_4231: {
        towgs84: '-83.11,-97.38,-117.22,0.0276,-0.2167,0.2147,0.1218'
    },
    EPSG_4274: {
        towgs84: '-230.994,102.591,25.199,0.633,-0.239,0.9,1.95'
    },
    EPSG_4134: {
        towgs84: '-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006'
    },
    EPSG_4254: {
        towgs84: '18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013'
    },
    EPSG_4159: {
        towgs84: '-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175'
    },
    EPSG_4687: {
        towgs84: '0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_4227: {
        towgs84: '-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225'
    },
    EPSG_4746: {
        towgs84: '599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46'
    },
    EPSG_4745: {
        towgs84: '612.4,77,440.2,-0.054,0.057,-2.797,2.55'
    },
    EPSG_6311: {
        towgs84: '8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926'
    },
    EPSG_4289: {
        towgs84: '565.7381,50.4018,465.2904,-1.91514,1.60363,-9.09546,4.07244'
    },
    EPSG_4230: {
        towgs84: '-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4'
    },
    EPSG_4154: {
        towgs84: '-123.02,-158.95,-168.47'
    },
    EPSG_4156: {
        towgs84: '570.8,85.7,462.8,4.998,1.587,5.261,3.56'
    },
    EPSG_4299: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4179: {
        towgs84: '33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84'
    },
    EPSG_4313: {
        towgs84: '-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747'
    },
    EPSG_4194: {
        towgs84: '163.511,127.533,-159.789'
    },
    EPSG_4195: {
        towgs84: '105,326,-102.5'
    },
    EPSG_4196: {
        towgs84: '-45,417,-3.5'
    },
    EPSG_4611: {
        towgs84: '-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246'
    },
    EPSG_4633: {
        towgs84: '137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824'
    },
    EPSG_4641: {
        towgs84: '-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993'
    },
    EPSG_4643: {
        towgs84: '-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002'
    },
    EPSG_4300: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4188: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4660: {
        towgs84: '982.6087,552.753,-540.873,32.39344,-153.25684,-96.2266,16.805'
    },
    EPSG_4662: {
        towgs84: '97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259'
    },
    EPSG_3906: {
        towgs84: '577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664'
    },
    EPSG_4307: {
        towgs84: '-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547'
    },
    EPSG_6892: {
        towgs84: '-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686'
    },
    EPSG_4690: {
        towgs84: '221.597,152.441,176.523,2.403,1.3893,0.884,11.4648'
    },
    EPSG_4691: {
        towgs84: '218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817'
    },
    EPSG_4629: {
        towgs84: '72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653'
    },
    EPSG_4630: {
        towgs84: '165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111'
    },
    EPSG_4692: {
        towgs84: '217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_9333: {
        towgs84: '0,0,0,-8.393,0.749,-10.276,0'
    },
    EPSG_9059: {
        towgs84: '0,0,0'
    },
    EPSG_4312: {
        towgs84: '601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887'
    },
    EPSG_4123: {
        towgs84: '-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496'
    },
    EPSG_4309: {
        towgs84: '-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365'
    },
    ESRI_104106: {
        towgs84: '-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058'
    },
    EPSG_4281: {
        towgs84: '-219.247,-73.802,269.529'
    },
    EPSG_4322: {
        towgs84: '0,0,4.5'
    },
    EPSG_4324: {
        towgs84: '0,0,1.9'
    },
    EPSG_4284: {
        towgs84: '43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549'
    },
    EPSG_4277: {
        towgs84: '446.448,-125.157,542.06,0.15,0.247,0.842,-20.489'
    },
    EPSG_4207: {
        towgs84: '-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46'
    },
    EPSG_4688: {
        towgs84: '347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647'
    },
    EPSG_4689: {
        towgs84: '410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218'
    },
    EPSG_4720: {
        towgs84: '0,0,4.5'
    },
    EPSG_4273: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    EPSG_4240: {
        towgs84: '204.64,834.74,293.8'
    },
    EPSG_4817: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    ESRI_104131: {
        towgs84: '426.62,142.62,460.09,4.98,4.49,-12.42,-17.1'
    },
    EPSG_4265: {
        towgs84: '-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68'
    },
    EPSG_4263: {
        towgs84: '-111.92,-87.85,114.5,1.875,0.202,0.219,0.032'
    },
    EPSG_4298: {
        towgs84: '-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536'
    },
    EPSG_4270: {
        towgs84: '-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424'
    },
    EPSG_4229: {
        towgs84: '-121.8,98.1,-10.7'
    },
    EPSG_4220: {
        towgs84: '-55.5,-348,-229.2'
    },
    EPSG_4214: {
        towgs84: '12.646,-155.176,-80.863'
    },
    EPSG_4232: {
        towgs84: '-345,3,223'
    },
    EPSG_4238: {
        towgs84: '-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037'
    },
    EPSG_4168: {
        towgs84: '-170,33,326'
    },
    EPSG_4131: {
        towgs84: '199,931,318.9'
    },
    EPSG_4152: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_5228: {
        towgs84: '572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378'
    },
    EPSG_8351: {
        towgs84: '485.021,169.465,483.839,7.786342,4.397554,4.102655,0'
    },
    EPSG_4683: {
        towgs84: '-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06'
    },
    EPSG_4133: {
        towgs84: '0,0,0'
    },
    EPSG_7373: {
        towgs84: '0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693'
    },
    EPSG_9075: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9072: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9294: {
        towgs84: '1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388'
    },
    EPSG_4212: {
        towgs84: '-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492'
    },
    EPSG_4191: {
        towgs84: '-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703'
    },
    EPSG_4237: {
        towgs84: '52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191'
    },
    EPSG_4740: {
        towgs84: '-1.08,-0.27,-0.9'
    },
    EPSG_4124: {
        towgs84: '419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496'
    },
    EPSG_5681: {
        towgs84: '584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922'
    },
    EPSG_4141: {
        towgs84: '23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262'
    },
    EPSG_4204: {
        towgs84: '-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194'
    },
    EPSG_4319: {
        towgs84: '226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798'
    },
    EPSG_4200: {
        towgs84: '24.82,-131.21,-82.66'
    },
    EPSG_4130: {
        towgs84: '0,0,0'
    },
    EPSG_4127: {
        towgs84: '-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359'
    },
    EPSG_4149: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4617: {
        towgs84: '-0.991,1.9072,0.5129,1.25033e-7,4.6785e-8,5.6529e-8,0'
    },
    EPSG_4663: {
        towgs84: '-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485'
    },
    EPSG_4664: {
        towgs84: '-211.939,137.626,58.3,-0.089,0.251,0.079,0.384'
    },
    EPSG_4665: {
        towgs84: '-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048'
    },
    EPSG_4666: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    EPSG_4756: {
        towgs84: '-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188'
    },
    EPSG_4723: {
        towgs84: '-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925'
    },
    EPSG_4726: {
        towgs84: '8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081'
    },
    EPSG_4267: {
        towgs84: '-8.0,160.0,176.0'
    },
    EPSG_5365: {
        towgs84: '-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693'
    },
    EPSG_4218: {
        towgs84: '304.5,306.5,-318.1'
    },
    EPSG_4242: {
        towgs84: '-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95'
    },
    EPSG_4216: {
        towgs84: '-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289'
    },
    ESRI_104105: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    ESRI_104129: {
        towgs84: '0,0,0'
    },
    EPSG_4673: {
        towgs84: '174.05,-25.49,112.57'
    },
    EPSG_4202: {
        towgs84: '-124,-60,154'
    },
    EPSG_4203: {
        towgs84: '-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191'
    },
    EPSG_3819: {
        towgs84: '595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408'
    },
    EPSG_8694: {
        towgs84: '-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169'
    },
    EPSG_4145: {
        towgs84: '275.57,676.78,229.6'
    },
    EPSG_4283: {
        towgs84: '61.55,-10.87,-40.19,39.4924,32.7221,32.8979,-9.994'
    },
    EPSG_4317: {
        towgs84: '2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266'
    },
    EPSG_4272: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993'
    },
    EPSG_4248: {
        towgs84: '-307.7,265.3,-363.5'
    },
    EPSG_5561: {
        towgs84: '24,-121,-76'
    },
    EPSG_5233: {
        towgs84: '-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338'
    },
    ESRI_104130: {
        towgs84: '-86,-98,-119'
    },
    ESRI_104102: {
        towgs84: '682,-203,480'
    },
    ESRI_37207: {
        towgs84: '7,-10,-26'
    },
    EPSG_4675: {
        towgs84: '59.935,118.4,-10.871'
    },
    ESRI_104109: {
        towgs84: '-89.121,-348.182,260.871'
    },
    ESRI_104112: {
        towgs84: '-185.583,-230.096,281.361'
    },
    ESRI_104113: {
        towgs84: '25.1,-275.6,222.6'
    },
    IGNF_WGS72G: {
        towgs84: '0,12,6'
    },
    IGNF_NTFG: {
        towgs84: '-168,-60,320'
    },
    IGNF_EFATE57G: {
        towgs84: '-127,-769,472'
    },
    IGNF_PGP50G: {
        towgs84: '324.8,153.6,172.1'
    },
    IGNF_REUN47G: {
        towgs84: '94,-948,-1262'
    },
    IGNF_CSG67G: {
        towgs84: '-186,230,110'
    },
    IGNF_GUAD48G: {
        towgs84: '-467,-16,-300'
    },
    IGNF_TAHI51G: {
        towgs84: '162,117,154'
    },
    IGNF_TAHAAG: {
        towgs84: '65,342,77'
    },
    IGNF_NUKU72G: {
        towgs84: '84,274,65'
    },
    IGNF_PETRELS72G: {
        towgs84: '365,194,166'
    },
    IGNF_WALL78G: {
        towgs84: '253,-133,-127'
    },
    IGNF_MAYO50G: {
        towgs84: '-382,-59,-262'
    },
    IGNF_TANNAG: {
        towgs84: '-139,-967,436'
    },
    IGNF_IGN72G: {
        towgs84: '-13,-348,292'
    },
    IGNF_ATIGG: {
        towgs84: '1118,23,66'
    },
    IGNF_FANGA84G: {
        towgs84: '150.57,158.33,118.32'
    },
    IGNF_RUSAT84G: {
        towgs84: '202.13,174.6,-15.74'
    },
    IGNF_KAUE70G: {
        towgs84: '126.74,300.1,-75.49'
    },
    IGNF_MOP90G: {
        towgs84: '-10.8,-1.8,12.77'
    },
    IGNF_MHPF67G: {
        towgs84: '338.08,212.58,-296.17'
    },
    IGNF_TAHI79G: {
        towgs84: '160.61,116.05,153.69'
    },
    IGNF_ANAA92G: {
        towgs84: '1.5,3.84,4.81'
    },
    IGNF_MARQUI72G: {
        towgs84: '330.91,-13.92,58.56'
    },
    IGNF_APAT86G: {
        towgs84: '143.6,197.82,74.05'
    },
    IGNF_TUBU69G: {
        towgs84: '237.17,171.61,-77.84'
    },
    IGNF_STPM50G: {
        towgs84: '11.363,424.148,373.13'
    },
    EPSG_4150: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4754: {
        towgs84: '-208.4058,-109.8777,-2.5764'
    },
    ESRI_104101: {
        towgs84: '374,150,588'
    },
    EPSG_4693: {
        towgs84: '0,-0.15,0.68'
    },
    EPSG_6207: {
        towgs84: '293.17,726.18,245.36'
    },
    EPSG_4153: {
        towgs84: '-133.63,-157.5,-158.62'
    },
    EPSG_4132: {
        towgs84: '-241.54,-163.64,396.06'
    },
    EPSG_4221: {
        towgs84: '-154.5,150.7,100.4'
    },
    EPSG_4266: {
        towgs84: '-80.7,-132.5,41.1'
    },
    EPSG_4193: {
        towgs84: '-70.9,-151.8,-41.4'
    },
    EPSG_5340: {
        towgs84: '-0.41,0.46,-0.35'
    },
    EPSG_4246: {
        towgs84: '-294.7,-200.1,525.5'
    },
    EPSG_4318: {
        towgs84: '-3.2,-5.7,2.8'
    },
    EPSG_4121: {
        towgs84: '-199.87,74.79,246.62'
    },
    EPSG_4223: {
        towgs84: '-260.1,5.5,432.2'
    },
    EPSG_4158: {
        towgs84: '-0.465,372.095,171.736'
    },
    EPSG_4285: {
        towgs84: '-128.16,-282.42,21.93'
    },
    EPSG_4613: {
        towgs84: '-404.78,685.68,45.47'
    },
    EPSG_4607: {
        towgs84: '195.671,332.517,274.607'
    },
    EPSG_4475: {
        towgs84: '-381.788,-57.501,-256.673'
    },
    EPSG_4208: {
        towgs84: '-157.84,308.54,-146.6'
    },
    EPSG_4743: {
        towgs84: '70.995,-335.916,262.898'
    },
    EPSG_4710: {
        towgs84: '-323.65,551.39,-491.22'
    },
    EPSG_7881: {
        towgs84: '-0.077,0.079,0.086'
    },
    EPSG_4682: {
        towgs84: '283.729,735.942,261.143'
    },
    EPSG_4739: {
        towgs84: '-156,-271,-189'
    },
    EPSG_4679: {
        towgs84: '-80.01,253.26,291.19'
    },
    EPSG_4750: {
        towgs84: '-56.263,16.136,-22.856'
    },
    EPSG_4644: {
        towgs84: '-10.18,-350.43,291.37'
    },
    EPSG_4695: {
        towgs84: '-103.746,-9.614,-255.95'
    },
    EPSG_4292: {
        towgs84: '-355,21,72'
    },
    EPSG_4302: {
        towgs84: '-61.702,284.488,472.052'
    },
    EPSG_4143: {
        towgs84: '-124.76,53,466.79'
    },
    EPSG_4606: {
        towgs84: '-153,153,307'
    },
    EPSG_4699: {
        towgs84: '-770.1,158.4,-498.2'
    },
    EPSG_4247: {
        towgs84: '-273.5,110.6,-357.9'
    },
    EPSG_4160: {
        towgs84: '8.88,184.86,106.69'
    },
    EPSG_4161: {
        towgs84: '-233.43,6.65,173.64'
    },
    EPSG_9251: {
        towgs84: '-9.5,122.9,138.2'
    },
    EPSG_9253: {
        towgs84: '-78.1,101.6,133.3'
    },
    EPSG_4297: {
        towgs84: '-198.383,-240.517,-107.909'
    },
    EPSG_4269: {
        towgs84: '0,0,0'
    },
    EPSG_4301: {
        towgs84: '-147,506,687'
    },
    EPSG_4618: {
        towgs84: '-59,-11,-52'
    },
    EPSG_4612: {
        towgs84: '0,0,0'
    },
    EPSG_4678: {
        towgs84: '44.585,-131.212,-39.544'
    },
    EPSG_4250: {
        towgs84: '-130,29,364'
    },
    EPSG_4144: {
        towgs84: '214,804,268'
    },
    EPSG_4147: {
        towgs84: '-17.51,-108.32,-62.39'
    },
    EPSG_4259: {
        towgs84: '-254.1,-5.36,-100.29'
    },
    EPSG_4164: {
        towgs84: '-76,-138,67'
    },
    EPSG_4211: {
        towgs84: '-378.873,676.002,-46.255'
    },
    EPSG_4182: {
        towgs84: '-422.651,-172.995,84.02'
    },
    EPSG_4224: {
        towgs84: '-143.87,243.37,-33.52'
    },
    EPSG_4225: {
        towgs84: '-205.57,168.77,-4.12'
    },
    EPSG_5527: {
        towgs84: '-67.35,3.88,-38.22'
    },
    EPSG_4752: {
        towgs84: '98,390,-22'
    },
    EPSG_4310: {
        towgs84: '-30,190,89'
    },
    EPSG_9248: {
        towgs84: '-192.26,65.72,132.08'
    },
    EPSG_4680: {
        towgs84: '124.5,-63.5,-281'
    },
    EPSG_4701: {
        towgs84: '-79.9,-158,-168.9'
    },
    EPSG_4706: {
        towgs84: '-146.21,112.63,4.05'
    },
    EPSG_4805: {
        towgs84: '682,-203,480'
    },
    EPSG_4201: {
        towgs84: '-165,-11,206'
    },
    EPSG_4210: {
        towgs84: '-157,-2,-299'
    },
    EPSG_4183: {
        towgs84: '-104,167,-38'
    },
    EPSG_4139: {
        towgs84: '11,72,-101'
    },
    EPSG_4668: {
        towgs84: '-86,-98,-119'
    },
    EPSG_4717: {
        towgs84: '-2,151,181'
    },
    EPSG_4732: {
        towgs84: '102,52,-38'
    },
    EPSG_4280: {
        towgs84: '-377,681,-50'
    },
    EPSG_4209: {
        towgs84: '-138,-105,-289'
    },
    EPSG_4261: {
        towgs84: '31,146,47'
    },
    EPSG_4658: {
        towgs84: '-73,46,-86'
    },
    EPSG_4721: {
        towgs84: '265.025,384.929,-194.046'
    },
    EPSG_4222: {
        towgs84: '-136,-108,-292'
    },
    EPSG_4601: {
        towgs84: '-255,-15,71'
    },
    EPSG_4602: {
        towgs84: '725,685,536'
    },
    EPSG_4603: {
        towgs84: '72,213.7,93'
    },
    EPSG_4605: {
        towgs84: '9,183,236'
    },
    EPSG_4621: {
        towgs84: '137,248,-430'
    },
    EPSG_4657: {
        towgs84: '-28,199,5'
    },
    EPSG_4316: {
        towgs84: '103.25,-100.4,-307.19'
    },
    EPSG_4642: {
        towgs84: '-13,-348,292'
    },
    EPSG_4698: {
        towgs84: '145,-187,103'
    },
    EPSG_4192: {
        towgs84: '-206.1,-174.7,-87.7'
    },
    EPSG_4311: {
        towgs84: '-265,120,-358'
    },
    EPSG_4135: {
        towgs84: '58,-283,-182'
    },
    ESRI_104138: {
        towgs84: '198,-226,-347'
    },
    EPSG_4245: {
        towgs84: '-11,851,5'
    },
    EPSG_4142: {
        towgs84: '-125,53,467'
    },
    EPSG_4213: {
        towgs84: '-106,-87,188'
    },
    EPSG_4253: {
        towgs84: '-133,-77,-51'
    },
    EPSG_4129: {
        towgs84: '-132,-110,-335'
    },
    EPSG_4713: {
        towgs84: '-77,-128,142'
    },
    EPSG_4239: {
        towgs84: '217,823,299'
    },
    EPSG_4146: {
        towgs84: '295,736,257'
    },
    EPSG_4155: {
        towgs84: '-83,37,124'
    },
    EPSG_4165: {
        towgs84: '-173,253,27'
    },
    EPSG_4672: {
        towgs84: '175,-38,113'
    },
    EPSG_4236: {
        towgs84: '-637,-549,-203'
    },
    EPSG_4251: {
        towgs84: '-90,40,88'
    },
    EPSG_4271: {
        towgs84: '-2,374,172'
    },
    EPSG_4175: {
        towgs84: '-88,4,101'
    },
    EPSG_4716: {
        towgs84: '298,-304,-375'
    },
    EPSG_4315: {
        towgs84: '-23,259,-9'
    },
    EPSG_4744: {
        towgs84: '-242.2,-144.9,370.3'
    },
    EPSG_4244: {
        towgs84: '-97,787,86'
    },
    EPSG_4293: {
        towgs84: '616,97,-251'
    },
    EPSG_4714: {
        towgs84: '-127,-769,472'
    },
    EPSG_4736: {
        towgs84: '260,12,-147'
    },
    EPSG_6883: {
        towgs84: '-235,-110,393'
    },
    EPSG_6894: {
        towgs84: '-63,176,185'
    },
    EPSG_4205: {
        towgs84: '-43,-163,45'
    },
    EPSG_4256: {
        towgs84: '41,-220,-134'
    },
    EPSG_4262: {
        towgs84: '639,405,60'
    },
    EPSG_4604: {
        towgs84: '174,359,365'
    },
    EPSG_4169: {
        towgs84: '-115,118,426'
    },
    EPSG_4620: {
        towgs84: '-106,-129,165'
    },
    EPSG_4184: {
        towgs84: '-203,141,53'
    },
    EPSG_4616: {
        towgs84: '-289,-124,60'
    },
    EPSG_9403: {
        towgs84: '-307,-92,127'
    },
    EPSG_4684: {
        towgs84: '-133,-321,50'
    },
    EPSG_4708: {
        towgs84: '-491,-22,435'
    },
    EPSG_4707: {
        towgs84: '114,-116,-333'
    },
    EPSG_4709: {
        towgs84: '145,75,-272'
    },
    EPSG_4712: {
        towgs84: '-205,107,53'
    },
    EPSG_4711: {
        towgs84: '124,-234,-25'
    },
    EPSG_4718: {
        towgs84: '230,-199,-752'
    },
    EPSG_4719: {
        towgs84: '211,147,111'
    },
    EPSG_4724: {
        towgs84: '208,-435,-229'
    },
    EPSG_4725: {
        towgs84: '189,-79,-202'
    },
    EPSG_4735: {
        towgs84: '647,1777,-1124'
    },
    EPSG_4722: {
        towgs84: '-794,119,-298'
    },
    EPSG_4728: {
        towgs84: '-307,-92,127'
    },
    EPSG_4734: {
        towgs84: '-632,438,-609'
    },
    EPSG_4727: {
        towgs84: '912,-58,1227'
    },
    EPSG_4729: {
        towgs84: '185,165,42'
    },
    EPSG_4730: {
        towgs84: '170,42,84'
    },
    EPSG_4733: {
        towgs84: '276,-57,149'
    },
    ESRI_37218: {
        towgs84: '230,-199,-752'
    },
    ESRI_37240: {
        towgs84: '-7,215,225'
    },
    ESRI_37221: {
        towgs84: '252,-209,-751'
    },
    ESRI_4305: {
        towgs84: '-123,-206,219'
    },
    ESRI_104139: {
        towgs84: '-73,-247,227'
    },
    EPSG_4748: {
        towgs84: '51,391,-36'
    },
    EPSG_4219: {
        towgs84: '-384,664,-48'
    },
    EPSG_4255: {
        towgs84: '-333,-222,114'
    },
    EPSG_4257: {
        towgs84: '-587.8,519.75,145.76'
    },
    EPSG_4646: {
        towgs84: '-963,510,-359'
    },
    EPSG_6881: {
        towgs84: '-24,-203,268'
    },
    EPSG_6882: {
        towgs84: '-183,-15,273'
    },
    EPSG_4715: {
        towgs84: '-104,-129,239'
    },
    IGNF_RGF93GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGM04GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGSPM06GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGTAAF07GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGFG95GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGNCG: {
        towgs84: '0,0,0'
    },
    IGNF_RGPFGDD: {
        towgs84: '0,0,0'
    },
    IGNF_ETRS89G: {
        towgs84: '0,0,0'
    },
    IGNF_RGR92GDD: {
        towgs84: '0,0,0'
    },
    EPSG_4173: {
        towgs84: '0,0,0'
    },
    EPSG_4180: {
        towgs84: '0,0,0'
    },
    EPSG_4619: {
        towgs84: '0,0,0'
    },
    EPSG_4667: {
        towgs84: '0,0,0'
    },
    EPSG_4075: {
        towgs84: '0,0,0'
    },
    EPSG_6706: {
        towgs84: '0,0,0'
    },
    EPSG_7798: {
        towgs84: '0,0,0'
    },
    EPSG_4661: {
        towgs84: '0,0,0'
    },
    EPSG_4669: {
        towgs84: '0,0,0'
    },
    EPSG_8685: {
        towgs84: '0,0,0'
    },
    EPSG_4151: {
        towgs84: '0,0,0'
    },
    EPSG_9702: {
        towgs84: '0,0,0'
    },
    EPSG_4758: {
        towgs84: '0,0,0'
    },
    EPSG_4761: {
        towgs84: '0,0,0'
    },
    EPSG_4765: {
        towgs84: '0,0,0'
    },
    EPSG_8997: {
        towgs84: '0,0,0'
    },
    EPSG_4023: {
        towgs84: '0,0,0'
    },
    EPSG_4670: {
        towgs84: '0,0,0'
    },
    EPSG_4694: {
        towgs84: '0,0,0'
    },
    EPSG_4148: {
        towgs84: '0,0,0'
    },
    EPSG_4163: {
        towgs84: '0,0,0'
    },
    EPSG_4167: {
        towgs84: '0,0,0'
    },
    EPSG_4189: {
        towgs84: '0,0,0'
    },
    EPSG_4190: {
        towgs84: '0,0,0'
    },
    EPSG_4176: {
        towgs84: '0,0,0'
    },
    EPSG_4659: {
        towgs84: '0,0,0'
    },
    EPSG_3824: {
        towgs84: '0,0,0'
    },
    EPSG_3889: {
        towgs84: '0,0,0'
    },
    EPSG_4046: {
        towgs84: '0,0,0'
    },
    EPSG_4081: {
        towgs84: '0,0,0'
    },
    EPSG_4558: {
        towgs84: '0,0,0'
    },
    EPSG_4483: {
        towgs84: '0,0,0'
    },
    EPSG_5013: {
        towgs84: '0,0,0'
    },
    EPSG_5264: {
        towgs84: '0,0,0'
    },
    EPSG_5324: {
        towgs84: '0,0,0'
    },
    EPSG_5354: {
        towgs84: '0,0,0'
    },
    EPSG_5371: {
        towgs84: '0,0,0'
    },
    EPSG_5373: {
        towgs84: '0,0,0'
    },
    EPSG_5381: {
        towgs84: '0,0,0'
    },
    EPSG_5393: {
        towgs84: '0,0,0'
    },
    EPSG_5489: {
        towgs84: '0,0,0'
    },
    EPSG_5593: {
        towgs84: '0,0,0'
    },
    EPSG_6135: {
        towgs84: '0,0,0'
    },
    EPSG_6365: {
        towgs84: '0,0,0'
    },
    EPSG_5246: {
        towgs84: '0,0,0'
    },
    EPSG_7886: {
        towgs84: '0,0,0'
    },
    EPSG_8431: {
        towgs84: '0,0,0'
    },
    EPSG_8427: {
        towgs84: '0,0,0'
    },
    EPSG_8699: {
        towgs84: '0,0,0'
    },
    EPSG_8818: {
        towgs84: '0,0,0'
    },
    EPSG_4757: {
        towgs84: '0,0,0'
    },
    EPSG_9140: {
        towgs84: '0,0,0'
    },
    EPSG_8086: {
        towgs84: '0,0,0'
    },
    EPSG_4686: {
        towgs84: '0,0,0'
    },
    EPSG_4737: {
        towgs84: '0,0,0'
    },
    EPSG_4702: {
        towgs84: '0,0,0'
    },
    EPSG_4747: {
        towgs84: '0,0,0'
    },
    EPSG_4749: {
        towgs84: '0,0,0'
    },
    EPSG_4674: {
        towgs84: '0,0,0'
    },
    EPSG_4755: {
        towgs84: '0,0,0'
    },
    EPSG_4759: {
        towgs84: '0,0,0'
    },
    EPSG_4762: {
        towgs84: '0,0,0'
    },
    EPSG_4763: {
        towgs84: '0,0,0'
    },
    EPSG_4764: {
        towgs84: '0,0,0'
    },
    EPSG_4166: {
        towgs84: '0,0,0'
    },
    EPSG_4170: {
        towgs84: '0,0,0'
    },
    EPSG_5546: {
        towgs84: '0,0,0'
    },
    EPSG_7844: {
        towgs84: '0,0,0'
    },
    EPSG_4818: {
        towgs84: '589,76,480'
    }
};
for(var $c36bbc8057de3d00$var$key in $c36bbc8057de3d00$var$datums){
    var $c36bbc8057de3d00$var$datum = $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$key];
    if (!$c36bbc8057de3d00$var$datum.datumName) continue;
    $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$datum.datumName] = $c36bbc8057de3d00$var$datum;
}
var $c36bbc8057de3d00$export$2e2bcd8739ae039 = $c36bbc8057de3d00$var$datums;

});

parcelRegister("3MCqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c13a87cc45f972b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === 'none') out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $gyVUi.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; // datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;

});

parcelRegister("flUkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d482da445fbb18$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getNadgrids", () => $b2d482da445fbb18$export$31c4d9288d81329a);
/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ /**
 * @typedef {Object} NadgridInfo
 * @property {string} name The name of the NAD grid or 'null' if not specified.
 * @property {boolean} mandatory Indicates if the grid is mandatory (true) or optional (false).
 * @property {*} grid The loaded NAD grid object, or null if not loaded or not applicable.
 * @property {boolean} isNull True if the grid is explicitly 'null', otherwise false.
 */ /**
 * @typedef {Object} NTV2GridOptions
 * @property {boolean} [includeErrorFields=true] Whether to include error fields in the subgrids.
 */ /**
 * @typedef {Object} NadgridHeader
 * @property {number} [nFields] Number of fields in the header.
 * @property {number} [nSubgridFields] Number of fields in each subgrid header.
 * @property {number} nSubgrids Number of subgrids in the file.
 * @property {string} [shiftType] Type of shift (e.g., "SECONDS").
 * @property {number} [fromSemiMajorAxis] Source ellipsoid semi-major axis.
 * @property {number} [fromSemiMinorAxis] Source ellipsoid semi-minor axis.
 * @property {number} [toSemiMajorAxis] Target ellipsoid semi-major axis.
 * @property {number} [toSemiMinorAxis] Target ellipsoid semi-minor axis.
 */ /**
 * @typedef {Object} Subgrid
 * @property {Array<number>} ll Lower left corner of the grid in radians [longitude, latitude].
 * @property {Array<number>} del Grid spacing in radians [longitude interval, latitude interval].
 * @property {Array<number>} lim Number of columns in the grid [longitude columns, latitude columns].
 * @property {number} [count] Total number of grid nodes.
 * @property {Array} cvs Mapped node values for the grid.
 */ /** @typedef {{header: NadgridHeader, subgrids: Array<Subgrid>}} NADGrid */ /**
 * @typedef {Object} GeoTIFF
 * @property {() => Promise<number>} getImageCount - Returns the number of images in the GeoTIFF.
 * @property {(index: number) => Promise<GeoTIFFImage>} getImage - Returns a GeoTIFFImage for the given index.
 */ /**
 * @typedef {Object} GeoTIFFImage
 * @property {() => number} getWidth - Returns the width of the image.
 * @property {() => number} getHeight - Returns the height of the image.
 * @property {() => number[]} getBoundingBox - Returns the bounding box as [minX, minY, maxX, maxY] in degrees.
 * @property {() => Promise<ArrayLike<ArrayLike<number>>>} readRasters - Returns the raster data as an array of bands.
 * @property {Object} fileDirectory - The file directory object containing metadata.
 * @property {Object} fileDirectory.ModelPixelScale - The pixel scale array [scaleX, scaleY, scaleZ] in degrees.
 */ var $b2d482da445fbb18$var$loadedNadgrids = {};
function $b2d482da445fbb18$export$2e2bcd8739ae039(key, data, options) {
    if (data instanceof ArrayBuffer) return $b2d482da445fbb18$var$readNTV2Grid(key, data, options);
    return {
        ready: $b2d482da445fbb18$var$readGeotiffGrid(key, data)
    };
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {ArrayBuffer} data The NTv2 grid data as an ArrayBuffer.
 * @param {NTV2GridOptions} [options] Optional parameters for loading the grid.
 * @returns {NADGrid} The loaded NAD grid information.
 */ function $b2d482da445fbb18$var$readNTV2Grid(key, data, options) {
    var includeErrorFields = true;
    if (options !== undefined && options.includeErrorFields === false) includeErrorFields = false;
    var view = new DataView(data);
    var isLittleEndian = $b2d482da445fbb18$var$detectLittleEndian(view);
    var header = $b2d482da445fbb18$var$readHeader(view, isLittleEndian);
    var subgrids = $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian, includeErrorFields);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {GeoTIFF} tiff The GeoTIFF instance to read the grid from.
 * @returns {Promise<NADGrid>} A promise that resolves to the loaded NAD grid information.
 */ async function $b2d482da445fbb18$var$readGeotiffGrid(key, tiff) {
    var subgrids = [];
    var subGridCount = await tiff.getImageCount();
    // proj produced tiff grid shift files appear to organize lower res subgrids first, higher res/ child subgrids last.
    for(var subgridIndex = subGridCount - 1; subgridIndex >= 0; subgridIndex--){
        var image = await tiff.getImage(subgridIndex);
        var rasters = await image.readRasters();
        var data = rasters;
        var lim = [
            image.getWidth(),
            image.getHeight()
        ];
        var imageBBoxRadians = image.getBoundingBox().map($b2d482da445fbb18$var$degreesToRadians);
        var del = [
            image.fileDirectory.ModelPixelScale[0],
            image.fileDirectory.ModelPixelScale[1]
        ].map($b2d482da445fbb18$var$degreesToRadians);
        var maxX = imageBBoxRadians[0] + (lim[0] - 1) * del[0];
        var minY = imageBBoxRadians[3] - (lim[1] - 1) * del[1];
        var latitudeOffsetBand = data[0];
        var longitudeOffsetBand = data[1];
        var nodes = [];
        for(let i = lim[1] - 1; i >= 0; i--)for(let j = lim[0] - 1; j >= 0; j--){
            var index = i * lim[0] + j;
            nodes.push([
                -$b2d482da445fbb18$var$secondsToRadians(longitudeOffsetBand[index]),
                $b2d482da445fbb18$var$secondsToRadians(latitudeOffsetBand[index])
            ]);
        }
        subgrids.push({
            del: del,
            lim: lim,
            ll: [
                -maxX,
                minY
            ],
            cvs: nodes
        });
    }
    var tifGrid = {
        header: {
            nSubgrids: subGridCount
        },
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = tifGrid;
    return tifGrid;
}
function $b2d482da445fbb18$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(',');
    return grids.map($b2d482da445fbb18$var$parseNadgridString);
}
/**
 * @param {string} value The nadgrid string to get information for.
 * @returns {NadgridInfo|null} An object with grid information, or null if the input is empty.
 */ function $b2d482da445fbb18$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === '@';
    if (optional) value = value.slice(1);
    if (value === 'null') return {
        name: 'null',
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $b2d482da445fbb18$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $b2d482da445fbb18$var$degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function $b2d482da445fbb18$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $b2d482da445fbb18$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    return true;
}
function $b2d482da445fbb18$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $b2d482da445fbb18$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian, includeErrorFields) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $b2d482da445fbb18$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $b2d482da445fbb18$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian, includeErrorFields);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLongitude),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.longitudeInterval),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $b2d482da445fbb18$var$mapNodes(nodes)
        });
        var rowSize = 16;
        if (includeErrorFields === false) rowSize = 8;
        gridOffset += 176 + subHeader.gridNodeCount * rowSize;
    }
    return grids;
}
/**
 * @param {*} nodes
 * @returns Array<Array<number>>
 */ function $b2d482da445fbb18$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $b2d482da445fbb18$var$secondsToRadians(r.longitudeShift),
            $b2d482da445fbb18$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $b2d482da445fbb18$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $b2d482da445fbb18$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $b2d482da445fbb18$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$readGridNodes(view, offset, gridHeader, isLittleEndian, includeErrorFields) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    if (includeErrorFields === false) gridRecordLength = 8;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian)
        };
        if (includeErrorFields !== false) {
            record.latitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian);
            record.longitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian);
        }
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}

});


parcelRegister("ceNev", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8cfb7cbefc2113$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $d7qcu = parcelRequire("d7qcu");

var $hL60j = parcelRequire("hL60j");

var $38qqf = parcelRequire("38qqf");

var $5vTfu = parcelRequire("5vTfu");

var $coO2L = parcelRequire("coO2L");
function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && dest.datumCode !== 'WGS84' || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && source.datumCode !== 'WGS84';
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $5vTfu.default)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $coO2L.default)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $38qqf.default)('WGS84');
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') point = (0, $hL60j.default)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $d7qcu.default)(source.datum, dest.datum, point);
    if (!point) return;
    /** @type {import('./core').InterfaceCoordinates} */ point;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === 'longlat') // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') return (0, $hL60j.default)(dest, true, point);
    if (point && !hasZ) delete point.z;
    return point;
}

});
parcelRegister("d7qcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d040a88dc0214f$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $4YPx7 = parcelRequire("4YPx7");

var $a9oRf = parcelRequire("a9oRf");
function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $4YPx7.compareDatums)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var gridShiftCode = $98d040a88dc0214f$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        dest_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $gyVUi.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $4YPx7.geodeticToGeocentric)(point, source_es, source_a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $4YPx7.geocentricToWgs84)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $4YPx7.geocentricFromWgs84)(point, dest.datum_type, dest.datum_params);
    point = (0, $4YPx7.geocentricToGeodetic)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $98d040a88dc0214f$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $98d040a88dc0214f$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log('Unable to find mandatory grid \'' + grid.name + '\'');
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $98d040a88dc0214f$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log('Failed to find a grid shift table for location \'' + -input.x * (0, $gyVUi.R2D) + ' ' + input.y * (0, $gyVUi.R2D) + ' tried: \'' + attemptedGrids + '\'');
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $98d040a88dc0214f$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $a9oRf.default)(tb.x - Math.PI) + Math.PI;
    var t = $98d040a88dc0214f$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $98d040a88dc0214f$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log('Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.');
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log('Inverse grid shift iterator failed to converge.');
            return val;
        }
        val.x = (0, $a9oRf.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $98d040a88dc0214f$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}

});
parcelRegister("4YPx7", function(module, exports) {

$parcel$export(module.exports, "compareDatums", () => $3a04bd721826a648$export$68c8d8590fbb24e4);
$parcel$export(module.exports, "geodeticToGeocentric", () => $3a04bd721826a648$export$4a4ae2976f9a808a);
$parcel$export(module.exports, "geocentricToGeodetic", () => $3a04bd721826a648$export$26210192c8922750);
$parcel$export(module.exports, "geocentricToWgs84", () => $3a04bd721826a648$export$d18952b9ecb47c8f);
$parcel$export(module.exports, "geocentricFromWgs84", () => $3a04bd721826a648$export$2b744ad521e7ac0b);

var $gyVUi = parcelRequire("gyVUi");
'use strict';
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; // Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ // ..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; // Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } // cs_geocentric_from_wgs84()
}

});


parcelRegister("hL60j", function(module, exports) {

$parcel$export(module.exports, "default", () => $cedb7bb5617791b0$export$2e2bcd8739ae039);
function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    /** @type {import("./core").InterfaceCoordinates} */ var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ('ew'.indexOf(crs.axis[i]) !== -1) t = 'x';
            else t = 'y';
        } else if (i === 1) {
            v = yin;
            if ('ns'.indexOf(crs.axis[i]) !== -1) t = 'y';
            else t = 'x';
        } else {
            v = zin;
            t = 'z';
        }
        switch(crs.axis[i]){
            case 'e':
                out[t] = v;
                break;
            case 'w':
                out[t] = -v;
                break;
            case 'n':
                out[t] = v;
                break;
            case 's':
                out[t] = -v;
                break;
            case 'u':
                if (point[t] !== undefined) out.z = v;
                break;
            case 'd':
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                // console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}

});

parcelRegister("5vTfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $01093474ae9bd8f6$export$2e2bcd8739ae039);
/**
 * @param {Array<number>} array
 * @returns {import("../core").InterfaceCoordinates}
 */ function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}

});

parcelRegister("coO2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $906e8b8bdc80d434$export$2e2bcd8739ae039);
function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) return;
        throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) throw new TypeError('coordinates must be finite numbers');
}

});



parcelRegister("iCFRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ec3fc1ff061c76$export$2e2bcd8739ae039);

var $4hMrQ = parcelRequire("4hMrQ");
/**
 * @deprecated v3.0.0 - use proj4.toPoint instead
 * @param {number | import('./core').TemplateCoordinates | string} x
 * @param {number} [y]
 * @param {number} [z]
 */ function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0]);
        this.y = parseFloat(coords[1]);
        this.z = parseFloat(coords[2]) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $4hMrQ.toPoint)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $4hMrQ.forward)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;

});
parcelRegister("4hMrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forward", () => $31ee54b8e1d1cd8f$export$174bb771924e7eb1);
$parcel$export(module.exports, "toPoint", () => $31ee54b8e1d1cd8f$export$b63cca88ddc558a9);
/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';
    if (84 >= lat && lat >= 72) LetterDesignator = 'X';
    else if (72 > lat && lat >= 64) LetterDesignator = 'W';
    else if (64 > lat && lat >= 56) LetterDesignator = 'V';
    else if (56 > lat && lat >= 48) LetterDesignator = 'U';
    else if (48 > lat && lat >= 40) LetterDesignator = 'T';
    else if (40 > lat && lat >= 32) LetterDesignator = 'S';
    else if (32 > lat && lat >= 24) LetterDesignator = 'R';
    else if (24 > lat && lat >= 16) LetterDesignator = 'Q';
    else if (16 > lat && lat >= 8) LetterDesignator = 'P';
    else if (8 > lat && lat >= 0) LetterDesignator = 'N';
    else if (0 > lat && lat >= -8) LetterDesignator = 'M';
    else if (-8 > lat && lat >= -16) LetterDesignator = 'L';
    else if (-16 > lat && lat >= -24) LetterDesignator = 'K';
    else if (-24 > lat && lat >= -32) LetterDesignator = 'J';
    else if (-32 > lat && lat >= -40) LetterDesignator = 'H';
    else if (-40 > lat && lat >= -48) LetterDesignator = 'G';
    else if (-48 > lat && lat >= -56) LetterDesignator = 'F';
    else if (-56 > lat && lat >= -64) LetterDesignator = 'E';
    else if (-64 > lat && lat >= -72) LetterDesignator = 'D';
    else if (-72 > lat && lat >= -80) LetterDesignator = 'C';
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > 'V') throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case 'C':
            northing = 1100000.0;
            break;
        case 'D':
            northing = 2000000.0;
            break;
        case 'E':
            northing = 2800000.0;
            break;
        case 'F':
            northing = 3700000.0;
            break;
        case 'G':
            northing = 4600000.0;
            break;
        case 'H':
            northing = 5500000.0;
            break;
        case 'J':
            northing = 6400000.0;
            break;
        case 'K':
            northing = 7300000.0;
            break;
        case 'L':
            northing = 8200000.0;
            break;
        case 'M':
            northing = 9100000.0;
            break;
        case 'N':
            northing = 0.0;
            break;
        case 'P':
            northing = 800000.0;
            break;
        case 'Q':
            northing = 1700000.0;
            break;
        case 'R':
            northing = 2600000.0;
            break;
        case 'S':
            northing = 3500000.0;
            break;
        case 'T':
            northing = 4400000.0;
            break;
        case 'U':
            northing = 5300000.0;
            break;
        case 'V':
            northing = 6200000.0;
            break;
        case 'W':
            northing = 7000000.0;
            break;
        case 'X':
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}

});


parcelRegister("j48cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $de14c0a63cfa0e0d$export$2e2bcd8739ae039);

var $9t3dO = parcelRequire("9t3dO");

var $9zr9G = parcelRequire("9zr9G");

var $kAWkR = parcelRequire("kAWkR");

var $5HQRm = parcelRequire("5HQRm");

var $llHto = parcelRequire("llHto");

var $4gjYM = parcelRequire("4gjYM");

var $ejQ1Z = parcelRequire("ejQ1Z");

var $iubsy = parcelRequire("iubsy");

var $h7o5G = parcelRequire("h7o5G");

var $0599r = parcelRequire("0599r");

var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $iSJfu = parcelRequire("iSJfu");

var $6CTAc = parcelRequire("6CTAc");

var $cEGTl = parcelRequire("cEGTl");

var $2Lrqq = parcelRequire("2Lrqq");

var $6Eu1X = parcelRequire("6Eu1X");

var $fpjAW = parcelRequire("fpjAW");

var $eA4Bc = parcelRequire("eA4Bc");

var $7uCfv = parcelRequire("7uCfv");

var $hp0oy = parcelRequire("hp0oy");

var $1W450 = parcelRequire("1W450");

var $i6dz6 = parcelRequire("i6dz6");

var $37G1n = parcelRequire("37G1n");

var $2XUb4 = parcelRequire("2XUb4");

var $byZja = parcelRequire("byZja");

var $Fj8jS = parcelRequire("Fj8jS");

var $eJp9e = parcelRequire("eJp9e");

var $jJ6PL = parcelRequire("jJ6PL");

var $cbANR = parcelRequire("cbANR");

var $gtZfx = parcelRequire("gtZfx");

var $kU0qj = parcelRequire("kU0qj");
function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $9t3dO.default));
    proj4.Proj.projections.add((0, $9zr9G.default));
    proj4.Proj.projections.add((0, $kAWkR.default));
    proj4.Proj.projections.add((0, $5HQRm.default));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $4gjYM.default));
    proj4.Proj.projections.add((0, $ejQ1Z.default));
    proj4.Proj.projections.add((0, $iubsy.default));
    proj4.Proj.projections.add((0, $h7o5G.default));
    proj4.Proj.projections.add((0, $0599r.default));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $iSJfu.default));
    proj4.Proj.projections.add((0, $6CTAc.default));
    proj4.Proj.projections.add((0, $cEGTl.default));
    proj4.Proj.projections.add((0, $2Lrqq.default));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $fpjAW.default));
    proj4.Proj.projections.add((0, $eA4Bc.default));
    proj4.Proj.projections.add((0, $7uCfv.default));
    proj4.Proj.projections.add((0, $hp0oy.default));
    proj4.Proj.projections.add((0, $1W450.default));
    proj4.Proj.projections.add((0, $i6dz6.default));
    proj4.Proj.projections.add((0, $37G1n.default));
    proj4.Proj.projections.add((0, $2XUb4.default));
    proj4.Proj.projections.add((0, $byZja.default));
    proj4.Proj.projections.add((0, $Fj8jS.default));
    proj4.Proj.projections.add((0, $eJp9e.default));
    proj4.Proj.projections.add((0, $jJ6PL.default));
    proj4.Proj.projections.add((0, $cbANR.default));
    proj4.Proj.projections.add((0, $gtZfx.default));
    proj4.Proj.projections.add((0, $kU0qj.default));
}

});
parcelRegister("9t3dO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e495242beb4668f$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.ml0 = (0, $hpUQm.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $hpUQm.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0, this.over);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $jQUK6.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi, this.over);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    'Fast_Transverse_Mercator',
    'Fast Transverse Mercator'
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};

});
parcelRegister("gqKpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6313ff986be9ac$export$2e2bcd8739ae039);
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}

});

parcelRegister("hpUQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae0dd692f473684$export$2e2bcd8739ae039);
function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("jQUK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73ee39023f9c198$export$2e2bcd8739ae039);

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        // t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        // phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $hpUQm.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    // ..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});


parcelRegister("9zr9G", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $6f7c72613b8aa92a$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $9t3dO = parcelRequire("9t3dO");

var $zBlxr = parcelRequire("zBlxr");

var $jU5gu = parcelRequire("jU5gu");

var $cVtoA = parcelRequire("cVtoA");

var $klaWo = parcelRequire("klaWo");

var $k0stT = parcelRequire("k0stT");

var $iKZ74 = parcelRequire("iKZ74");

var $a9oRf = parcelRequire("a9oRf");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $9t3dO.default).init.apply(this);
        this.forward = (0, $9t3dO.default).forward;
        this.inverse = (0, $9t3dO.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $klaWo.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $k0stT.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0, this.over);
    var Cn = p.y;
    Cn = (0, $klaWo.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $jU5gu.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVtoA.default)(Math.tan(Ce));
    var tmp = (0, $iKZ74.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $iKZ74.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $zBlxr.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $jU5gu.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0, this.over);
        lat = (0, $klaWo.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Extended_Transverse_Mercator',
    'Extended Transverse Mercator',
    'etmerc',
    'Transverse_Mercator',
    'Transverse Mercator',
    'Gauss Kruger',
    'Gauss_Kruger',
    'tmerc'
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("zBlxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b03d370063c40e$export$2e2bcd8739ae039);
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("jU5gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d754d244264a37$export$2e2bcd8739ae039);
function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVtoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96919c3c2b0cfee9$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");

var $g1hBf = parcelRequire("g1hBf");
function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $g1hBf.default)(y * (1 + y / ((0, $jU5gu.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("g1hBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a64430787103e$export$2e2bcd8739ae039);
function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("klaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecee41736c9c0e4b$export$2e2bcd8739ae039);
function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("k0stT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909e682fc23c405$export$2e2bcd8739ae039);
function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("iKZ74", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7beda932685c15$export$2e2bcd8739ae039);

var $zBlxr = parcelRequire("zBlxr");

var $cz4ED = parcelRequire("cz4ED");
function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $zBlxr.default)(arg_i);
    var cosh_arg_i = (0, $cz4ED.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("cz4ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c5d35b4e59088$export$2e2bcd8739ae039);
function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("kAWkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe46ba059d82de2$export$2e2bcd8739ae039);

var $b4YJ1 = parcelRequire("b4YJ1");

var $9zr9G = parcelRequire("9zr9G");

var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = 'etmerc';
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $b4YJ1.default)(this.zone, this.long0);
    if (zone === undefined) throw new Error('unknown utm zone');
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $9zr9G.default).init.apply(this);
    this.forward = (0, $9zr9G.default).forward;
    this.inverse = (0, $9zr9G.default).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    'Universal Transverse Mercator System',
    'utm'
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};

});
parcelRegister("b4YJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $810f2c2910fd20b1$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}

});


parcelRegister("5HQRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4279f8b9d31284e6$export$2e2bcd8739ae039);

var $zGHAa = parcelRequire("zGHAa");

var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $zGHAa.default).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = 'Oblique Stereographic Alternative';
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0, this.over);
    (0, $zGHAa.default).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $jU5gu.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $zGHAa.default).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0, this.over);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    'Stereographic_North_Pole',
    'Oblique_Stereographic',
    'sterea',
    'Oblique Stereographic Alternative',
    'Double_Stereographic'
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};

});
parcelRegister("zGHAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b464b721451620$export$2e2bcd8739ae039);

var $82Tex = parcelRequire("82Tex");

var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $82Tex.default)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    'gauss'
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};

});
parcelRegister("82Tex", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db95ad4da70d3a6$export$2e2bcd8739ae039);
function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}

});



parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function $f8ad4802022ce868$export$8adc077b4b982c95(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function $f8ad4802022ce868$export$2cd8252107eb640b() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) // North pole
            // trace('stere:north pole');
            this.con = 1;
            else // South pole
            // trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $gyVUi.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan($f8ad4802022ce868$export$8adc077b4b982c95(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function $f8ad4802022ce868$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        // case of the origine point
        // trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        // trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan($f8ad4802022ce868$export$8adc077b4b982c95(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            // trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            // Eq
            // trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            // other case
            // trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    // trace(p.toString());
    return p;
}
function $f8ad4802022ce868$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            // trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)), this.over);
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    // trace(p.toString());
    return p;
}
var $f8ad4802022ce868$export$e4b2ac9215619f8d = [
    'stere',
    'Stereographic_South_Pole',
    'Polar_Stereographic_variant_A',
    'Polar_Stereographic_variant_B',
    'Polar_Stereographic'
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: $f8ad4802022ce868$export$2cd8252107eb640b,
    forward: $f8ad4802022ce868$export$174bb771924e7eb1,
    inverse: $f8ad4802022ce868$export$70ae2c07e401031b,
    names: $f8ad4802022ce868$export$e4b2ac9215619f8d,
    ssfn_: $f8ad4802022ce868$export$8adc077b4b982c95
};

});

parcelRegister("4gjYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a8278a941356d4$export$2e2bcd8739ae039);
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ /**
 * @typedef {Object} LocalThis
 * @property {number} lambda0
 * @property {number} e
 * @property {number} R
 * @property {number} b0
 * @property {number} K
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) // ...reportError("omercFwdInfinity");
        return;
        // S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    'somerc'
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};

});

parcelRegister("ejQ1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6cb33582cb5910b$export$2e2bcd8739ae039);

var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");

var $1Wo5P = parcelRequire("1Wo5P");
/**
 * @typedef {Object} LocalThis
 * @property {boolean} no_off
 * @property {boolean} no_rot
 * @property {number} rectified_grid_angle
 * @property {number} es
 * @property {number} A
 * @property {number} B
 * @property {number} E
 * @property {number} e
 * @property {number} lam0
 * @property {number} singam
 * @property {number} cosgam
 * @property {number} sinrot
 * @property {number} cosrot
 * @property {number} rB
 * @property {number} ArB
 * @property {number} BrA
 * @property {number} u_0
 * @property {number} v_pole_n
 * @property {number} v_pole_s
 */ var $a6cb33582cb5910b$var$TOL = 1e-7;
function $a6cb33582cb5910b$var$isTypeA(P) {
    var typeAProjections = [
        'Hotine_Oblique_Mercator',
        'Hotine_Oblique_Mercator_variant_A',
        'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'
    ];
    var projectionName = typeof P.projName === 'object' ? Object.keys(P.projName)[0] : P.projName;
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1 || typeAProjections.indexOf((0, $1Wo5P.getNormalizedProjName)(projectionName)) !== -1;
}
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $a6cb33582cb5910b$var$isTypeA(this);
    this.no_rot = 'no_rot' in this;
    var alp = false;
    if ('alpha' in this) alp = true;
    var gam = false;
    if ('rectified_grid_angle' in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle;
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $a6cb33582cb5910b$var$TOL || (con = Math.abs(phi1)) <= $a6cb33582cb5910b$var$TOL || Math.abs(con - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(phi2) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $gyVUi.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $3xC66.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $3xC66.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $3xC66.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.PI) lam2 -= (0, $gyVUi.TWO_PI);
        else if (con > Math.PI) lam2 += (0, $gyVUi.TWO_PI);
        this.lam0 = (0, $a9oRf.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B, this.over);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $a9oRf.default)(lam1 - this.lam0, this.over)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) + F));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $gyVUi.HALF_PI)) > (0, $gyVUi.EPSLN)) {
        W = this.E / Math.pow((0, $3xC66.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $gyVUi.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $a6cb33582cb5910b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $gyVUi.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $2AZR8.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    'Hotine_Oblique_Mercator',
    'Hotine Oblique Mercator',
    'Hotine_Oblique_Mercator_variant_A',
    'Hotine_Oblique_Mercator_Variant_B',
    'Hotine_Oblique_Mercator_Azimuth_Natural_Origin',
    'Hotine_Oblique_Mercator_Two_Point_Natural_Origin',
    'Hotine_Oblique_Mercator_Azimuth_Center',
    'Oblique_Mercator',
    'omerc'
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};

});

parcelRegister("iubsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d753eaf12887a276$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    // double lat0;                    /* the reference latitude               */
    // double long0;                   /* the reference longitude              */
    // double lat1;                    /* first standard parallel              */
    // double lat2;                    /* second standard parallel             */
    // double r_maj;                   /* major axis                           */
    // double r_min;                   /* minor axis                           */
    // double false_east;              /* x offset in meters                   */
    // double false_north;             /* y offset in meters                   */
    // the above value can be set with proj4.defs
    // example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     // if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN) ? 0 // Handle poles by setting ts0 to 0
     : (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = 'Lambert Conformal Conic';
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0, this.over);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    'Lambert Tangential Conformal Conic Projection',
    'Lambert_Conformal_Conic',
    'Lambert_Conformal_Conic_1SP',
    'Lambert_Conformal_Conic_2SP',
    'lcc',
    'Lambert Conic Conformal (1SP)',
    'Lambert Conic Conformal (2SP)'
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};

});

parcelRegister("h7o5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c765c705b741a192$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x */ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    'Krovak',
    'krovak'
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};

});

parcelRegister("0599r", function(module, exports) {

$parcel$export(module.exports, "default", () => $00f791059e8f61f5$export$2e2bcd8739ae039);

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $3eeGT = parcelRequire("3eeGT");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $bWC4D.default)(this.es);
        this.e1 = (0, $hU8aC.default)(this.es);
        this.e2 = (0, $i9r9A.default)(this.es);
        this.e3 = (0, $bM0eI.default)(this.es);
        this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0, this.over);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        // ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $3eeGT.default)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $cfNuL.default)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $3eeGT.default)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0, this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    'Cassini',
    'Cassini_Soldner',
    'cass'
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};

});
parcelRegister("f3cKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $af51062589eeb2ce$export$2e2bcd8739ae039);
function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}

});

parcelRegister("bWC4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b22a51ec249391e$export$2e2bcd8739ae039);
function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}

});

parcelRegister("hU8aC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08e0117e308bb87$export$2e2bcd8739ae039);
function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}

});

parcelRegister("i9r9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36e2161accfe0ec$export$2e2bcd8739ae039);
function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}

});

parcelRegister("bM0eI", function(module, exports) {

$parcel$export(module.exports, "default", () => $89245c5bc9a5a616$export$2e2bcd8739ae039);
function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}

});

parcelRegister("3eeGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $259e1333723cc7cb$export$2e2bcd8739ae039);
function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}

});

parcelRegister("aDUFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf9815baea17aa9$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}

});

parcelRegister("cfNuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ebd4771f70de1ee$export$2e2bcd8739ae039);
function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // ..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? S_POLE : N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = EQUIT;
    else this.mode = OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case N_POLE:
                this.dd = 1;
                break;
            case S_POLE:
                this.dd = 1;
                break;
            case EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0, this.over);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam, this.over);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    'Lambert Azimuthal Equal Area',
    'Lambert_Azimuthal_Equal_Area',
    'laea'
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    'Albers_Conic_Equal_Area',
    'Albers_Equal_Area',
    'Albers',
    'aea'
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("iSJfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf05e97c9232a2a$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon, this.over);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    'gnom'
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};

});

parcelRegister("6CTAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31684dfe594c29$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $b4Ogv = parcelRequire("b4Ogv");
function $4d31684dfe594c29$export$2cd8252107eb640b() {
    // no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts), this.over);
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $b4Ogv.default)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    'cea'
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};

});
parcelRegister("b4Ogv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81070f0f2a61f650$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    // var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}

});


parcelRegister("cEGTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $936a7dd52884a3fc$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");
function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Equidistant Cylindrical (Plate Carre)';
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var dlat = (0, $aDUFA.default)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc), this.over);
    p.y = (0, $aDUFA.default)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    'Equirectangular',
    'Equidistant_Cylindrical',
    'Equidistant_Cylindrical_Spherical',
    'eqc'
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};

});

parcelRegister("2Lrqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $20353e9e716518d0$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $f3cKo = parcelRequire("f3cKo");

var $gyVUi = parcelRequire("gyVUi");

var $3eeGT = parcelRequire("3eeGT");
/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0); // si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $aDUFA.default)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $3eeGT.default)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0, this.over);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat), this.over);
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a, this.over);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        // lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    'Polyconic',
    'American_Polyconic',
    'poly'
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};

});

parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'New_Zealand_Map_Grid',
    'nzmg'
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

parcelRegister("fpjAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37863f65bf2a2a4$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
// no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a, this.over);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    'Miller_Cylindrical',
    'mill'
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};

});

parcelRegister("eA4Bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d7febe7a8566f2$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    ------------------------------------------------- */ if (!this.sphere) this.en = (0, $gqKpL.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $hpUQm.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0, this.over);
        lat = (0, $aDUFA.default)(lat);
    } else {
        lat = (0, $jQUK6.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            // temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp, this.over);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    'Sinusoidal',
    'sinu'
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};

});

parcelRegister("7uCfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $57490138fba0a0b8$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      ----------------------------------------------------- */ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       -------------------------------------------------------------------------- */ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       ------------------------------------------------------------------- */ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)), this.over);
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    'Mollweide',
    'moll'
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};

});

parcelRegister("hp0oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab513e7d920927e$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $bi5ZC = parcelRequire("bi5ZC");

var $f3cKo = parcelRequire("f3cKo");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.sin_phi = Math.sin(this.lat1);
    this.cos_phi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sin_phi, this.cos_phi);
    this.ml1 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sin_phi;
    else {
        this.sin_phi = Math.sin(this.lat2);
        this.cos_phi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sin_phi, this.cos_phi);
        this.ml2 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      ----------------- */ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns, this.over);
        lat = (0, $aDUFA.default)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $cfNuL.default)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns, this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    'Equidistant_Conic',
    'eqdc'
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};

});

parcelRegister("1W450", function(module, exports) {

$parcel$export(module.exports, "default", () => $168e5f6524a6fc5f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    // this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    // con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) // y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else // y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    'Van_der_Grinten_I',
    'VanDerGrinten',
    'Van_der_Grinten',
    'vandg'
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};

});

parcelRegister("i6dz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d34f4dbda3af26$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $ljPJJ = parcelRequire("ljPJJ");

var $cfNuL = parcelRequire("cfNuL");

var $7StUg = parcelRequire("7StUg");
function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
    // flattening for ellipsoid
    this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var e0, e1, e2, e3, Mlp, Ml, c, kp, cos_c, vars, azi1;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            // default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            // Default case
            if (Math.abs(lon) < (0, $gyVUi.EPSLN) && Math.abs(lat - this.lat0) < (0, $gyVUi.EPSLN)) {
                p.x = p.y = 0;
                return p;
            }
            vars = (0, $7StUg.vincentyInverse)(this.lat0, this.long0, lat, lon, this.a, this.f);
            azi1 = vars.azi1;
            p.x = vars.s12 * Math.sin(azi1);
            p.y = vars.s12 * Math.cos(azi1);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, azi1, s12, vars;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
            } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz), this.over);
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            // default case
            azi1 = Math.atan2(p.x, p.y);
            s12 = Math.sqrt(p.x * p.x + p.y * p.y);
            vars = (0, $7StUg.vincentyDirect)(this.lat0, this.long0, azi1, s12, this.a, this.f);
            p.x = vars.lon2;
            p.y = vars.lat2;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    'Azimuthal_Equidistant',
    'aeqd'
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};

});
parcelRegister("7StUg", function(module, exports) {

$parcel$export(module.exports, "vincentyInverse", () => $5bc4c6541701a39b$export$56278523bd130841);
$parcel$export(module.exports, "vincentyDirect", () => $5bc4c6541701a39b$export$b5a922c94102a306);
/**
 * Calculates the inverse geodesic problem using Vincenty's formulae.
 * Computes the forward azimuth and ellipsoidal distance between two points
 * specified by latitude and longitude on the surface of an ellipsoid.
 *
 * @param {number} lat1 Latitude of the first point in radians.
 * @param {number} lon1 Longitude of the first point in radians.
 * @param {number} lat2 Latitude of the second point in radians.
 * @param {number} lon2 Longitude of the second point in radians.
 * @param {number} a Semi-major axis of the ellipsoid (meters).
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{ azi1: number, s12: number }} An object containing:
 *   - azi1: Forward azimuth from the first point to the second point (radians).
 *   - s12: Ellipsoidal distance between the two points (meters).
 */ function $5bc4c6541701a39b$export$56278523bd130841(lat1, lon1, lat2, lon2, a, f) {
    const L = lon2 - lon1;
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const U2 = Math.atan((1 - f) * Math.tan(lat2));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinU2 = Math.sin(U2), cosU2 = Math.cos(U2);
    let lambda = L, lambdaP, iterLimit = 100;
    let sinLambda, cosLambda, sinSigma, cosSigma, sigma, sinAlpha, cos2Alpha, cos2SigmaM, C;
    let uSq, A, B, deltaSigma, s;
    do {
        sinLambda = Math.sin(lambda);
        cosLambda = Math.cos(lambda);
        sinSigma = Math.sqrt(cosU2 * sinLambda * (cosU2 * sinLambda) + (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda) * (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
        if (sinSigma === 0) return {
            azi1: 0,
            s12: 0
        }; // coincident points
        cosSigma = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        sinAlpha = cosU1 * cosU2 * sinLambda / sinSigma;
        cos2Alpha = 1 - sinAlpha * sinAlpha;
        cos2SigmaM = cos2Alpha !== 0 ? cosSigma - 2 * sinU1 * sinU2 / cos2Alpha : 0;
        C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
        lambdaP = lambda;
        lambda = L + (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    }while (Math.abs(lambda - lambdaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        azi1: NaN,
        s12: NaN
    }; // formula failed to converge
    uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    s = a * (1 - f) * A * (sigma - deltaSigma);
    // Forward azimuth
    const azi1 = Math.atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
    return {
        azi1: azi1,
        s12: s
    };
}
function $5bc4c6541701a39b$export$b5a922c94102a306(lat1, lon1, azi1, s12, a, f) {
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinAlpha1 = Math.sin(azi1), cosAlpha1 = Math.cos(azi1);
    const sigma1 = Math.atan2(sinU1, cosU1 * cosAlpha1);
    const sinAlpha = cosU1 * sinAlpha1;
    const cos2Alpha = 1 - sinAlpha * sinAlpha;
    const uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    const A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    const B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    let sigma = s12 / (a * (1 - f) * A), sigmaP, iterLimit = 100;
    let cos2SigmaM, sinSigma, cosSigma, deltaSigma;
    do {
        cos2SigmaM = Math.cos(2 * sigma1 + sigma);
        sinSigma = Math.sin(sigma);
        cosSigma = Math.cos(sigma);
        deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
        sigmaP = sigma;
        sigma = s12 / (a * (1 - f) * A) + deltaSigma;
    }while (Math.abs(sigma - sigmaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        lat2: NaN,
        lon2: NaN
    };
    const tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
    const lat2 = Math.atan2(sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1, (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp));
    const lambda = Math.atan2(sinSigma * sinAlpha1, cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1);
    const C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
    const L = lambda - (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    const lon2 = lon1 + L;
    return {
        lat2: lat2,
        lon2: lon2
    };
}

});


parcelRegister("37G1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $24629f153ebf2c1f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    // double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    'ortho'
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};

});

parcelRegister("2XUb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $228cab2632c5bcf7$export$2e2bcd8739ae039);
// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/**
 * @typedef {Object} LocalThis
 * @property {number} face
 * @property {number} x0
 * @property {number} y0
 * @property {number} es
 * @property {number} one_minus_f
 * @property {number} one_minus_f_squared
 */ /* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Quadrilateralized Spherical Cube';
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; // lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    'Quadrilateralized Spherical Cube',
    'Quadrilateralized_Spherical_Cube',
    'qsc'
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};

});

parcelRegister("byZja", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b26d30d3579075$export$2e2bcd8739ae039);
// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || 'Robinson';
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0, this.over);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0, this.over);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    'Robinson',
    'robin'
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};

});

parcelRegister("Fj8jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2abe70612fbc5$export$2e2bcd8739ae039);

var $4YPx7 = parcelRequire("4YPx7");
function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = 'geocent';
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $4YPx7.geodeticToGeocentric)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $4YPx7.geocentricToGeodetic)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    'Geocentric',
    'geocentric',
    'geocent',
    'Geocent'
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};

});

parcelRegister("eJp9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab98c67e9f567a4b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $jU5gu = parcelRequire("jU5gu");
/**
 * @typedef {Object} LocalThis
 * @property {number} mode
 * @property {number} sinph0
 * @property {number} cosph0
 * @property {number} pn1
 * @property {number} h
 * @property {number} rp
 * @property {number} p
 * @property {number} h1
 * @property {number} pfact
 * @property {number} es
 * @property {number} tilt
 * @property {number} azi
 * @property {number} cg
 * @property {number} sg
 * @property {number} cw
 * @property {number} sw
 */ var $ab98c67e9f567a4b$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $ab98c67e9f567a4b$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $ab98c67e9f567a4b$export$2cd8252107eb640b() {
    Object.keys($ab98c67e9f567a4b$var$params).forEach((function(p) {
        if (typeof this[p] === 'undefined') this[p] = $ab98c67e9f567a4b$var$params[p].def;
        else if ($ab98c67e9f567a4b$var$params[p].num && isNaN(this[p])) throw new Error('Invalid parameter value, must be numeric ' + p + ' = ' + this[p]);
        else if ($ab98c67e9f567a4b$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($ab98c67e9f567a4b$var$params[p].degrees) this[p] = this[p] * (0, $gyVUi.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? $ab98c67e9f567a4b$var$mode.S_POLE : $ab98c67e9f567a4b$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $gyVUi.EPSLN)) this.mode = $ab98c67e9f567a4b$var$mode.EQUIT;
    else {
        this.mode = $ab98c67e9f567a4b$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error('Invalid height');
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $ab98c67e9f567a4b$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $ab98c67e9f567a4b$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $jU5gu.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $gyVUi.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $ab98c67e9f567a4b$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $ab98c67e9f567a4b$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $ab98c67e9f567a4b$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $ab98c67e9f567a4b$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $ab98c67e9f567a4b$export$e4b2ac9215619f8d = [
    'Tilted_Perspective',
    'tpers'
];
var $ab98c67e9f567a4b$export$2e2bcd8739ae039 = {
    init: $ab98c67e9f567a4b$export$2cd8252107eb640b,
    forward: $ab98c67e9f567a4b$export$174bb771924e7eb1,
    inverse: $ab98c67e9f567a4b$export$70ae2c07e401031b,
    names: $ab98c67e9f567a4b$export$e4b2ac9215619f8d
};

});

parcelRegister("jJ6PL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c7855edcbcda04$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");
function $e5c7855edcbcda04$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === 'x' ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = 'sphere'; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = 'Geostationary Satellite View';
}
function $e5c7855edcbcda04$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === 'ellipse') {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $jU5gu.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    } else if (this.shape === 'sphere') {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $e5c7855edcbcda04$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === 'ellipse') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === 'sphere') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $e5c7855edcbcda04$export$e4b2ac9215619f8d = [
    'Geostationary Satellite View',
    'Geostationary_Satellite',
    'geos'
];
var $e5c7855edcbcda04$export$2e2bcd8739ae039 = {
    init: $e5c7855edcbcda04$export$2cd8252107eb640b,
    forward: $e5c7855edcbcda04$var$forward,
    inverse: $e5c7855edcbcda04$var$inverse,
    names: $e5c7855edcbcda04$export$e4b2ac9215619f8d
};

});

parcelRegister("cbANR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df30f7b6f96e4d8$export$2e2bcd8739ae039);
/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $a9oRf = parcelRequire("a9oRf");
var $8df30f7b6f96e4d8$var$A1 = 1.340264, $8df30f7b6f96e4d8$var$A2 = -0.081106, $8df30f7b6f96e4d8$var$A3 = 0.000893, $8df30f7b6f96e4d8$var$A4 = 0.003796, $8df30f7b6f96e4d8$var$M = Math.sqrt(3) / 2.0;
function $8df30f7b6f96e4d8$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
}
function $8df30f7b6f96e4d8$export$174bb771924e7eb1(p) {
    var lam = (0, $a9oRf.default)(p.x - this.long0, this.over);
    var phi = p.y;
    var paramLat = Math.asin($8df30f7b6f96e4d8$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($8df30f7b6f96e4d8$var$M * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)));
    p.y = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $8df30f7b6f96e4d8$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq)) - p.y;
        fpy = $8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $8df30f7b6f96e4d8$var$M * p.x * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $8df30f7b6f96e4d8$var$M);
    p.x = (0, $a9oRf.default)(p.x + this.long0, this.over);
    return p;
}
var $8df30f7b6f96e4d8$export$e4b2ac9215619f8d = [
    'eqearth',
    'Equal Earth',
    'Equal_Earth'
];
var $8df30f7b6f96e4d8$export$2e2bcd8739ae039 = {
    init: $8df30f7b6f96e4d8$export$2cd8252107eb640b,
    forward: $8df30f7b6f96e4d8$export$174bb771924e7eb1,
    inverse: $8df30f7b6f96e4d8$export$70ae2c07e401031b,
    names: $8df30f7b6f96e4d8$export$e4b2ac9215619f8d
};

});

parcelRegister("gtZfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bffedda91368999e$export$2e2bcd8739ae039);

var $aDUFA = parcelRequire("aDUFA");

var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");

var $gqKpL = parcelRequire("gqKpL");

var $jQUK6 = parcelRequire("jQUK6");

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
/**
 * @typedef {Object} LocalThis
 * @property {number} phi1
 * @property {number} cphi1
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} m1
 * @property {number} am1
 */ var $bffedda91368999e$var$EPS10 = 1e-10;
function $bffedda91368999e$export$2cd8252107eb640b() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < $bffedda91368999e$var$EPS10) throw new Error();
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.m1 = (0, $hpUQm.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = $bffedda91368999e$var$e_inv;
        this.forward = $bffedda91368999e$var$e_fwd;
    } else {
        if (Math.abs(this.phi1) + $bffedda91368999e$var$EPS10 >= (0, $gyVUi.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = $bffedda91368999e$var$s_inv;
        this.forward = $bffedda91368999e$var$s_fwd;
    }
}
function $bffedda91368999e$var$e_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, $hpUQm.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, $jU5gu.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, $jQUK6.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, $gyVUi.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else throw new Error();
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
function $bffedda91368999e$var$s_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > $bffedda91368999e$var$EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, $jU5gu.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, $gyVUi.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
var $bffedda91368999e$export$e4b2ac9215619f8d = [
    'bonne',
    'Bonne (Werner lat_1=90)'
];
var $bffedda91368999e$export$2e2bcd8739ae039 = {
    init: $bffedda91368999e$export$2cd8252107eb640b,
    names: $bffedda91368999e$export$e4b2ac9215619f8d
};

});

parcelRegister("kU0qj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3795daa9f669a64$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $38qqf = parcelRequire("38qqf");

var $iMMJV = parcelRequire("iMMJV");
/**
    Original projection implementation:
        https://github.com/OSGeo/PROJ/blob/46c47e9adf6376ae06afabe5d24a0016a05ced82/src/projections/ob_tran.cpp

    Documentation:
        https://proj.org/operations/projections/ob_tran.html

    References/Formulas:
        https://pubs.usgs.gov/pp/1395/report.pdf

    Examples:
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=60
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=-90
*/ const $f3795daa9f669a64$var$projectionType = {
    OBLIQUE: {
        forward: $f3795daa9f669a64$var$forwardOblique,
        inverse: $f3795daa9f669a64$var$inverseOblique
    },
    TRANSVERSE: {
        forward: $f3795daa9f669a64$var$forwardTransverse,
        inverse: $f3795daa9f669a64$var$inverseTransverse
    }
};
/**
 * @typedef {Object} LocalThis
 * @property {number} lamp
 * @property {number} cphip
 * @property {number} sphip
 * @property {Object} projectionType
 * @property {string | undefined} o_proj
 * @property {string | undefined} o_lon_p
 * @property {string | undefined} o_lat_p
 * @property {string | undefined} o_alpha
 * @property {string | undefined} o_lon_c
 * @property {string | undefined} o_lat_c
 * @property {string | undefined} o_lon_1
 * @property {string | undefined} o_lat_1
 * @property {string | undefined} o_lon_2
 * @property {string | undefined} o_lat_2
 * @property {number | undefined} oLongP
 * @property {number | undefined} oLatP
 * @property {number | undefined} oAlpha
 * @property {number | undefined} oLongC
 * @property {number | undefined} oLatC
 * @property {number | undefined} oLong1
 * @property {number | undefined} oLat1
 * @property {number | undefined} oLong2
 * @property {number | undefined} oLat2
 * @property {boolean} isIdentity
 * @property {import('..').Converter} obliqueProjection
 *
 */ /**
 *    Parameters can be from the following sets:
 *       New pole --> o_lat_p, o_lon_p
 *       Rotate about point --> o_alpha, o_lon_c, o_lat_c
 *       New equator points --> lon_1, lat_1, lon_2, lat_2
 *
 *    Per the original source code, the parameter sets are
 *    checked in the order of the object below.
 */ const $f3795daa9f669a64$var$paramSets = {
    ROTATE: {
        o_alpha: 'oAlpha',
        o_lon_c: 'oLongC',
        o_lat_c: 'oLatC'
    },
    NEW_POLE: {
        o_lat_p: 'oLatP',
        o_lon_p: 'oLongP'
    },
    NEW_EQUATOR: {
        o_lon_1: 'oLong1',
        o_lat_1: 'oLat1',
        o_lon_2: 'oLong2',
        o_lat_2: 'oLat2'
    }
};
function $f3795daa9f669a64$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.title = this.title || 'General Oblique Transformation';
    this.isIdentity = (0, $iMMJV.names).includes(this.o_proj);
    /** Verify required parameters exist */ if (!this.o_proj) throw new Error('Missing parameter: o_proj');
    if (this.o_proj === `ob_tran`) throw new Error('Invalid value for o_proj: ' + this.o_proj);
    const newProjStr = this.projStr.replace('+proj=ob_tran', '').replace('+o_proj=', '+proj=').trim();
    /** @type {import('../defs.js').ProjectionDefinition} */ const oProj = (0, $38qqf.default)(newProjStr);
    if (!oProj) throw new Error('Invalid parameter: o_proj. Unknown projection ' + this.o_proj);
    oProj.long0 = 0; // we handle long0 before/after forward/inverse
    this.obliqueProjection = oProj;
    let matchedSet;
    const paramSetsKeys = Object.keys($f3795daa9f669a64$var$paramSets);
    /**
   * parse strings, convert to radians, throw on NaN
   * @param {string} name
   * @returns {number | undefined}
   */ const parseParam = (name)=>{
        if (typeof this[name] === `undefined`) return undefined;
        const val = parseFloat(this[name]) * (0, $gyVUi.D2R);
        if (isNaN(val)) throw new Error('Invalid value for ' + name + ': ' + this[name]);
        return val;
    };
    for(let i = 0; i < paramSetsKeys.length; i++){
        const setKey = paramSetsKeys[i];
        const set = $f3795daa9f669a64$var$paramSets[setKey];
        const params = Object.entries(set);
        const setHasParams = params.some(([p])=>typeof this[p] !== 'undefined');
        if (!setHasParams) continue;
        matchedSet = set;
        for(let ii = 0; ii < params.length; ii++){
            const [inputParam, param] = params[ii];
            const val = parseParam(inputParam);
            if (typeof val === 'undefined') throw new Error('Missing parameter: ' + inputParam + '.');
            this[param] = val;
        }
        break;
    }
    if (!matchedSet) throw new Error('No valid parameters provided for ob_tran projection.');
    const { lamp: lamp, phip: phip } = $f3795daa9f669a64$var$createRotation(this, matchedSet);
    this.lamp = lamp;
    if (Math.abs(phip) > (0, $gyVUi.EPSLN)) {
        this.cphip = Math.cos(phip);
        this.sphip = Math.sin(phip);
        this.projectionType = $f3795daa9f669a64$var$projectionType.OBLIQUE;
    } else this.projectionType = $f3795daa9f669a64$var$projectionType.TRANSVERSE;
}
function $f3795daa9f669a64$export$174bb771924e7eb1(p) {
    return this.projectionType.forward(this, p);
}
function $f3795daa9f669a64$export$70ae2c07e401031b(p) {
    return this.projectionType.inverse(this, p);
}
/**
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} params - Initialized projection definition
 * @param {Object} how - Transformation method
 * @returns {{phip: number, lamp: number}}
 */ function $f3795daa9f669a64$var$createRotation(params, how) {
    let phip, lamp;
    if (how === $f3795daa9f669a64$var$paramSets.ROTATE) {
        let lamc = params.oLongC;
        let phic = params.oLatC;
        let alpha = params.oAlpha;
        if (Math.abs(Math.abs(phic) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_c: ' + params.o_lat_c + " should be < 90\xb0");
        lamp = lamc + Math.atan2(-1 * Math.cos(alpha), -1 * Math.sin(alpha) * Math.sin(phic));
        phip = Math.asin(Math.cos(phic) * Math.sin(alpha));
    } else if (how === $f3795daa9f669a64$var$paramSets.NEW_POLE) {
        lamp = params.oLongP;
        phip = params.oLatP;
    } else {
        let lam1 = params.oLong1;
        let phi1 = params.oLat1;
        let lam2 = params.oLong2;
        let phi2 = params.oLat2;
        let con = Math.abs(phi1);
        if (Math.abs(phi1) > (0, $gyVUi.HALF_PI) - (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1: ' + params.o_lat_1 + " should be < 90\xb0");
        if (Math.abs(phi2) > (0, $gyVUi.HALF_PI) - (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_2: ' + params.o_lat_2 + " should be < 90\xb0");
        if (Math.abs(phi1 - phi2) < (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1 and o_lat_2: o_lat_1 should be different from o_lat_2');
        if (con < (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1: o_lat_1 should be different from zero');
        lamp = Math.atan2(Math.cos(phi1) * Math.sin(phi2) * Math.cos(lam1) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(lam2), Math.sin(phi1) * Math.cos(phi2) * Math.sin(lam2) - Math.cos(phi1) * Math.sin(phi2) * Math.sin(lam1));
        phip = Math.atan(-1 * Math.cos(lamp - lam1) / Math.tan(phi1));
    }
    return {
        lamp: lamp,
        phip: phip
    };
}
/**
 * Forward (lng, lat) to (x, y) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$forwardOblique(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const coslam = Math.cos(lam);
    const sinphi = Math.sin(phi);
    const cosphi = Math.cos(phi);
    lp.x = (0, $a9oRf.default)(Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam + self.cphip * sinphi) + self.lamp);
    lp.y = Math.asin(self.sphip * sinphi - self.cphip * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $gyVUi.R2D);
        result.y *= (0, $gyVUi.R2D);
    }
    return result;
}
/**
 * Forward (lng, lat) to (x, y) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$forwardTransverse(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const cosphi = Math.cos(phi);
    const coslam = Math.cos(lam);
    lp.x = (0, $a9oRf.default)(Math.atan2(cosphi * Math.sin(lam), Math.sin(phi)) + self.lamp);
    lp.y = Math.asin(-1 * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $gyVUi.R2D);
        result.y *= (0, $gyVUi.R2D);
    }
    return result;
}
/**
 * Inverse (x, y) to (lng, lat) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$inverseOblique(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $gyVUi.D2R);
        lp.y *= (0, $gyVUi.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        lam -= self.lamp;
        const coslam = Math.cos(lam);
        const sinphi = Math.sin(phi);
        const cosphi = Math.cos(phi);
        lp.x = Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam - self.cphip * sinphi);
        lp.y = Math.asin(self.sphip * sinphi + self.cphip * cosphi * coslam);
    }
    lp.x = (0, $a9oRf.default)(lp.x + self.long0);
    return lp;
}
/**
 * Inverse (x, y) to (lng, lat) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$inverseTransverse(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $gyVUi.D2R);
        lp.y *= (0, $gyVUi.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        const cosphi = Math.cos(phi);
        lam -= self.lamp;
        lp.x = Math.atan2(cosphi * Math.sin(lam), -1 * Math.sin(phi));
        lp.y = Math.asin(cosphi * Math.cos(lam));
    }
    lp.x = (0, $a9oRf.default)(lp.x + self.long0);
    return lp;
}
var $f3795daa9f669a64$export$e4b2ac9215619f8d = [
    'General Oblique Transformation',
    'General_Oblique_Transformation',
    'ob_tran'
];
var $f3795daa9f669a64$export$2e2bcd8739ae039 = {
    init: $f3795daa9f669a64$export$2cd8252107eb640b,
    forward: $f3795daa9f669a64$export$174bb771924e7eb1,
    inverse: $f3795daa9f669a64$export$70ae2c07e401031b,
    names: $f3795daa9f669a64$export$e4b2ac9215619f8d
};

});




var $8JYDX = parcelRequire("8JYDX");
var $125d88de280575d0$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $125d88de280575d0$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = '[data-choice]';
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn('Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.');
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
                        var passedElement = typeof element === 'string' ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError('Expected one of the following types text|select-one|select-multiple');
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            'auto',
                            'always'
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = 'auto';
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = '';
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, 'choices-');
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: 'item-choice'
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === '' || option.hasAttribute('placeholder'),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute('disabled');
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === 'function') callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = 'value';
                        if (label === void 0) label = 'label';
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === 'function') {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate('notice', canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === 'function' ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-results');
                            } else {
                                notice = typeof this.config.noChoicesText === 'function' ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-choices');
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === 'always' || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate('choiceGroup', group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === 'auto' ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate('choice', choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === 'auto' && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate('item', item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate('placeholder', this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || '';
                            } else this.input.placeholder = this._placeholderValue || '';
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== 'undefined' && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === 'function' ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === 'function' ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === 'function' ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === 'function' && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === 'function' ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === 'string' ? value.trim() : value;
                        var currentValue = typeof this._currentValue === 'string' ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.addEventListener('mousedown', this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener('click', this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener('touchmove', this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener('focus', this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener('blur', this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener('keyup', this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener('reset', this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener('mousedown', this._onMouseDown, true);
                        documentElement.removeEventListener('click', this._onClick);
                        documentElement.removeEventListener('touchmove', this._onTouchMove);
                        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener('focus', this._onFocus);
                            this.containerOuter.element.removeEventListener('blur', this._onBlur);
                        }
                        this.input.element.removeEventListener('keyup', this._onKeyUp);
                        this.input.element.removeEventListener('focus', this._onFocus);
                        this.input.element.removeEventListener('blur', this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener('reset', this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate('notice', canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute('data-button');
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = '[data-choice-selectable]';
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest('[data-button],[data-item],[data-choice]');
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ('button' in dataset) this._handleButtonAction(activeItems, item);
                            else if ('item' in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ('choice' in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll('[data-choice-selectable]'));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute('aria-selected', 'false');
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute('aria-selected', 'true');
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === 'string' ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === 'undefined' || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? 'value' : _b, _c = _a.labelKey, labelKey = _c === void 0 ? 'label' : _c;
                        var groupChoices = (0, utils_1.isType)('Object', group) ? group.choices : Array.from(group.getElementsByTagName('OPTION'));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)('Object', choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate('containerOuter', this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate('containerInner'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate('input', this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate('choiceList', this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate('itemList', this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate('dropdown'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || '';
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === 'SELECT') this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? '' : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === 'object' && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === 'string') _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener('focus', this._onFocus);
                        this.element.addEventListener('blur', this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== 'number') return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === 'auto') shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === 'top') shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute('aria-disabled');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '0');
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute('aria-disabled', 'true');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '-1');
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute('aria-busy', 'true');
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute('aria-busy');
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener('paste', this._onPaste);
                        this.element.addEventListener('input', this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('input', this._onInput);
                        this.element.removeEventListener('paste', this._onPaste);
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = '';
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = '';
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError('Invalid element passed');
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === 'active';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute('style');
                        if (origStyle) this.element.setAttribute('data-choice-orig-style', origStyle);
                        this.element.setAttribute('data-choice', 'active');
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute('tabindex');
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute('data-choice-orig-style');
                        if (origStyle) {
                            this.element.removeAttribute('data-choice-orig-style');
                            this.element.setAttribute('style', origStyle);
                        } else this.element.removeAttribute('style');
                        this.element.removeAttribute('data-choice');
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute('value', value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector('option[placeholder]');
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName('OPTGROUP'));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = '';
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: 'showDropdown',
                    hideDropdown: 'hideDropdown',
                    change: 'change',
                    choice: 'choice',
                    search: 'search',
                    addItem: 'addItem',
                    removeItem: 'removeItem',
                    highlightItem: 'highlightItem',
                    highlightChoice: 'highlightChoice',
                    unhighlightItem: 'unhighlightItem'
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: 'ADD_CHOICE',
                    FILTER_CHOICES: 'FILTER_CHOICES',
                    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
                    CLEAR_CHOICES: 'CLEAR_CHOICES',
                    ADD_GROUP: 'ADD_GROUP',
                    ADD_ITEM: 'ADD_ITEM',
                    REMOVE_ITEM: 'REMOVE_ITEM',
                    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
                    CLEAR_ALL: 'CLEAR_ALL',
                    RESET_TO: 'RESET_TO',
                    SET_IS_LOADING: 'SET_IS_LOADING'
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = 'text';
                exports.SELECT_ONE_TYPE = 'select-one';
                exports.SELECT_MULTIPLE_TYPE = 'select-multiple';
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: 'choices',
                    containerInner: 'choices__inner',
                    input: 'choices__input',
                    inputCloned: 'choices__input--cloned',
                    list: 'choices__list',
                    listItems: 'choices__list--multiple',
                    listSingle: 'choices__list--single',
                    listDropdown: 'choices__list--dropdown',
                    item: 'choices__item',
                    itemSelectable: 'choices__item--selectable',
                    itemDisabled: 'choices__item--disabled',
                    itemChoice: 'choices__item--choice',
                    placeholder: 'choices__placeholder',
                    group: 'choices__group',
                    groupHeading: 'choices__heading',
                    button: 'choices__button',
                    activeState: 'is-active',
                    focusState: 'is-focused',
                    openState: 'is-open',
                    disabledState: 'is-disabled',
                    highlightedState: 'is-highlighted',
                    selectedState: 'is-selected',
                    flippedState: 'is-flipped',
                    loadingState: 'is-loading',
                    noResults: 'has-no-results',
                    noChoices: 'has-no-choices'
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ',',
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        'label',
                        'value'
                    ],
                    position: 'auto',
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: 'auto',
                    loadingText: 'Loading...',
                    noResultsText: 'No results found',
                    noChoicesText: 'No choices to choose from',
                    itemSelectText: 'Press to select',
                    uniqueItemText: 'Only unique values can be added',
                    customAddItemText: 'Only values matching specific conditions can be added',
                    addItemText: function(value) {
                        return "Press Enter to add <b>\"".concat((0, utils_1.sanitise)(value), "\"</b>");
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: '',
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join('');
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, '');
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement('div');
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== 'string') return value;
                    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement('div');
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: 'base',
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = 'value';
                    return array.some(function(item) {
                        if (typeof value === 'string') return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== 'undefined') try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_CHOICE':
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case 'ADD_ITEM':
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case 'REMOVE_ITEM':
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case 'FILTER_CHOICES':
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case 'ACTIVATE_CHOICES':
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case 'CLEAR_CHOICES':
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_GROUP':
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case 'CLEAR_CHOICES':
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === 'CLEAR_ALL') state = exports.defaultState;
                    else if (action.type === 'RESET_TO') return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_ITEM':
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case 'REMOVE_ITEM':
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case 'HIGHLIGHT_ITEM':
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'SET_IS_LOADING':
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement('div'), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
                        }
                        div.setAttribute('aria-haspopup', 'true');
                        div.setAttribute('aria-expanded', 'false');
                        if (labelId) div.setAttribute('aria-labelledby', labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement('div'), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement('div'), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement('div'), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? 'innerHTML' : 'innerText'] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            className: item
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c));
                        Object.assign(div.dataset, {
                            item: '',
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute('aria-selected', 'true');
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = '';
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = 'Remove item';
                            var removeButton = Object.assign(document.createElement('button'), (_d = {
                                type: 'button',
                                className: button
                            }, _d[allowHTML ? 'innerHTML' : 'innerText'] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute('aria-label', "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = '';
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement('div'), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
                        div.setAttribute('role', 'listbox');
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement('div'), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : '')
                        });
                        div.setAttribute('role', 'group');
                        Object.assign(div.dataset, {
                            group: '',
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        div.appendChild(Object.assign(document.createElement('div'), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            id: elementId
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute('role', groupId && groupId > 0 ? 'treeitem' : 'option');
                        Object.assign(div.dataset, {
                            choice: '',
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = '';
                            div.setAttribute('aria-disabled', 'true');
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = '';
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement('input'), {
                            type: 'search',
                            name: 'search_terms',
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: 'off',
                            autocapitalize: 'off',
                            spellcheck: false
                        });
                        inp.setAttribute('role', 'textbox');
                        inp.setAttribute('aria-autocomplete', 'list');
                        inp.setAttribute('aria-label', placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement('div');
                        div.classList.add(list, listDropdown);
                        div.setAttribute('aria-expanded', 'false');
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = '';
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === 'no-choices') classes.push(noChoices);
                        else if (type === 'no-results') classes.push(noResults);
                        return Object.assign(document.createElement('div'), (_b = {}, _b[allowHTML ? 'innerHTML' : 'innerText'] = innerText, _b.className = classes.join(' '), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === 'object';
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === 'function' ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error('first argument should be an array');
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == 'string') return value;
                    let result = value + '';
                    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }
                function toString(value) {
                    return value == null ? '' : baseToString(value);
                }
                function isString(value) {
                    return typeof value === 'string';
                }
                function isNumber(value) {
                    return typeof value === 'number';
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
                }
                function isObject(value) {
                    return typeof value === 'object';
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, 'name')) throw new Error(MISSING_KEY_PROPERTY('name'));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, 'weight')) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split('.');
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join('.') : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split('.') : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'exact';
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'prefix-exact';
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-prefix-exact';
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'suffix-exact';
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-suffix-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return 'fuzzy';
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'include';
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = '|';
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: '$and',
                    OR: '$or'
                };
                const KeyType = {
                    PATH: '$path',
                    PATTERN: '$val'
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = '6.6.2';
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split('').join('.');
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== 'object' || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return 'undefined';
                    if (val === null) return 'null';
                    var type = typeof val;
                    switch(type){
                        case 'boolean':
                        case 'string':
                        case 'number':
                        case 'symbol':
                        case 'function':
                            return type;
                    }
                    if (Array.isArray(val)) return 'array';
                    if (isDate(val)) return 'date';
                    if (isError(val)) return 'error';
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case 'Symbol':
                        case 'Promise':
                        case 'WeakMap':
                        case 'WeakSet':
                        case 'Map':
                        case 'Set':
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
                }
                function ctorName(val) {
                    return typeof val.constructor === 'function' ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== 'undefined') {
                        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === 'undefined') {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


var $ce7d8f23dd6ea532$exports = {};
$ce7d8f23dd6ea532$exports = import.meta.resolve("4Eweb");


var $3c13b92efe6fa458$exports = {};
$3c13b92efe6fa458$exports = import.meta.resolve("iniyU");


var $41fc4b5b4201dc02$exports = {};
$41fc4b5b4201dc02$exports = import.meta.resolve("6z4h0");


var $d701e9e9e65fbcf7$exports = {};
$d701e9e9e65fbcf7$exports = import.meta.resolve("3srhT");


async function $057bcfcec5498507$export$2e2bcd8739ae039() {
    // Paths to GeoJSONs
    // prettier-ignore
    const pathCountries = new URL($ce7d8f23dd6ea532$exports);
    // prettier-ignore
    const pathContinental = new URL($3c13b92efe6fa458$exports);
    // prettier-ignore
    const pathEcoregions = new URL($41fc4b5b4201dc02$exports);
    // prettier-ignore
    const pathGADM = new URL($d701e9e9e65fbcf7$exports);
    const [countries, biomes, ecoregions, gadm] = await Promise.all([
        fetch(pathCountries).then((res)=>res.json()),
        fetch(pathContinental).then((res)=>res.json()),
        fetch(pathEcoregions).then((res)=>res.json()),
        fetch(pathGADM).then((res)=>res.json())
    ]);
    // Return promises
    return [
        countries,
        biomes,
        ecoregions,
        gadm
    ];
}



var $8JYDX = parcelRequire("8JYDX");
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ''));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, '');
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? 'element' : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(',') : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = 'alert';
const $e9dd36436aec3b21$var$DATA_KEY$a = 'bs.alert';
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = 'button';
const $e9dd36436aec3b21$var$DATA_KEY$9 = 'bs.button';
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = '.data-api';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = 'swipe';
const $e9dd36436aec3b21$var$EVENT_KEY$9 = '.bs.swipe';
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = 'touch';
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = 'pen';
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = 'carousel';
const $e9dd36436aec3b21$var$DATA_KEY$8 = 'bs.carousel';
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = '.data-api';
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = 'next';
const $e9dd36436aec3b21$var$ORDER_PREV = 'prev';
const $e9dd36436aec3b21$var$DIRECTION_LEFT = 'left';
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = 'right';
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = 'carousel';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = 'slide';
const $e9dd36436aec3b21$var$CLASS_NAME_END = 'carousel-item-end';
const $e9dd36436aec3b21$var$CLASS_NAME_START = 'carousel-item-start';
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = '.active';
const $e9dd36436aec3b21$var$SELECTOR_ITEM = '.carousel-item';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = 'collapse';
const $e9dd36436aec3b21$var$DATA_KEY$7 = 'bs.collapse';
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = 'collapse';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $e9dd36436aec3b21$var$WIDTH = 'width';
const $e9dd36436aec3b21$var$HEIGHT = 'height';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = 'dropdown';
const $e9dd36436aec3b21$var$DATA_KEY$6 = 'bs.dropdown';
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = 'Escape';
const $e9dd36436aec3b21$var$TAB_KEY$1 = 'Tab';
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = 'dropup';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = 'dropend';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = 'dropstart';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = '.navbar';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? 'top-end' : 'top-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? 'top-start' : 'top-end';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? 'left-start' : 'right-start';
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? 'right-start' : 'left-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = 'top';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = 'backdrop';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = 'show';
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = 'focustrap';
const $e9dd36436aec3b21$var$DATA_KEY$5 = 'bs.focustrap';
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = 'Tab';
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = 'forward';
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = 'backward';
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $e9dd36436aec3b21$var$PROPERTY_PADDING = 'padding-right';
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = 'modal';
const $e9dd36436aec3b21$var$DATA_KEY$4 = 'bs.modal';
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = 'Escape';
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = 'modal-open';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = 'modal-static';
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = '.modal.show';
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = '.modal-dialog';
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = '.modal-body';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = 'offcanvas';
const $e9dd36436aec3b21$var$DATA_KEY$3 = 'bs.offcanvas';
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = 'Escape';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = 'showing';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = 'hiding';
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $e9dd36436aec3b21$var$OPEN_SELECTOR = '.offcanvas.show';
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = 'TemplateFactory';
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = 'tooltip';
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = 'modal';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $e9dd36436aec3b21$var$TRIGGER_HOVER = 'hover';
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = 'focus';
const $e9dd36436aec3b21$var$TRIGGER_CLICK = 'click';
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = 'manual';
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = 'hide';
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = 'hidden';
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = 'shown';
const $e9dd36436aec3b21$var$EVENT_INSERTED = 'inserted';
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = 'click';
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = 'focusin';
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = 'focusout';
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = 'mouseenter';
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = 'mouseleave';
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $e9dd36436aec3b21$var$isRTL() ? 'right' : 'left'
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = 'popover';
const $e9dd36436aec3b21$var$SELECTOR_TITLE = '.popover-header';
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = '.popover-body';
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = 'scrollspy';
const $e9dd36436aec3b21$var$DATA_KEY$2 = 'bs.scrollspy';
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = '.data-api';
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = '[href]';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = '.nav-link';
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = '.dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = 'tab';
const $e9dd36436aec3b21$var$DATA_KEY$1 = 'bs.tab';
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $e9dd36436aec3b21$var$ARROW_UP_KEY = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = 'ArrowDown';
const $e9dd36436aec3b21$var$HOME_KEY = 'Home';
const $e9dd36436aec3b21$var$END_KEY = 'End';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = 'show';
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = 'dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = 'toast';
const $e9dd36436aec3b21$var$DATA_KEY = 'bs.toast';
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = 'showing';
const $e9dd36436aec3b21$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);


var $2a9498df2b5d3cfc$exports = {};


(function(factory) {
    var L, proj4;
    if (typeof define === 'function' && define.amd) // AMD
    define([
        'leaflet',
        'proj4'
    ], factory);
    else if (typeof $2a9498df2b5d3cfc$exports === "object") {
        // Node/CommonJS
        L = (parcelRequire("8JYDX"));
        proj4 = (parcelRequire("ebcW3"));
        $2a9498df2b5d3cfc$exports = factory(L, proj4);
    } else {
        // Browser globals
        if (typeof window.L === 'undefined' || typeof window.proj4 === 'undefined') throw 'Leaflet and proj4 must be loaded first';
        factory(window.L, window.proj4);
    }
})(function(L, proj4) {
    if (proj4.__esModule && proj4.default) // If proj4 was bundled as an ES6 module, unwrap it to get
    // to the actual main proj4 object.
    // See discussion in https://github.com/kartena/Proj4Leaflet/pull/147
    proj4 = proj4.default;
    L.Proj = {};
    L.Proj._isProj4Obj = function(a) {
        return typeof a.inverse !== 'undefined' && typeof a.forward !== 'undefined';
    };
    L.Proj.Projection = L.Class.extend({
        initialize: function(code, def, bounds) {
            var isP4 = L.Proj._isProj4Obj(code);
            this._proj = isP4 ? code : this._projFromCodeDef(code, def);
            this.bounds = isP4 ? def : bounds;
        },
        project: function(latlng) {
            var point = this._proj.forward([
                latlng.lng,
                latlng.lat
            ]);
            return new L.Point(point[0], point[1]);
        },
        unproject: function(point, unbounded) {
            var point2 = this._proj.inverse([
                point.x,
                point.y
            ]);
            return new L.LatLng(point2[1], point2[0], unbounded);
        },
        _projFromCodeDef: function(code, def) {
            if (def) proj4.defs(code, def);
            else if (proj4.defs[code] === undefined) {
                var urn = code.split(':');
                if (urn.length > 3) code = urn[urn.length - 3] + ':' + urn[urn.length - 1];
                if (proj4.defs[code] === undefined) throw 'No projection definition for code ' + code;
            }
            return proj4(code);
        }
    });
    L.Proj.CRS = L.Class.extend({
        includes: L.CRS,
        options: {
            transformation: new L.Transformation(1, 0, -1, 0)
        },
        initialize: function(a, b, c) {
            var code, proj, def, options;
            if (L.Proj._isProj4Obj(a)) {
                proj = a;
                code = proj.srsCode;
                options = b || {};
                this.projection = new L.Proj.Projection(proj, options.bounds);
            } else {
                code = a;
                def = b;
                options = c || {};
                this.projection = new L.Proj.Projection(code, def, options.bounds);
            }
            L.Util.setOptions(this, options);
            this.code = code;
            this.transformation = this.options.transformation;
            if (this.options.origin) this.transformation = new L.Transformation(1, -this.options.origin[0], -1, this.options.origin[1]);
            if (this.options.scales) this._scales = this.options.scales;
            else if (this.options.resolutions) {
                this._scales = [];
                for(var i = this.options.resolutions.length - 1; i >= 0; i--)if (this.options.resolutions[i]) this._scales[i] = 1 / this.options.resolutions[i];
            }
            this.infinite = !this.options.bounds;
        },
        scale: function(zoom) {
            var iZoom = Math.floor(zoom), baseScale, nextScale, scaleDiff, zDiff;
            if (zoom === iZoom) return this._scales[zoom];
            else {
                // Non-integer zoom, interpolate
                baseScale = this._scales[iZoom];
                nextScale = this._scales[iZoom + 1];
                scaleDiff = nextScale - baseScale;
                zDiff = zoom - iZoom;
                return baseScale + scaleDiff * zDiff;
            }
        },
        zoom: function(scale) {
            // Find closest number in this._scales, down
            var downScale = this._closestElement(this._scales, scale), downZoom = this._scales.indexOf(downScale), nextScale, nextZoom, scaleDiff;
            // Check if scale is downScale => return array index
            if (scale === downScale) return downZoom;
            if (downScale === undefined) return -Infinity;
            // Interpolate
            nextZoom = downZoom + 1;
            nextScale = this._scales[nextZoom];
            if (nextScale === undefined) return Infinity;
            scaleDiff = nextScale - downScale;
            return (scale - downScale) / scaleDiff + downZoom;
        },
        distance: L.CRS.Earth.distance,
        R: L.CRS.Earth.R,
        /* Get the closest lowest element in an array */ _closestElement: function(array, element) {
            var low;
            for(var i = array.length; i--;)if (array[i] <= element && (low === undefined || low < array[i])) low = array[i];
            return low;
        }
    });
    L.Proj.GeoJSON = L.GeoJSON.extend({
        initialize: function(geojson, options) {
            this._callLevel = 0;
            L.GeoJSON.prototype.initialize.call(this, geojson, options);
        },
        addData: function(geojson) {
            var crs;
            if (geojson) {
                if (geojson.crs && geojson.crs.type === 'name') crs = new L.Proj.CRS(geojson.crs.properties.name);
                else if (geojson.crs && geojson.crs.type) crs = new L.Proj.CRS(geojson.crs.type + ':' + geojson.crs.properties.code);
                if (crs !== undefined) this.options.coordsToLatLng = function(coords) {
                    var point = L.point(coords[0], coords[1]);
                    return crs.projection.unproject(point);
                };
            }
            // Base class' addData might call us recursively, but
            // CRS shouldn't be cleared in that case, since CRS applies
            // to the whole GeoJSON, inluding sub-features.
            this._callLevel++;
            try {
                L.GeoJSON.prototype.addData.call(this, geojson);
            } finally{
                this._callLevel--;
                if (this._callLevel === 0) delete this.options.coordsToLatLng;
            }
        }
    });
    L.Proj.geoJson = function(geojson, options) {
        return new L.Proj.GeoJSON(geojson, options);
    };
    L.Proj.ImageOverlay = L.ImageOverlay.extend({
        initialize: function(url, bounds, options) {
            L.ImageOverlay.prototype.initialize.call(this, url, null, options);
            this._projectedBounds = bounds;
        },
        // Danger ahead: Overriding internal methods in Leaflet.
        // Decided to do this rather than making a copy of L.ImageOverlay
        // and doing very tiny modifications to it.
        // Future will tell if this was wise or not.
        _animateZoom: function(event) {
            var scale = this._map.getZoomScale(event.zoom);
            var northWest = L.point(this._projectedBounds.min.x, this._projectedBounds.max.y);
            var offset = this._projectedToNewLayerPoint(northWest, event.zoom, event.center);
            L.DomUtil.setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var zoom = this._map.getZoom();
            var pixelOrigin = this._map.getPixelOrigin();
            var bounds = L.bounds(this._transform(this._projectedBounds.min, zoom)._subtract(pixelOrigin), this._transform(this._projectedBounds.max, zoom)._subtract(pixelOrigin));
            var size = bounds.getSize();
            L.DomUtil.setPosition(this._image, bounds.min);
            this._image.style.width = size.x + 'px';
            this._image.style.height = size.y + 'px';
        },
        _projectedToNewLayerPoint: function(point, zoom, center) {
            var viewHalf = this._map.getSize()._divideBy(2);
            var newTopLeft = this._map.project(center, zoom)._subtract(viewHalf)._round();
            var topLeft = newTopLeft.add(this._map._getMapPanePos());
            return this._transform(point, zoom)._subtract(topLeft);
        },
        _transform: function(point, zoom) {
            var crs = this._map.options.crs;
            var transformation = crs.transformation;
            var scale = crs.scale(zoom);
            return transformation.transform(point, scale);
        }
    });
    L.Proj.imageOverlay = function(url, bounds, options) {
        return new L.Proj.ImageOverlay(url, bounds, options);
    };
    return L.Proj;
});


/*
 leaflet.responsive.popup 1.0.0
 (c) 20222 https://github.com/yafred
*/ var $c9fbb13121e97103$export$ccfdee0fbd1573b;
var $c9fbb13121e97103$export$713eca98442a58b5;
L.ResponsivePopup = L.Popup.extend({
    options: {
        hasTip: true
    },
    /**
	 * Overrides https://github.com/Leaflet/Leaflet/blob/399ed2105220f10b79e69b57420597e03502e611/src/layer/Popup.js#L183
	 * This is to add hasTip option
	 */ _initLayout: function() {
        var prefix = 'leaflet-popup', container = this._container = L.DomUtil.create('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
        var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
        this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(this._contentNode);
        L.DomEvent.on(container, 'contextmenu', L.DomEvent.stopPropagation);
        this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
        if (!this.options.hasTip) this._tipContainer.style.visibility = 'hidden';
        this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
        if (this.options.closeButton) {
            var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
            closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
            closeButton.setAttribute('aria-label', 'Close popup');
            closeButton.href = '#close';
            closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
            L.DomEvent.on(closeButton, 'click', function(ev) {
                L.DomEvent.preventDefault(ev);
                this.close();
            }, this);
        }
    },
    /**
	 * Overrides https://github.com/Leaflet/Leaflet/blob/v1.3.4/src/layer/DivOverlay.js#L178
	 */ _updatePosition: function() {
        if (!this._map) return;
        var pos = this._map.latLngToLayerPoint(this._latlng), basePoint = this._map.layerPointToContainerPoint(pos), containerWidth = this._container.offsetWidth, containerHeight = this._container.offsetHeight, padding = L.point(this.options.autoPanPadding), paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding), paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding), mapSize = this._map.getSize(), anchor = this._getAnchor(), offset = L.point(this.options.offset); // offset relative to anchor (option from L.DivOverlay. We only use absolute values).
        // Leaflet default dimensions (should not be hard coded in the future)
        var tipHeight = 11; //px
        var tipWidth = 22; //px
        var containerRadius = 12; //px  
        // Tweak offset to include tip dimensions 
        var offsetX = Math.abs(offset.x);
        var offsetY = Math.abs(offset.y);
        if (this.options.hasTip) {
            offsetX += tipHeight;
            offsetY += tipHeight;
            // clear CSS
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east-south');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west-south');
        // this._container.style.display = 'initial'; // this does not work
        }
        // Where can we fit the popup ?
        var canGoTop = true, canGoBottom = true, canGoLeft = true, canGoRight = true, containerPos = false;
        if (basePoint.y + anchor.y - offsetY - containerHeight - Math.abs(paddingTL.y) < 0) canGoTop = false;
        if (basePoint.y + anchor.y + offsetY + containerHeight + Math.abs(paddingBR.y) > mapSize.y) canGoBottom = false;
        if (basePoint.x + anchor.x - offsetX - containerWidth - Math.abs(paddingTL.x) < 0) canGoLeft = false;
        if (basePoint.x + anchor.x + offsetX + containerWidth + Math.abs(paddingBR.x) > mapSize.x) canGoRight = false;
        // manage overflows
        var subtractX = containerWidth / 2 - anchor.x, subtractY = containerHeight / 2 - anchor.y;
        if (canGoTop || canGoBottom) {
            var containerLeft = basePoint.x + anchor.x - containerWidth / 2;
            var containerRight = basePoint.x + anchor.x + containerWidth / 2;
            if (containerLeft < Math.abs(paddingTL.x)) subtractX = containerWidth / 2 - anchor.x - Math.abs(paddingTL.x) + containerLeft;
            if (containerRight > mapSize.x - Math.abs(paddingBR.x)) subtractX = containerWidth / 2 - anchor.x + containerRight - mapSize.x + Math.abs(paddingBR.x);
        }
        if (canGoLeft || canGoRight) {
            var containerTop = basePoint.y + anchor.y - containerHeight / 2;
            var containerBottom = basePoint.y + anchor.y + containerHeight / 2;
            if (containerTop < Math.abs(paddingTL.y)) subtractY = containerHeight / 2 - anchor.y - Math.abs(paddingTL.y) + containerTop;
            if (containerBottom > mapSize.y - Math.abs(paddingBR.y)) subtractY = containerHeight / 2 - anchor.y + containerBottom - mapSize.y + Math.abs(paddingBR.y);
        }
        // position the popup (order of preference is: top, left, bottom, right, centerOnMap)
        if (canGoTop) {
            containerPos = pos.subtract(L.point(subtractX, -anchor.y + containerHeight + offsetY, true));
            if (this.options.hasTip) {
                if (basePoint.x + anchor.x < paddingTL.x + containerRadius + tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north-east');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.x + anchor.x > mapSize.x - paddingBR.x - containerRadius - tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x - containerWidth;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north-west');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = pos.x + anchor.x - containerPos.x + 'px';
                }
            }
        } else if (canGoLeft) {
            containerPos = pos.subtract(L.point(-anchor.x + containerWidth + offsetX, subtractY, true));
            if (this.options.hasTip) {
                if (basePoint.y + anchor.y < paddingTL.y + containerRadius + tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else if (basePoint.y + anchor.y > mapSize.y - paddingBR.y - containerRadius - tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y - containerHeight;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west');
                    this._tipContainer.style.top = pos.y + anchor.y - containerPos.y + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                }
            }
        } else if (canGoBottom) {
            containerPos = pos.subtract(L.point(subtractX, -anchor.y - offsetY, true));
            if (this.options.hasTip) {
                if (basePoint.x + anchor.x < paddingTL.x + containerRadius + tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south-east');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.x + anchor.x > mapSize.x - paddingBR.x - containerRadius - tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x - containerWidth;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south-west');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = pos.x + anchor.x - containerPos.x + 'px';
                }
            }
        } else if (canGoRight) {
            containerPos = pos.subtract(L.point(-anchor.x - offsetX, subtractY, true));
            if (this.options.hasTip) {
                if (basePoint.y + anchor.y < paddingTL.y + containerRadius + tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.y + anchor.y > mapSize.y - paddingBR.y - containerRadius - tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y - containerHeight;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = '0px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east');
                    this._tipContainer.style.top = pos.y + anchor.y - containerPos.y + 'px';
                    this._tipContainer.style.left = '0px';
                }
            }
        } else {
            var pos = this._map.latLngToLayerPoint(this._map.getCenter());
            containerPos = pos.subtract(L.point(containerWidth / 2, containerHeight / 2));
            this.options.hasTip;
        }
        // if point is not visible, just hide the popup
        basePoint.x < 0 || basePoint.y < 0 || basePoint.x > mapSize.x || (basePoint.y, mapSize.y);
        // if container is too big, just hide the popup
        containerWidth - Math.abs(paddingTL.x) - Math.abs(paddingBR.x) > mapSize.x || (paddingTL.y, paddingBR.y, mapSize.y);
        L.DomUtil.setPosition(this._container, containerPos);
    }
});
//Instantiates a `ResponsivePopup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
L.responsivePopup = function(options, source) {
    return new L.ResponsivePopup(options, source);
};
$c9fbb13121e97103$export$ccfdee0fbd1573b = L.responsivePopup;
$c9fbb13121e97103$export$713eca98442a58b5 = L.ResponsivePopup;


var $549f5169b246c417$exports = {};
!function(e, t) {
    t($549f5169b246c417$exports);
}($549f5169b246c417$exports, function(e) {
    "use strict";
    var t = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function n(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }
    var o = n(function(e, n) {
        !function(t) {
            const n = {
                escape: function(e) {
                    return e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
                },
                parseExtension: o,
                mimeType: function(e) {
                    return e = o(e).toLowerCase(), function() {
                        var e = "application/font-woff", t = "image/jpeg";
                        return {
                            woff: e,
                            woff2: e,
                            ttf: "application/font-truetype",
                            eot: "application/vnd.ms-fontobject",
                            png: "image/png",
                            jpg: t,
                            jpeg: t,
                            gif: "image/gif",
                            tiff: "image/tiff",
                            svg: "image/svg+xml"
                        };
                    }()[e] || "";
                },
                dataAsUrl: function(e, t) {
                    return `data:${t};base64,` + e;
                },
                isDataUrl: function(e) {
                    return -1 !== e.search(/^(data:)/);
                },
                canvasToBlob: function(e) {
                    var t;
                    return e.toBlob ? new Promise(function(t) {
                        e.toBlob(t);
                    }) : (t = e, new Promise(function(e) {
                        const n = d(t.toDataURL().split(",")[1]);
                        var o = n.length;
                        const r = new Uint8Array(o);
                        for(let e = 0; e < o; e++)r[e] = n.charCodeAt(e);
                        e(new Blob([
                            r
                        ], {
                            type: "image/png"
                        }));
                    }));
                },
                resolveUrl: function(e, t) {
                    const n = document.implementation.createHTMLDocument(), o = n.createElement("base"), r = (n.head.appendChild(o), n.createElement("a"));
                    return n.body.appendChild(r), o.href = t, r.href = e, r.href;
                },
                getAndEncode: function(e) {
                    let t = h.impl.urlCache.find(function(t) {
                        return t.url === e;
                    });
                    return t || (t = {
                        url: e,
                        promise: null
                    }, h.impl.urlCache.push(t)), null === t.promise && (h.impl.options.cacheBust && (e += (/\?/.test(e) ? "&" : "?") + (new Date).getTime()), t.promise = new Promise(function(t) {
                        const n = h.impl.options.httpTimeout, o = new XMLHttpRequest;
                        let r;
                        var i;
                        function a(e) {
                            console.error(e), t("");
                        }
                        o.onreadystatechange = function() {
                            if (4 === o.readyState) {
                                if (200 !== o.status) r ? t(r) : a(`cannot fetch resource: ${e}, status: ` + o.status);
                                else {
                                    const e = new FileReader;
                                    e.onloadend = function() {
                                        var n = e.result.split(/,/)[1];
                                        t(n);
                                    }, e.readAsDataURL(o.response);
                                }
                            }
                        }, o.ontimeout = function() {
                            r ? t(r) : a(`timeout of ${n}ms occured while fetching resource: ` + e);
                        }, o.responseType = "blob", o.timeout = n, h.impl.options.useCredentials && (o.withCredentials = !0), o.open("GET", e, !0), o.send(), h.impl.options.imagePlaceholder && (i = h.impl.options.imagePlaceholder.split(/,/)) && i[1] && (r = i[1]);
                    })), t.promise;
                },
                uid: function() {
                    let e = 0;
                    return function() {
                        return "u" + ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) + e++;
                    };
                }(),
                delay: function(e) {
                    return function(t) {
                        return new Promise(function(n) {
                            setTimeout(function() {
                                n(t);
                            }, e);
                        });
                    };
                },
                asArray: function(e) {
                    const t = [], n = e.length;
                    for(let o = 0; o < n; o++)t.push(e[o]);
                    return t;
                },
                escapeXhtml: function(e) {
                    return e.replace(/%/g, "%25").replace(/#/g, "%23").replace(/\n/g, "%0A");
                },
                makeImage: function(e) {
                    return "data:," !== e ? new Promise(function(t, n) {
                        const o = new Image;
                        h.impl.options.useCredentials && (o.crossOrigin = "use-credentials"), o.onload = function() {
                            t(o);
                        }, o.onerror = n, o.src = e;
                    }) : Promise.resolve();
                },
                width: function(e) {
                    var t = r(e, "border-left-width"), n = r(e, "border-right-width");
                    return e.scrollWidth + t + n;
                },
                height: function(e) {
                    var t = r(e, "border-top-width"), n = r(e, "border-bottom-width");
                    return e.scrollHeight + t + n;
                }
            };
            function o(e) {
                return (e = /\.([^\.\/]*?)(\?|$)/g.exec(e)) ? e[1] : "";
            }
            function r(e, t) {
                const n = f(e).getPropertyValue(t);
                return parseFloat(n.replace("px", ""));
            }
            const i = function() {
                const e = /url\(['"]?([^'"]+?)['"]?\)/g;
                return {
                    inlineAll: function(e, n, i) {
                        return t(e) ? Promise.resolve(e).then(o).then(function(t) {
                            let o = Promise.resolve(e);
                            return t.forEach(function(e) {
                                o = o.then(function(t) {
                                    return r(t, e, n, i);
                                });
                            }), o;
                        }) : Promise.resolve(e);
                    },
                    shouldProcess: t,
                    impl: {
                        readUrls: o,
                        inline: r
                    }
                };
                function t(t) {
                    return -1 !== t.search(e);
                }
                function o(t) {
                    const o = [];
                    for(var r; null !== (r = e.exec(t));)o.push(r[1]);
                    return o.filter(function(e) {
                        return !n.isDataUrl(e);
                    });
                }
                function r(e, t, o, r) {
                    return Promise.resolve(t).then(function(e) {
                        return o ? n.resolveUrl(e, o) : e;
                    }).then(r || n.getAndEncode).then(function(e) {
                        return n.dataAsUrl(e, n.mimeType(t));
                    }).then(function(o) {
                        var r;
                        return e.replace((r = t, new RegExp(`(url\\(['"]?)(${n.escape(r)})(['"]?\\))`, "g")), `$1${o}$3`);
                    });
                }
            }(), a = {
                resolveAll: function() {
                    return s().then(function(e) {
                        return Promise.all(e.map(function(e) {
                            return e.resolve();
                        }));
                    }).then(function(e) {
                        return e.join("\n");
                    });
                },
                impl: {
                    readAll: s
                }
            };
            function s() {
                return Promise.resolve(n.asArray(document.styleSheets)).then(function(e) {
                    const t = [];
                    return e.forEach(function(e) {
                        if (Object.getPrototypeOf(e).hasOwnProperty("cssRules")) try {
                            n.asArray(e.cssRules || []).forEach(t.push.bind(t));
                        } catch (t) {
                            console.log("Error while reading CSS rules from " + e.href, t.toString());
                        }
                    }), t;
                }).then(function(e) {
                    return e.filter(function(e) {
                        return e.type === CSSRule.FONT_FACE_RULE;
                    }).filter(function(e) {
                        return i.shouldProcess(e.style.getPropertyValue("src"));
                    });
                }).then(function(t) {
                    return t.map(e);
                });
                function e(e) {
                    return {
                        resolve: function() {
                            var t = (e.parentStyleSheet || {}).href;
                            return i.inlineAll(e.cssText, t);
                        },
                        src: function() {
                            return e.style.getPropertyValue("src");
                        }
                    };
                }
            }
            const c = {
                inlineAll: function e(t) {
                    return t instanceof Element ? (function(e) {
                        const t = e.style.getPropertyValue("background");
                        return t ? i.inlineAll(t).then(function(n) {
                            e.style.setProperty("background", n, t);
                        }).then(function() {
                            return e;
                        }) : Promise.resolve(e);
                    })(t).then(function() {
                        return t instanceof HTMLImageElement ? l(t).inline() : Promise.all(n.asArray(t.childNodes).map(function(t) {
                            return e(t);
                        }));
                    }) : Promise.resolve(t);
                },
                impl: {
                    newImage: l
                }
            };
            function l(e) {
                return {
                    inline: function(t) {
                        return n.isDataUrl(e.src) ? Promise.resolve() : Promise.resolve(e.src).then(t || n.getAndEncode).then(function(t) {
                            return n.dataAsUrl(t, n.mimeType(e.src));
                        }).then(function(t) {
                            return new Promise(function(n) {
                                e.onload = n, e.onerror = n, e.src = t;
                            });
                        });
                    }
                };
            }
            const u = {
                imagePlaceholder: void 0,
                cacheBust: !1,
                useCredentials: !1,
                httpTimeout: 3e4
            }, h = {
                toSvg: p,
                toPng: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(e) {
                        return e.toDataURL();
                    });
                },
                toJpeg: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(e) {
                        return e.toDataURL("image/jpeg", t.quality || 1);
                    });
                },
                toBlob: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(n.canvasToBlob);
                },
                toPixelData: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(t) {
                        return t.getContext("2d").getImageData(0, 0, n.width(e), n.height(e)).data;
                    });
                },
                toCanvas: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t || {});
                },
                impl: {
                    fontFaces: a,
                    images: c,
                    util: n,
                    inliner: i,
                    urlCache: [],
                    options: {}
                }
            }, f = (e.exports = h, t.getComputedStyle || window.getComputedStyle), d = t.atob || window.atob;
            function p(e, t) {
                var o = t = t || {};
                return void 0 === o.imagePlaceholder ? h.impl.options.imagePlaceholder = u.imagePlaceholder : h.impl.options.imagePlaceholder = o.imagePlaceholder, void 0 === o.cacheBust ? h.impl.options.cacheBust = u.cacheBust : h.impl.options.cacheBust = o.cacheBust, void 0 === o.useCredentials ? h.impl.options.useCredentials = u.useCredentials : h.impl.options.useCredentials = o.useCredentials, Promise.resolve(e).then(function(e) {
                    return function e(t, o, r, i, a = null) {
                        return r || !o || o(t) ? Promise.resolve(t).then(function(e) {
                            return e instanceof HTMLCanvasElement ? n.makeImage(e.toDataURL()) : "IFRAME" === e.nodeName ? html2canvas(e.contentDocument.body).then((e)=>e.toDataURL()).then(n.makeImage) : e.cloneNode(!1);
                        }).then(function(r) {
                            return function(t, r) {
                                const a = t.childNodes;
                                return 0 === a.length ? Promise.resolve(r) : (function(n, r) {
                                    const a = f(t);
                                    let s = Promise.resolve();
                                    return r.forEach(function(t) {
                                        s = s.then(function() {
                                            return e(t, o, !1, i, a);
                                        }).then(function(e) {
                                            e && n.appendChild(e);
                                        });
                                    }), s;
                                })(r, n.asArray(a)).then(function() {
                                    return r;
                                });
                            }(t, r);
                        }).then(function(e) {
                            return function(e, t, o) {
                                return t instanceof Element ? Promise.resolve().then(function() {
                                    !function(e, t) {
                                        const i = f(e);
                                        i.cssText ? (t.style.cssText = i.cssText, function(e, t) {
                                            t.font = e.font, t.fontFamily = e.fontFamily, t.fontFeatureSettings = e.fontFeatureSettings, t.fontKerning = e.fontKerning, t.fontSize = e.fontSize, t.fontStretch = e.fontStretch, t.fontStyle = e.fontStyle, t.fontVariant = e.fontVariant, t.fontVariantCaps = e.fontVariantCaps, t.fontVariantEastAsian = e.fontVariantEastAsian, t.fontVariantLigatures = e.fontVariantLigatures, t.fontVariantNumeric = e.fontVariantNumeric, t.fontVariationSettings = e.fontVariationSettings, t.fontWeight = e.fontWeight;
                                        }(i, t.style)) : (o ? function(e, t, n, o) {
                                            const r = n.style, i = e.style;
                                            for (var a of t){
                                                var s = t.getPropertyValue(a), c = i.getPropertyValue(a), l = (i.setProperty(a, o ? "initial" : "unset"), t.getPropertyValue(a));
                                                l !== s ? r.setProperty(a, s) : r.removeProperty(a), i.setProperty(a, c);
                                            }
                                        }(e, i, t, r) : function(e, t, o) {
                                            const r = function(e) {
                                                if (v[e]) return v[e];
                                                y || ((y = document.createElement("iframe")).style.visibility = "hidden", y.style.position = "fixed", document.body.appendChild(y), y.contentWindow.document.write('<!DOCTYPE html><meta charset="UTF-8"><title>sandbox</title><body>'));
                                                const t = document.createElement(e), o = (y.contentWindow.document.body.appendChild(t), t.textContent = ".", y.contentWindow.getComputedStyle(t)), r = {};
                                                return n.asArray(o).forEach(function(e) {
                                                    r[e] = "width" === e || "height" === e ? "auto" : o.getPropertyValue(e);
                                                }), y.contentWindow.document.body.removeChild(t), v[e] = r;
                                            }(o.tagName), i = o.style;
                                            n.asArray(e).forEach(function(n) {
                                                var o = e.getPropertyValue(n);
                                                (o !== r[n] || t && o !== t.getPropertyValue(n)) && i.setProperty(n, o, e.getPropertyPriority(n));
                                            });
                                        }(i, a, t), r && ([
                                            "inset-block",
                                            "inset-block-start",
                                            "inset-block-end"
                                        ].forEach((e)=>t.style.removeProperty(e)), [
                                            "left",
                                            "right",
                                            "top",
                                            "bottom"
                                        ].forEach((e)=>{
                                            t.style.getPropertyValue(e) && t.style.setProperty(e, "0px");
                                        })));
                                    }(e, t);
                                }).then(function() {
                                    [
                                        ":before",
                                        ":after"
                                    ].forEach(function(o) {
                                        !function(o) {
                                            const r = f(e, o), i = r.getPropertyValue("content");
                                            if ("" !== i && "none" !== i) {
                                                const e = n.uid(), i = t.getAttribute("class"), a = (i && t.setAttribute("class", i + " " + e), document.createElement("style"));
                                                a.appendChild(function() {
                                                    const t = `.${e}:` + o, i = (r.cssText ? function() {
                                                        return `${r.cssText} content: ${r.getPropertyValue("content")};`;
                                                    } : function() {
                                                        return n.asArray(r).map(function(e) {
                                                            return e + ": " + r.getPropertyValue(e) + (r.getPropertyPriority(e) ? " !important" : "");
                                                        }).join("; ") + ";";
                                                    })();
                                                    return document.createTextNode(t + `{${i}}`);
                                                }()), t.appendChild(a);
                                            }
                                        }(o);
                                    });
                                }).then(function() {
                                    e instanceof HTMLTextAreaElement && (t.innerHTML = e.value), e instanceof HTMLInputElement && t.setAttribute("value", e.value);
                                }).then(function() {
                                    t instanceof SVGElement && (t.setAttribute("xmlns", "http://www.w3.org/2000/svg"), t instanceof SVGRectElement && [
                                        "width",
                                        "height"
                                    ].forEach(function(e) {
                                        const n = t.getAttribute(e);
                                        n && t.style.setProperty(e, n);
                                    }));
                                }).then(function() {
                                    return t;
                                }) : t;
                            }(t, e, i);
                        }) : Promise.resolve();
                    }(e, t.filter, !0, !t.raster);
                }).then(g).then(w).then(function(e) {
                    t.bgcolor && (e.style.backgroundColor = t.bgcolor), t.width && (e.style.width = t.width + "px"), t.height && (e.style.height = t.height + "px"), t.style && Object.keys(t.style).forEach(function(n) {
                        e.style[n] = t.style[n];
                    });
                    let n = null;
                    return "function" == typeof t.onclone && (n = t.onclone(e)), Promise.resolve(n).then(function() {
                        return e;
                    });
                }).then(function(o) {
                    var r, i;
                    return o, r = t.width || n.width(e), i = t.height || n.height(e), Promise.resolve(o).then(function(e) {
                        return e.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), (new XMLSerializer).serializeToString(e);
                    }).then(n.escapeXhtml).then(function(e) {
                        return `<foreignObject x="0" y="0" width="100%" height="100%">${e}</foreignObject>`;
                    }).then(function(e) {
                        return `<svg xmlns="http://www.w3.org/2000/svg" width="${r}" height="${i}">${e}</svg>`;
                    }).then(function(e) {
                        return "data:image/svg+xml;charset=utf-8," + e;
                    });
                }).then(function(e) {
                    return h.impl.urlCache = [], e;
                });
            }
            function m(e, t) {
                return p(e, t).then(n.makeImage).then(n.delay(0)).then(function(o) {
                    var r = "number" != typeof t.scale ? 1 : t.scale;
                    const i = function(e, o) {
                        const r = document.createElement("canvas");
                        if (r.width = (t.width || n.width(e)) * o, r.height = (t.height || n.height(e)) * o, t.bgcolor) {
                            const e = r.getContext("2d");
                            e.fillStyle = t.bgcolor, e.fillRect(0, 0, r.width, r.height);
                        }
                        return r;
                    }(e, r), a = i.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, o && (a.scale(r, r), a.drawImage(o, 0, 0)), y && (document.body.removeChild(y), y = null, M && clearTimeout(M), M = setTimeout(()=>{
                        M = null, v = {};
                    }, 2e4)), i;
                });
            }
            function g(e) {
                return a.resolveAll().then(function(t) {
                    const n = document.createElement("style");
                    return e.appendChild(n), n.appendChild(document.createTextNode(t)), e;
                });
            }
            function w(e) {
                return c.inlineAll(e).then(function() {
                    return e;
                });
            }
            let M = null, y = null, v = {};
        }(t);
    }), r = n(function(e, n) {
        (function() {
            function n(e, t, n) {
                var o = new XMLHttpRequest;
                o.open("GET", e), o.responseType = "blob", o.onload = function() {
                    a(o.response, t, n);
                }, o.onerror = function() {
                    console.error("could not download file");
                }, o.send();
            }
            function o(e) {
                var t = new XMLHttpRequest;
                t.open("HEAD", e, !1);
                try {
                    t.send();
                } catch (e) {}
                return 200 <= t.status && 299 >= t.status;
            }
            function r(e) {
                try {
                    e.dispatchEvent(new MouseEvent("click"));
                } catch (n) {
                    var t = document.createEvent("MouseEvents");
                    t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
                }
            }
            var i = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof t && t.global === t ? t : void 0, a = i.saveAs || ("object" != typeof window || window !== i ? function() {} : "download" in HTMLAnchorElement.prototype ? function(e, t, a) {
                var s = i.URL || i.webkitURL, c = document.createElement("a");
                t = t || e.name || "download", c.download = t, c.rel = "noopener", "string" == typeof e ? (c.href = e, c.origin === location.origin ? r(c) : o(c.href) ? n(e, t, a) : r(c, c.target = "_blank")) : (c.href = s.createObjectURL(e), setTimeout(function() {
                    s.revokeObjectURL(c.href);
                }, 4e4), setTimeout(function() {
                    r(c);
                }, 0));
            } : "msSaveOrOpenBlob" in navigator ? function(e, t, i) {
                if (t = t || e.name || "download", "string" != typeof e) navigator.msSaveOrOpenBlob(function(e, t) {
                    return void 0 === t ? t = {
                        autoBom: !1
                    } : "object" != typeof t && (console.warn("Deprecated: Expected third argument to be a object"), t = {
                        autoBom: !t
                    }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
                        "\ufeff",
                        e
                    ], {
                        type: e.type
                    }) : e;
                }(e, i), t);
                else if (o(e)) n(e, t, i);
                else {
                    var a = document.createElement("a");
                    a.href = e, a.target = "_blank", setTimeout(function() {
                        r(a);
                    });
                }
            } : function(e, t, o, r) {
                if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), "string" == typeof e) return n(e, t, o);
                var a = "application/octet-stream" === e.type, s = /constructor/i.test(i.HTMLElement) || i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
                if ((c || a && s) && "object" == typeof FileReader) {
                    var l = new FileReader;
                    l.onloadend = function() {
                        var e = l.result;
                        e = c ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = e : location = e, r = null;
                    }, l.readAsDataURL(e);
                } else {
                    var u = i.URL || i.webkitURL, h = u.createObjectURL(e);
                    r ? r.location = h : location.href = h, r = null, setTimeout(function() {
                        u.revokeObjectURL(h);
                    }, 4e4);
                }
            });
            i.saveAs = a.saveAs = a, e.exports = a;
        })();
    }), i = L.Control.extend({
        options: {
            cropImageByInnerWH: !0,
            hidden: !1,
            domtoimageOptions: {},
            position: "topleft",
            screenName: "screen",
            iconUrl: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxnIGlkPSJjYW1lcmEiPjxwYXRoIHN0eWxlPSJmaWxsOiMwMTAwMDI7IiBkPSJNMTYsOS41MDFjLTQuNDE5LDAtOCwzLjU4MS04LDhjMCw0LjQxOCwzLjU4MSw4LDgsOGM0LjQxOCwwLDgtMy41ODIsOC04UzIwLjQxOCw5LjUwMSwxNiw5LjUwMXogTTIwLjU1NSwyMS40MDZjLTIuMTU2LDIuNTE2LTUuOTQzLDIuODA3LTguNDU5LDAuNjVjLTIuNTE3LTIuMTU2LTIuODA3LTUuOTQ0LTAuNjUtOC40NTljMi4xNTUtMi41MTcsNS45NDMtMi44MDcsOC40NTktMC42NUMyMi40MiwxNS4xMDIsMjIuNzExLDE4Ljg5MSwyMC41NTUsMjEuNDA2eiIvPjxwYXRoIHN0eWxlPSJmaWxsOiMwMTAwMDI7IiBkPSJNMTYsMTMuNTAxYy0yLjIwOSwwLTMuOTk5LDEuNzkxLTQsMy45OTl2MC4wMDJjMCwwLjI3NSwwLjIyNCwwLjUsMC41LDAuNXMwLjUtMC4yMjUsMC41LTAuNVYxNy41YzAuMDAxLTEuNjU2LDEuMzQzLTIuOTk5LDMtMi45OTljMC4yNzYsMCwwLjUtMC4yMjQsMC41LTAuNVMxNi4yNzYsMTMuNTAxLDE2LDEzLjUwMXoiLz48cGF0aCBzdHlsZT0iZmlsbDojMDEwMDAyOyIgZD0iTTI5LjQ5Miw4LjU0MmwtNC4zMzQtMC43MjNsLTEuMzczLTMuNDM0QzIzLjMyNiwzLjI0LDIyLjIzMiwyLjUsMjEsMi41SDExYy0xLjIzMiwwLTIuMzI2LDAuNzQtMi43ODYsMS44ODZMNi44NDIsNy44MTlMMi41MDksOC41NDJDMS4wNTUsOC43ODMsMCwxMC4wMjcsMCwxMS41djE1YzAsMS42NTQsMS4zNDYsMywzLDNoMjZjMS42NTQsMCwzLTEuMzQ2LDMtM3YtMTVDMzIsMTAuMDI3LDMwLjk0NSw4Ljc4MywyOS40OTIsOC41NDJ6IE0zMCwyNi41YzAsMC41NTMtMC40NDcsMS0xLDFIM2MtMC41NTMsMC0xLTAuNDQ3LTEtMXYtMTVjMC0wLjQ4OSwwLjM1NC0wLjkwNiwwLjgzNi0wLjk4Nkw4LjI4LDkuNjA3bDEuNzkxLTQuNDc4QzEwLjIyNCw0Ljc1LDEwLjU5MSw0LjUsMTEsNC41aDEwYzAuNDA4LDAsMC43NzUsMC4yNDksMC45MjgsMC42MjlsMS43OTEsNC40NzhsNS40NDUsMC45MDdDMjkuNjQ2LDEwLjU5NCwzMCwxMS4wMTEsMzAsMTEuNVYyNi41eiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+",
            hideElementsWithSelectors: [
                ".leaflet-control-container"
            ],
            onCropBorderSize: 2,
            caption: null,
            captionFontSize: 15,
            captionFont: "Arial",
            captionColor: "black",
            captionBgColor: "white",
            captionOffset: 5,
            mimeType: "image/png",
            debugMode: !1,
            preventDownload: !1,
            onPixelDataFail: function(e) {
                var t = e.node, n = e.error;
                return console.warn("Map node is very big " + t.scrollWidth + "x" + t.scrollHeight), console.warn("Add function: SimpleMapScreenshoter({\n              onPixelDataFail: function({ node, plugin, error, mapPane, domtoimageOptions }) {\n                 // Solutions:\n                 // decrease size of map\n                 // or decrease zoom level\n                 // or remove elements with big distanses\n                 // and after that return image in Promise - plugin._getPixelDataOfNormalMap\n                 return plugin._getPixelDataOfNormalMap(domtoimageOptions)\n              }\n            })"), Promise.reject(n);
            }
        },
        onAdd: function() {
            return this._container = L.DomUtil.create("div", "leaflet-control-simpleMapScreenshoter"), this._link = null, this._screenState = {
                status: 1,
                promise: null
            }, !1 === this.options.hidden && this._addScreenBtn(), this._onUserStartInteractWithMap = this._onUserStartInteractWithMap.bind(this), this._onUserEndInteractWithMap = this._onUserEndInteractWithMap.bind(this), this._map.on("zoomstart", this._onUserStartInteractWithMap), this._map.on("move", this._onUserStartInteractWithMap), this._map.on("zoomend", this._onUserEndInteractWithMap), this._map.on("moveend", this._onUserEndInteractWithMap), this._container;
        },
        takeScreen: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "blob", n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = {};
            for(var r in this.options)n.hasOwnProperty(r) ? o[r] = n[r] : o[r] = this.options[r];
            return 2 === this._screenState.status ? this._screenState.promise : (this._map.fire("simpleMapScreenshoter.takeScreen"), this._screenState.status = 2, this._setElementsVisible(!1), this._screenState.promise = this._waitEndOfInteractions().then(function() {
                return e._getPixelData(o);
            }).then(function(t) {
                return e._setElementsVisible(!0), e._toCanvas(t, o);
            }).then(function(n) {
                return "image" === t ? e._canvasToImage(n, o) : "canvas" === t ? n : e._canvasToBlob(n, o);
            }).then(function(t) {
                return e._screenState.status = 1, e._map.fire("simpleMapScreenshoter.done"), t;
            }).catch(function(t) {
                return e._setElementsVisible(!0), e._screenState.status = 1, e._map.fire("simpleMapScreenshoter.error", {
                    e: t
                }), Promise.reject(t);
            }), this._screenState.promise);
        },
        _setElementsVisible: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.options.hideElementsWithSelectors.forEach(function(n) {
                var o = e._map._container.querySelectorAll(n), r = !0, i = !1, a = void 0;
                try {
                    for(var s, c = o[Symbol.iterator](); !(r = (s = c.next()).done); r = !0)s.value.style.opacity = !1 === t ? 0 : 1;
                } catch (e) {
                    i = !0, a = e;
                } finally{
                    try {
                        !r && c.return && c.return();
                    } finally{
                        if (i) throw a;
                    }
                }
            });
        },
        _canvasToImage: function(e, t) {
            var n = t.mimeType, o = e.toDataURL(n);
            return -1 === o.indexOf("base64") ? Promise.reject(new Error("Base64 image generation error")) : Promise.resolve(o);
        },
        _canvasToBlob: function(e, t) {
            var n = t.mimeType;
            return new Promise(function(t, o) {
                e.toBlob(function(e) {
                    t(e);
                }, n);
            });
        },
        _toCanvas: function(e, t) {
            var n = t.captionOffset, o = t.caption, r = t.captionFontSize, i = t.captionFont, a = t.captionColor, s = t.captionBgColor, c = this._node, l = c.screenHeight, u = c.screenWidth, h = document.createElement("canvas");
            h.width = u, h.height = l;
            for(var f = h.getContext("2d"), d = f.createImageData(u, l), p = 0; p < e.length; ++p)d.data[p] = e[p];
            f.putImageData(d, 0, 0), d = null;
            var m = document.createElement("canvas"), g = m.getContext("2d"), w = 0, M = 0, y = l, v = u;
            if (!0 === this.options.cropImageByInnerWH) {
                for(var L1 = [], b = 0, P = 0; P < l; ++P){
                    b = 0;
                    for(var x = 0; x < u; ++x)0 === e[4 * P * u + 4 * x + 4] && b++;
                    b === u && L1.push(P);
                }
                var S = this._getMinAndMaxOnValuesBreak(L1);
                w = S.min;
                for(var C = u, T = S.max, j = [], D = 0, E = M; E < C; ++E){
                    D = 0;
                    for(var N = 0; N < l; ++N)0 === e[4 * N * u + 4 * E + 4] && D++;
                    D === l && j.push(E);
                }
                var I = this._getMinAndMaxOnValuesBreak(j);
                M = I.min, C = I.max, (0 === M && 0 === C || null === C) && (C = u), (0 === w && 0 === T || null === T) && (T = l), !0 === this.options.debugMode && (console.log("emptyYLine", L1), console.log("minMaxY", S), console.log("emptyXLine", j), console.log("minMaxX", I), console.log("debugX", {}), console.log("debugY", {})), 0 === w && T === l && 0 === M && C === u || (w += this.options.onCropBorderSize, T -= this.options.onCropBorderSize, M += this.options.onCropBorderSize, C -= this.options.onCropBorderSize), y = T - w, v = C - M, m.width = v, m.height = y;
            } else m.width = v, m.height = y;
            var A = null;
            return o && (A = "function" == typeof o ? o.call(this) : o), null !== A && (m.height = m.height + (n + r + n), g.beginPath(), g.rect(0, 0, m.width, m.height), g.fillStyle = s, g.fill(), g.save()), g.drawImage(h, M, w, v, y, 0, 0, v, y), null !== A && (g.font = r + "px " + i, g.fillStyle = a, g.fillText(A, n, y + n + r)), Promise.resolve(m);
        },
        _getMinAndMaxOnValuesBreak: function(e) {
            for(var t = 0, n = 0, o = !1, r = 1; r < e.length; r++){
                if (e[r] - 1 !== e[r - 1]) {
                    n = e[r], o = !0;
                    break;
                }
                t = e[r];
            }
            return !1 === o && e[0] > 1 ? (t = 0, n = e[0]) : !1 === o && (t = e[e.length - 1] || 0, n = null), {
                min: t,
                max: n
            };
        },
        _getPixelData: function(e) {
            var t = this, n = e.domtoimageOptions, o = void 0 === n ? {} : n;
            return this._getPixelDataOfNormalMap(o).catch(function(e) {
                return console.warn("May be map size very big on that zoom level, we have error:", e.toString()), console.warn("You can manually hide map elements with large distances between them for fix that warn"), t._getPixelDataOfBigMap(o);
            });
        },
        _getPixelDataOfNormalMap: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this._map.getContainer();
            return this._node = {
                node: t,
                screenHeight: t.scrollHeight,
                screenWidth: t.scrollWidth
            }, o.toPixelData(t, e);
        },
        _getPixelDataOfBigMap: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = this._map.getContainer(), r = this._map.getPane("mapPane");
            r.style.width = 2 * n.clientWidth + "px", r.style.height = 2 * n.clientHeight + "px", r.style.overflow = "hidden";
            var i = function() {
                r.style.width = "initial", r.style.height = "initial", r.style.overflow = "initial";
            };
            return this._node = {
                node: n,
                screenHeight: n.scrollHeight,
                screenWidth: n.scrollWidth
            }, o.toPixelData(n, t).then(function(e) {
                return i(), e;
            }).catch(function(o) {
                return i(), n.scrollHeight >= 4e3 || n.scrollWidth >= 4e3 ? e.options.onPixelDataFail({
                    plugin: e,
                    node: n,
                    mapPane: r,
                    error: o,
                    domtoimageOptions: t
                }) : Promise.reject(o);
            });
        },
        _addScreenBtn: function() {
            this._link = L.DomUtil.create("a", "leaflet-control-simpleMapScreenshoter-btn", this._container), this._addCss(), L.DomEvent.addListener(this._link, "click", this._onScreenBtn, this), L.DomEvent.disableClickPropagation(this._link);
        },
        _addCss: function() {
            var e = "\n    .leaflet-control-simpleMapScreenshoter{\n       border: 2px solid rgba(0,0,0,0.2);\n       background-clip: padding-box;\n    }\n    .leaflet-control-simpleMapScreenshoter a{\n       background-color: #fff;\n       border-bottom: 1px solid #ccc;\n       width: 30px;\n       height: 30px;\n       line-height: 30px;\n       display: block;\n       text-align: center;\n       text-decoration: none;\n       color: black;\n       overflow: hidden;\n       border-radius: 2px;\n       background-image: url('" + this.options.iconUrl + "');\n       background-position: 46% 41%;\n       background-repeat: no-repeat;\n       background-size: 63%;\n    }\n    .leaflet-control-simpleMapScreenshoter a:hover{\n       cursor: pointer;\n    }\n    ", t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
            n.appendChild(document.createTextNode(e)), t.appendChild(n);
        },
        _onScreenBtn: function() {
            var e = this;
            this._map.fire("simpleMapScreenshoter.click"), this.options.preventDownload || this.takeScreen().then(function(t) {
                var n = "function" == typeof e.options.screenName ? e.options.screenName.call(e) : e.options.screenName;
                r.saveAs(t, n + ".png");
            }).catch(function(t) {
                e._map.fire("simpleMapScreenshoter.error", {
                    e: t
                });
            });
        },
        _onUserStartInteractWithMap: function() {
            this._interaction = !0;
        },
        _onUserEndInteractWithMap: function() {
            this._interaction = !1;
        },
        _waitEndOfInteractions: function() {
            var e = this;
            return new Promise(function(t) {
                var n = setInterval(function() {
                    e._interaction || (t(), clearInterval(n));
                }, 100);
            });
        }
    }), a = (L.Control.SimpleMapScreenshoter = i, L.simpleMapScreenshoter = function(e) {
        return new L.Control.SimpleMapScreenshoter(e);
    }, i);
    e.default = a, e.SimpleMapScreenshoter = i, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});


let $2428c827a8ed55fc$var$infoModal;
function $2428c827a8ed55fc$export$2e2bcd8739ae039(titleYear) {
    // Define the Robinson projection using Proj4
    const robinsonProj = "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
    // Define a custom CRS for Robinson
    const robinsonCRS = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Proj.CRS("EPSG:54030", robinsonProj, {
        origin: [
            -20037508.342789244,
            20037508.342789244
        ],
        // define zoom level array
        resolutions: [
            // 156543.033928041,
            // 110407.27494603075,
            // 78271.5169640205,
            55271.63772301539,
            39135.75848201024,
            27613.818861507695,
            19567.87924100512,
            13875.859050753847,
            9783.93962050256,
            6891.954715377821,
            4891.96981025128,
            3468.9773576889106,
            1734.4886788444553,
            867.2443394222277,
            433.6221697111138
        ]
    });
    // Initialize the map
    const map = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("map", {
        // crs: L.CRS.Simple,
        crs: robinsonCRS,
        center: [
            0,
            0
        ],
        zoom: 1,
        maxZoom: 11,
        closeTooltipOnClick: false,
        attributionControl: false
    });
    // Set map boundary [ymin, xmin, ymax, xmax]
    // map.fitBounds([[-45, -130], [75, 130]]);
    // Add no tiles to map
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer("").addTo(map);
    // Add scalebar to the bottom-left corner of the map
    //   L.control.scale({ imperial: false, position: "bottomleft" }).addTo(map);
    // ------------------- //
    // Add Reset Map button
    // ------------------- //
    // Add a repeat arrow button to the top-left corner of the map
    // [Detail: this code creates and adds a custom control using the leaflet library]
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "topleft"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "btn-reset-view");
            divContainer.setAttribute("style", "cursor: pointer;");
            divContainer.insertAdjacentHTML("afterbegin", `
          <a title="Reset map view">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"/>
            </svg>
          </a>
  
        `);
            document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new resetView());
    // Reset view to default view when button is clicked
    document.getElementById("btn-reset-view").addEventListener("click", ()=>{
        // map.fitBounds([[-45, -130], [75, 130]]);
        map.setView([
            0,
            0
        ], 1);
    });
    // ------------------- //
    // Add Download Data Button
    // ------------------- //
    // Download data button
    // Add a repeat arrow button to the top-left corner of the map
    const downloadData = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "topleft"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "btn-download-data");
            divContainer.setAttribute("style", "cursor: pointer;");
            divContainer.insertAdjacentHTML("afterbegin", `
        <a title="Download layer data">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
          </svg>
        </a>
  
      `);
            document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new downloadData());
    // ------------------- //
    // Add Save Image Button
    // ------------------- //
    // Add a custom control button to the top-left corner of the map
    const saveImageIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-image" viewBox="0 0 16 16">
      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
    </svg>`;
    const saveImage = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "topleft"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "btn-save-image");
            divContainer.setAttribute("style", "cursor: pointer;");
            divContainer.insertAdjacentHTML("afterbegin", `
        <a title="Download screenshot">
          ${saveImageIcon}
        </a>
      `);
            document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new saveImage());
    // Inititate screenshot on map with the default button hidden
    const simpleMapScreenshoter = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).simpleMapScreenshoter({
        hidden: true,
        hideElementsWithSelectors: [
            ".leaflet-control-zoom",
            "#btn-reset-view",
            "#btn-info-modal",
            "#eu-toggle",
            "#btn-download-data"
        ]
    }).addTo(map);
    // Remove screenshoter logo entirely from DOM
    document.querySelector(".leaflet-control-simpleMapScreenshoter").remove();
    // Download an image when save-image button is clicked
    document.getElementById("btn-save-image").addEventListener("click", ()=>{
        // first hide the btn-save-image
        document.querySelector("#btn-save-image").style.display = "none";
        // second change the display hover text in the display info element to none
        const displayInfoSpan = document.querySelector("#display-info-widget > span");
        if (displayInfoSpan) displayInfoSpan.textContent = "";
        // add temporary title
        const tempTitle = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
            position: "topleft"
        });
        tempTitle.onAdd = function(map) {
            this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo"); // create div with class "displayInfo"
            this._div.setAttribute("id", "temp-title");
            this._div.innerHTML = `<h3 style="margin-bottom:0; font-size: 1.5em;">State of Wildfires: Extremes of ${titleYear} Fire Season</h3>`;
            this._div.style.position = "absolute";
            this._div.style.top = "1px"; // Distance from top of the map container
            this._div.style.left = "1px"; // Distance from left of the map container
            this._div.style.width = "max-content";
            return this._div;
        };
        tempTitle.addTo(map);
        // take screenshot
        simpleMapScreenshoter.takeScreen("blob", {
        }).then((blob)=>{
            saveAs(blob, "State-of_Wildfires-UEA-Map.png");
            // last unhide the btn-save-image
            document.querySelector("#btn-save-image").style.display = "block";
            // default text back on display info widget
            if (displayInfoSpan) displayInfoSpan.textContent = "Hover over a polygon";
            // remove temp title
            tempTitle.remove();
        }).catch((e)=>{
            console.error(e.toString());
        });
    });
    // ------------------- //
    // Add Information Modal Button
    // ------------------- //
    // Information modal button
    // Add a info icon button to the top-left corner of the map
    $2428c827a8ed55fc$var$infoModal = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "topleft"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "btn-info-modal");
            divContainer.setAttribute("style", "cursor: pointer;");
            divContainer.insertAdjacentHTML("afterbegin", `
          <a title="More information">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-info" viewBox="0 0 16 16">
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
            </svg>
          </a>
        `);
            // Add event listener to show the modal
            divContainer.addEventListener("click", ()=>{
                const infoModal = new (0, $e9dd36436aec3b21$export$2b77a92f1a5ad772)(document.getElementById("infoModal"));
                infoModal.show();
            });
            document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new $2428c827a8ed55fc$var$infoModal());
    // ------------------- //
    // Add UEA Logo
    // ------------------- //
    // Add UEA logo to the bottom-right corner of the map
    const ueaLogo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "bottomright"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "uea-logo");
            divContainer.setAttribute("style", "border: none; pointer-events: none; width: 60px; height: 100%; background-color: white; padding: 2px; opacity: 0.80;");
            divContainer.insertAdjacentHTML("afterbegin", `
  
        <svg width="100%" height="100%" viewBox="0 0 1963 1184" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g><path d="M481.442,886.217c-10.679,-0 -3.421,-0.279 -13.421,-0.279c-123.821,-0 -216.754,-85.088 -216.754,-323.28l-0,-351.079c-0,-120.362 53.266,-166.041 128.541,-166.041l0,-14.321l-379.808,-0l0,14.146c66.008,1.27 89.863,57.379 89.863,131.166l-0,346.059c-0,260.729 124.825,378.454 351.108,378.454l40.437,-0l0.034,-14.825Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1244.58,644.079c-1.458,-130.675 -30.937,-158.783 -161.441,-160.05l-0,-12.916c130.504,-1.288 159.983,-29.325 161.441,-160.021l12.292,-0c1.513,130.696 30.921,158.646 161.425,159.916l0,13.021c-130.504,1.267 -159.912,29.375 -161.425,160.05l-12.292,0Z" style="fill:#00aeef;fill-rule:nonzero;"/><path d="M544.238,886.304c118.124,0 170.087,-80.192 170.087,-193.525c0,-135.766 0,0 0,0l-0.125,-492.866c0,-115.763 -57.983,-154.271 -128.313,-154.271l-0.054,-14.463l670.904,0l0.292,182.084l-11.891,-0.034c-20.034,-107.029 -61.771,-148.837 -197.9,-148.837l-31.542,-0c-128.021,-0 -153.179,40.816 -153.179,155.4l-0,106.562c-0,138.925 56.721,144.638 163.629,144.638l-0,13.021c-106.908,-0 -163.629,11.645 -163.629,151.924l-0,45.609c-0,171.858 21.683,183.279 166.112,183.279c85.379,-0 189.463,-21.875 216.217,-139.671l12.204,0.054l0,175.834l-712.812,-0l-0,-14.738Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1495.75,886.217c117.933,-0 147.725,-76.146 94.271,-195.609l-180.729,-451.979l52.22,-223.541l9.95,-0.038c0,0 248.525,590.104 310.175,709.5c65.05,126.004 119.721,161.754 173.646,161.754l0,14.738l-459.533,-0l-0,-14.825Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M138.158,1152.17c-31.129,-0 -49.737,-22.413 -49.737,-59.95l-0,-76.788l19.167,0l-0,75.817c-0,28.158 12.795,40.85 30.937,40.85c18.054,0 30.4,-12.342 30.4,-39.879l-0,-76.788l19.167,0l-0,75.625c-0,38.246 -18.667,61.113 -49.934,61.113Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M286.738,1149.12l-18.717,-0l-0,-59.621c-0,-16.858 -7.067,-25.796 -19.167,-25.796c-12.692,0 -22.692,10.138 -22.692,26.996l0,58.421l-18.679,-0l0,-102.363l17.588,0l-0,14.446c5.987,-11.062 15.45,-16.583 27.462,-16.583c20.767,-0 34.205,16.162 34.205,41.233l-0,63.267Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M329.217,1034.51l-18.438,-0l0,-18.921l18.438,-0l-0,18.921Zm0.158,114.604l-18.679,-0l-0,-102.363l18.679,0l0,102.363Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M396.546,1149.86l-16.513,-0.001l-36.683,-103.108l19.792,0l25.175,76.7l25.329,-76.7l19.446,0l-36.546,103.108Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M457.188,1089.69l47.516,-0.001c-1.612,-15.295 -9.392,-27.308 -23.404,-27.308c-13.313,0 -22.533,12.446 -24.113,27.308Zm26.092,61.755c-26.283,-0 -45.433,-22.971 -45.433,-53.421c-0,-30.45 19.012,-53.404 43.767,-53.404c24.758,-0 42.137,21.754 42.137,54.166c0,1.392 0,2.971 -0.175,5.334l-0.087,2.204l-66.18,-0c2.084,18.437 13.475,27.604 26.305,27.604c8.312,-0 17.254,-3.454 25,-12.829l0.745,-0.871l10.259,10.262l0.816,0.834l-0.712,0.954c-9.513,13.108 -21.509,19.167 -36.442,19.167Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M558.629,1149.12l-18.387,-0l-0,-102.363l17.954,0l-0,21.963c6.196,-15.904 17.15,-23.734 30.675,-23.734c0.537,0 2.587,0.071 2.587,0.071l0,21.996l-2.083,0c-16.858,0 -30.746,13.229 -30.746,41.004l0,41.063Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M632.013,1151.01c-11.371,0 -24.217,-4.637 -34.08,-13.891l-0.795,-0.709l8.399,-14.62l0.905,0.783c9.425,8.158 17.741,11.421 27.445,11.421c10.055,-0 15.955,-4.792 15.955,-12.621c-0,-8.196 -6.334,-11.108 -18.105,-14.913c-12.412,-4.062 -29.395,-9.966 -29.395,-31.233c-0,-17.95 14.691,-30.208 32.625,-30.208c10.658,-0 21.041,3.125 30.225,10.137l0.883,0.646l-7.583,15.363l-0.905,-0.713c-8.195,-6.129 -17.395,-8.421 -23.42,-8.421c-9.2,0 -14.721,4.879 -14.721,11.271c-0,8.071 5.121,10 20.362,14.721c16.771,5.208 27.067,14.846 27.067,31.425c-0,19.042 -14.375,31.562 -34.863,31.562Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M805.746,1180.55c-12.484,0 -24.342,-8.646 -24.342,-8.646l6.25,-17.187c0,-0 9.638,7.171 17.05,7.171c9.967,-0 14.517,-6.234 18.142,-16.65l-38.942,-98.488l20.246,0l27.742,73.125l22.708,-73.125l19.725,0l-36.912,104.842c-7.084,18.612 -17.43,28.958 -31.25,28.958" style="fill:#231f20;fill-rule:nonzero;"/><path d="M949.704,1062.9c-14.446,0 -27.604,13.142 -27.604,34.442c0,21.425 13.3,35.108 27.933,35.108c14.584,0 27.867,-13.179 27.867,-34.325c0,-19.496 -12.204,-35.192 -28.196,-35.192m0,88.213c-25.729,-0 -46.612,-23.317 -46.612,-53.021c-0,-30.346 21.025,-53.783 46.941,-53.783c25.817,-0 46.98,23.279 46.98,53c-0,30.316 -21.284,53.804 -47.309,53.804Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1034.36,1149.01l-18.975,0l0,-83.85l-11.895,0l-0,-18.508l11.895,0l0,-6.65c0,-24.967 19.2,-30.05 28.071,-30.05c6.684,0 11.079,1.196 14.584,2.621l0.729,0.292l-0,18.524l-0.938,-0.45c-2.741,-1.387 -7.466,-2.466 -10.591,-2.466c-9.375,-0 -13.055,5.262 -13.055,13.716l0,4.655l24.392,-0l0,18.316l-24.217,0l0,83.85Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1188.54,1148.96l-82.5,0l-0,-133.75l81.666,0l0,19.321l-62.204,0l0,34.759l54.688,-0l-0,19.308l-54.688,-0l0,41.229l63.038,0l-0,19.133Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1218.17,1117.28c0,10.571 7.675,16.042 17.642,16.042c15.779,-0 24.758,-11.425 24.758,-24.513l0,-5.591c-4.204,-2.534 -11.65,-4.325 -19.671,-4.325c-11.425,-0 -22.729,5.729 -22.729,18.387Zm15.108,33.504c-16.562,0 -34.045,-10.537 -34.045,-33.021c-0,-21.612 15.795,-36.229 39.67,-36.229c9.2,0 16.821,1.996 21.284,3.871l-0,-1.425c-0,-10.746 -5.488,-20.779 -20.4,-20.779c-10.696,-0 -20.834,3.871 -28.975,9.25l-1.042,0.696l-5.4,-17.588l0.883,-0.675c8.005,-5.242 21.234,-10.137 34.896,-10.137c12.329,-0 22.659,3.937 29.1,11.387c6.284,7.275 9.688,17.154 9.688,30.242l-0,62.587l-16.392,0l0,-12.966c-3.679,6.995 -14.458,14.787 -29.267,14.787Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1543.33,1095.87l-20.712,-52.654l-20.642,52.708l41.354,-0.054Zm40.675,53.091l-20.829,0l-12.658,-33.8l-55.659,0l-12.675,33.8l-20.591,0l53.7,-133.558l15.016,0l53.696,133.558Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1732.43,1063.17c-13.504,0 -25.121,10.558 -25.121,29.292c0,18.733 12.067,30.104 25.121,30.104c14.742,-0 27.379,-11.946 27.379,-29.533c0,-20.746 -13.8,-29.863 -27.379,-29.863Zm0.159,117.05c-14.825,0 -28.23,-4.737 -39.93,-14.133l-0.816,-0.659l8.071,-16.858l0.975,0.854c9.825,8.296 20.812,12.5 32.62,12.5c19.271,0 28.109,-13.458 28.109,-31.25l-0,-8.108c-5.942,12.567 -18.65,18.646 -31.671,18.646c-20.521,-0 -41.771,-17.938 -41.771,-47.954c0,-30.709 21.25,-48.784 41.771,-48.784c13.058,0 26.337,6.267 32.675,17.725l-0,-15.625l16.633,0l0,83.734c0,15.329 -3.854,27.516 -11.371,36.233c-7.762,8.942 -20.975,13.679 -35.295,13.679Z" style="fill:#231f20;fill-rule:nonzero;"/><rect x="1800.14" y="1015.49" width="18.679" height="133.471" style="fill:#231f20;"/><path d="M757.742,1150.95c-16.404,0 -26.404,-10.487 -26.404,-29.479l-0,-55.938l-12.034,0.001l0,-18.734l11.771,-0.016l-0.017,-28.35l19.063,-0l-0,28.404l25.296,-0l-0,18.696l-25.296,-0l-0,50.991c-0,9.634 3.212,15.329 11.321,15.329c4.271,0 8.437,-1.025 11.546,-2.85l1.562,-0.866l-0.071,18.058l-0.696,0.346c-4.979,3.004 -10.104,4.408 -16.041,4.408Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1408.56,1150.62c-16.441,0 -26.441,-10.487 -26.441,-29.446l-0,-55.954l-12.03,-0l0,-18.525l11.684,-0.017l-0.034,-28.591l19.151,-0l-0,28.416l25.291,0l0,18.717l-25.291,-0l-0,50.992c-0,9.6 3.225,15.291 11.354,15.291c4.271,0 8.416,-0.971 11.541,-2.829l1.563,-0.867l0.037,18.075l-0.816,0.346c-4.984,3.005 -10.105,4.392 -16.009,4.392Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1673.05,1149.03l-18.712,0l-0,-59.583c-0,-16.875 -7.067,-25.817 -19.167,-25.817c-12.708,0 -22.692,10.138 -22.692,26.979l0,58.421l-18.7,0l0,-102.346l17.588,0l-0,14.446c5.991,-11.079 15.471,-16.579 27.45,-16.579c20.796,0 34.233,16.163 34.233,41.229l0,63.25Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M703.263,1034.57l-18.455,-0l0,-18.925l18.455,-0l-0,18.925Zm0.174,114.791l-18.716,0l-0,-102.57l18.716,-0l0,102.57Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1859.42,1034.64l-18.471,-0l0,-18.942l18.471,-0l0,18.942Zm0.158,114.27l-18.679,0l0,-102.362l18.679,-0l0,102.362Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1325.68,1150.61c-11.391,0 -24.221,-4.67 -34.083,-13.908l-0.796,-0.708l8.4,-14.654l0.921,0.816c9.412,8.175 17.725,11.442 27.433,11.442c10.05,-0 15.971,-4.792 15.971,-12.625c0,-8.208 -6.354,-11.146 -18.142,-14.946c-12.395,-4.063 -29.375,-9.983 -29.375,-31.2c0,-17.967 14.671,-30.225 32.605,-30.225c10.691,0 21.041,3.108 30.241,10.138l0.867,0.662l-7.567,15.313l-0.904,-0.68c-8.212,-6.125 -17.396,-8.4 -23.437,-8.4c-9.2,0 -14.705,4.842 -14.705,11.25c0,8.071 5.121,9.984 20.363,14.705c16.754,5.208 27.067,14.858 27.067,31.458c-0,19.008 -14.392,31.562 -34.859,31.562Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1894.6,1117.69c0,10.591 7.692,16.025 17.638,16.025c15.783,-0 24.775,-11.409 24.775,-24.5l-0,-5.571c-4.2,-2.554 -11.646,-4.304 -19.688,-4.304c-11.387,-0 -22.725,5.691 -22.725,18.35Zm15.104,33.508c-16.546,-0 -34.046,-10.521 -34.046,-33.004c0,-21.617 15.85,-36.217 39.688,-36.217c9.166,0 16.825,1.963 21.287,3.871l0,-1.442c0,-10.746 -5.487,-20.779 -20.416,-20.779c-10.696,0 -20.834,3.871 -28.975,9.254l-1.063,0.675l-5.396,-17.587l0.9,-0.642c8.004,-5.279 21.234,-10.137 34.913,-10.137c12.312,-0 22.658,3.887 29.116,11.354c6.25,7.275 9.65,17.15 9.65,30.241l0,62.292l-16.387,0l-0,-12.654c-3.679,6.996 -14.463,14.775 -29.271,14.775Z" style="fill:#231f20;fill-rule:nonzero;"/></g>
        </svg>
  
      `);
            // document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new ueaLogo());
    // ------------------- //
    // Add State of Wildfires Logo
    // ------------------- //
    // Add wildfire logo to the bottom-right corner of the map
    const wildfireLogo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "bottomright"
        },
        onAdd: function() {
            const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
            divContainer.setAttribute("id", "wildfire-logo");
            divContainer.setAttribute("style", "border: none; pointer-events: none; width: 60px; height: 100%; background-color: white; padding: 0; opacity: 0.80;");
            divContainer.insertAdjacentHTML("afterbegin", `
  
          <?xml version="1.0" encoding="UTF-8"?>
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 391.89 461.4">
            <defs>
              <style>
                .cls-1 {
                  fill: #008786;
                }
  
                .cls-2 {
                  fill: #fbb172;
                }
  
                .cls-3 {
                  fill: #e37225;
                }
  
                .cls-4 {
                  fill: #fed8b8;
                }
  
                .cls-5 {
                  fill: #221f1f;
                }
  
                .cls-6 {
                  fill: #c8403e;
                }
              </style>
            </defs>
            <g>
              <path class="cls-5" d="M71.2,234.33v2.91h-9.75v32.2h-3.52v-32.2h-9.8v-2.91h23.06Z"/>
              <path class="cls-5" d="M101.85,234.33v35.12h-3.52v-16.43h-19.04v16.43h-3.52v-35.12h3.52v15.77h19.04v-15.77h3.52Z"/>
              <path class="cls-5" d="M112.39,237.2v13.11h13.31v2.91h-13.31v13.31h14.82v2.91h-18.34v-35.17h18.34v2.91h-14.82Z"/>
            </g>
            <g>
              <path class="cls-5" d="M56.12,315.9c-2.04-.84-3.68-2.08-4.9-3.72-1.22-1.64-1.87-3.62-1.93-5.93h9.14c.13,1.31.59,2.3,1.36,2.99.77.69,1.77,1.03,3.01,1.03s2.28-.29,3.01-.88c.74-.59,1.11-1.4,1.11-2.44,0-.87-.29-1.59-.88-2.16-.59-.57-1.31-1.04-2.16-1.41-.85-.37-2.07-.79-3.64-1.26-2.28-.7-4.14-1.41-5.58-2.11-1.44-.7-2.68-1.74-3.72-3.11-1.04-1.37-1.56-3.17-1.56-5.38,0-3.28,1.19-5.85,3.57-7.71,2.38-1.86,5.48-2.79,9.29-2.79s7.02.93,9.39,2.79c2.38,1.86,3.65,4.45,3.82,7.76h-9.29c-.07-1.14-.49-2.03-1.26-2.69-.77-.65-1.76-.98-2.96-.98-1.04,0-1.88.28-2.51.83-.64.55-.95,1.35-.95,2.39,0,1.14.54,2.03,1.61,2.66,1.07.64,2.75,1.32,5.02,2.06,2.28.77,4.13,1.51,5.55,2.21,1.42.7,2.65,1.73,3.69,3.06,1.04,1.34,1.56,3.06,1.56,5.17s-.51,3.84-1.53,5.48c-1.02,1.64-2.5,2.95-4.45,3.92-1.94.97-4.24,1.46-6.88,1.46s-4.89-.42-6.93-1.26Z"/>
              <path class="cls-5" d="M105.55,281.54v6.88h-9.34v28.38h-8.59v-28.38h-9.34v-6.88h27.28Z"/>
              <path class="cls-5" d="M127.7,310.58h-13.16l-2.11,6.23h-8.99l12.76-35.27h9.95l12.76,35.27h-9.09l-2.11-6.23ZM125.49,303.95l-4.37-12.91-4.32,12.91h8.69Z"/>
              <path class="cls-5" d="M165.43,281.54v6.88h-9.34v28.38h-8.59v-28.38h-9.34v-6.88h27.28Z"/>
              <path class="cls-5" d="M177.34,288.42v7.13h11.5v6.63h-11.5v7.74h13.01v6.88h-21.6v-35.27h21.6v6.88h-13.01Z"/>
              <path class="cls-5" d="M216.95,314.85c-2.76-1.54-4.96-3.69-6.58-6.46-1.62-2.76-2.44-5.87-2.44-9.32s.81-6.55,2.44-9.29c1.62-2.75,3.82-4.89,6.58-6.43,2.76-1.54,5.8-2.31,9.12-2.31s6.36.77,9.12,2.31c2.76,1.54,4.94,3.68,6.53,6.43,1.59,2.75,2.39,5.84,2.39,9.29s-.8,6.56-2.41,9.32c-1.61,2.76-3.79,4.92-6.53,6.46-2.75,1.54-5.78,2.31-9.09,2.31s-6.36-.77-9.12-2.31ZM232.82,306.51c1.69-1.88,2.54-4.35,2.54-7.43s-.85-5.6-2.54-7.46c-1.69-1.86-3.94-2.79-6.76-2.79s-5.12.92-6.81,2.76c-1.69,1.84-2.54,4.34-2.54,7.49s.84,5.6,2.54,7.46c1.69,1.86,3.96,2.79,6.81,2.79s5.06-.94,6.76-2.81Z"/>
              <path class="cls-5" d="M270.83,281.54v6.88h-14.37v7.43h10.75v6.68h-10.75v14.27h-8.59v-35.27h22.96Z"/>
            </g>
            <g>
              <path class="cls-5" d="M98.28,329.25l-9.19,35.27h-10.4l-5.63-23.21-5.83,23.21h-10.4l-8.94-35.27h9.19l5.07,25.67,6.28-25.67h9.44l6.03,25.67,5.12-25.67h9.24Z"/>
              <path class="cls-5" d="M110.18,329.25v35.27h-8.59v-35.27h8.59Z"/>
              <path class="cls-5" d="M124,357.89h11.25v6.63h-19.84v-35.27h8.59v28.63Z"/>
              <path class="cls-5" d="M161.32,331.46c2.78,1.47,4.93,3.54,6.46,6.2,1.52,2.66,2.29,5.74,2.29,9.22s-.76,6.51-2.29,9.19c-1.52,2.68-3.68,4.76-6.48,6.23-2.8,1.47-6.04,2.21-9.72,2.21h-13.21v-35.27h13.21c3.72,0,6.97.74,9.75,2.21ZM158.61,354.42c1.81-1.77,2.71-4.29,2.71-7.54s-.9-5.78-2.71-7.59c-1.81-1.81-4.34-2.71-7.59-2.71h-4.07v20.5h4.07c3.25,0,5.78-.89,7.59-2.66Z"/>
              <path class="cls-5" d="M196.84,329.25v6.88h-14.37v7.43h10.75v6.68h-10.75v14.27h-8.59v-35.27h22.96Z"/>
              <path class="cls-5" d="M208.95,329.25v35.27h-8.59v-35.27h8.59Z"/>
              <path class="cls-5" d="M232.15,364.52l-7.33-13.31h-2.06v13.31h-8.59v-35.27h14.42c2.78,0,5.15.49,7.11,1.46,1.96.97,3.42,2.3,4.4,3.99.97,1.69,1.46,3.58,1.46,5.65,0,2.34-.66,4.44-1.98,6.28-1.32,1.84-3.27,3.15-5.85,3.92l8.14,13.97h-9.7ZM222.76,345.13h5.32c1.57,0,2.75-.38,3.54-1.16.79-.77,1.18-1.86,1.18-3.27s-.39-2.39-1.18-3.16c-.79-.77-1.97-1.16-3.54-1.16h-5.32v8.74Z"/>
              <path class="cls-5" d="M254.51,336.13v7.13h11.5v6.63h-11.5v7.74h13.01v6.88h-21.6v-35.27h21.6v6.88h-13.01Z"/>
              <path class="cls-5" d="M277.92,363.61c-2.04-.84-3.68-2.08-4.9-3.72-1.22-1.64-1.87-3.62-1.93-5.93h9.14c.13,1.31.59,2.3,1.36,2.99.77.69,1.77,1.03,3.01,1.03s2.28-.29,3.01-.88c.74-.59,1.11-1.4,1.11-2.44,0-.87-.29-1.59-.88-2.16-.59-.57-1.31-1.04-2.16-1.41-.85-.37-2.07-.79-3.64-1.26-2.28-.7-4.14-1.41-5.58-2.11-1.44-.7-2.68-1.74-3.72-3.11-1.04-1.37-1.56-3.17-1.56-5.38,0-3.28,1.19-5.85,3.57-7.71,2.38-1.86,5.48-2.79,9.29-2.79s7.02.93,9.39,2.79c2.38,1.86,3.65,4.45,3.82,7.76h-9.29c-.07-1.14-.49-2.03-1.26-2.69-.77-.65-1.76-.98-2.96-.98-1.04,0-1.88.28-2.51.83-.64.55-.95,1.35-.95,2.39,0,1.14.54,2.03,1.61,2.66,1.07.64,2.75,1.32,5.02,2.06,2.28.77,4.13,1.51,5.55,2.21,1.42.7,2.65,1.73,3.69,3.06,1.04,1.34,1.56,3.06,1.56,5.17s-.51,3.84-1.53,5.48c-1.02,1.64-2.5,2.95-4.45,3.92-1.94.97-4.24,1.46-6.88,1.46s-4.89-.42-6.93-1.26Z"/>
            </g>
            <g>
              <path class="cls-5" d="M68.9,394.24c-1.98,1.84-4.94,2.76-8.89,2.76h-7.08v14.97h-3.52v-35.12h10.6c3.92,0,6.87.92,8.87,2.76,1.99,1.84,2.99,4.29,2.99,7.33s-.99,5.44-2.96,7.28ZM68.24,386.96c0-2.34-.65-4.12-1.96-5.33-1.31-1.21-3.4-1.81-6.28-1.81h-7.08v14.17h7.08c5.49,0,8.24-2.34,8.24-7.03Z"/>
              <path class="cls-5" d="M95.42,411.98l-8.69-14.67h-6.48v14.67h-3.52v-35.12h10.55c3.92,0,6.89.94,8.92,2.81,2.03,1.88,3.04,4.34,3.04,7.38,0,2.55-.73,4.71-2.19,6.51-1.46,1.79-3.61,2.96-6.46,3.49l9.04,14.92h-4.22ZM80.25,394.44h7.08c2.75,0,4.81-.67,6.2-2.01,1.39-1.34,2.08-3.13,2.08-5.37s-.67-4.09-2.01-5.35-3.45-1.88-6.33-1.88h-7.03v14.62Z"/>
              <path class="cls-5" d="M112.15,410.04c-2.65-1.52-4.73-3.65-6.25-6.38-1.52-2.73-2.29-5.82-2.29-9.27s.76-6.54,2.29-9.27c1.52-2.73,3.61-4.86,6.25-6.38,2.65-1.52,5.59-2.29,8.84-2.29s6.25.76,8.89,2.29c2.65,1.52,4.72,3.65,6.23,6.38,1.51,2.73,2.26,5.82,2.26,9.27s-.75,6.54-2.26,9.27c-1.51,2.73-3.58,4.86-6.23,6.38-2.65,1.52-5.61,2.29-8.89,2.29s-6.2-.76-8.84-2.29ZM128.03,407.45c2.08-1.21,3.72-2.94,4.92-5.2,1.21-2.26,1.81-4.88,1.81-7.86s-.6-5.59-1.81-7.84c-1.2-2.24-2.85-3.97-4.92-5.17-2.08-1.21-4.42-1.81-7.03-1.81s-4.96.6-7.03,1.81c-2.08,1.21-3.72,2.93-4.92,5.17-1.21,2.24-1.81,4.86-1.81,7.84s.6,5.6,1.81,7.86,2.85,3.99,4.92,5.2c2.08,1.21,4.42,1.81,7.03,1.81s4.96-.6,7.03-1.81Z"/>
              <path class="cls-5" d="M160.03,376.86v26.57c0,2.68-.82,4.83-2.46,6.46-1.64,1.62-3.84,2.44-6.58,2.44s-5.12-.86-6.81-2.59c-1.69-1.72-2.54-4.06-2.54-7.01h3.57c.03,1.91.51,3.47,1.43,4.67.92,1.21,2.37,1.81,4.35,1.81,1.88,0,3.27-.55,4.17-1.66.9-1.11,1.36-2.48,1.36-4.12v-26.57h3.52Z"/>
              <path class="cls-5" d="M171.38,379.72v13.11h13.31v2.91h-13.31v13.31h14.82v2.91h-18.34v-35.17h18.34v2.91h-14.82Z"/>
              <path class="cls-5" d="M192.78,385.12c1.51-2.73,3.57-4.86,6.18-6.38,2.61-1.52,5.53-2.29,8.74-2.29,3.92,0,7.28.93,10.07,2.79,2.8,1.86,4.83,4.48,6.1,7.86h-4.12c-1-2.38-2.54-4.24-4.6-5.58-2.06-1.34-4.55-2.01-7.46-2.01-2.58,0-4.9.6-6.96,1.81s-3.68,2.94-4.85,5.2c-1.17,2.26-1.76,4.88-1.76,7.86s.59,5.59,1.76,7.84c1.17,2.24,2.79,3.97,4.85,5.17,2.06,1.21,4.38,1.81,6.96,1.81,2.91,0,5.4-.66,7.46-1.98,2.06-1.32,3.59-3.16,4.6-5.5h4.12c-1.27,3.35-3.32,5.95-6.13,7.79-2.81,1.84-6.16,2.76-10.05,2.76-3.22,0-6.13-.76-8.74-2.29-2.61-1.52-4.67-3.64-6.18-6.35-1.51-2.71-2.26-5.79-2.26-9.24s.75-6.54,2.26-9.27Z"/>
              <path class="cls-5" d="M250.4,376.86v2.91h-9.75v32.2h-3.52v-32.2h-9.8v-2.91h23.06Z"/>
            </g>
            <g>
              <path class="cls-2" d="M234.08,201.59c-22.96,0-41.63-18.37-41.63-40.95s18.68-40.95,41.63-40.95,41.63,18.37,41.63,40.95-18.68,40.95-41.63,40.95ZM229.52,127.1c-19.2,0-34.82,16.07-34.82,35.82s15.62,35.82,34.82,35.82,34.82-16.07,34.82-35.82-15.62-35.82-34.82-35.82Z"/>
              <path class="cls-3" d="M259.86,209.11c-34.45,11.21-71.27-6.69-82.07-39.9s8.43-69.35,42.88-80.55,71.27,6.69,82.07,39.9-8.43,69.35-42.88,80.55ZM226.65,92.33c-31.15,10.14-48.82,41.99-39.37,71.01,9.44,29.02,42.47,44.38,73.62,34.24,31.15-10.14,48.82-41.99,39.37-71.01-9.44-29.02-42.47-44.38-73.62-34.24Z"/>
              <path class="cls-6" d="M231.94,243.62c-49.41,0-89.6-39.08-89.6-87.11s40.2-87.11,89.6-87.11,89.6,39.08,89.6,87.11-40.2,87.11-89.6,87.11ZM227.07,80.07c-45.21,0-81.99,35.63-81.99,79.43s36.78,79.44,81.99,79.44,81.99-35.63,81.99-79.44-36.78-79.43-81.99-79.43Z"/>
              <path class="cls-4" d="M222.18,136.33c7.54-8.63,20.71-9.51,29.35-1.96,8.65,7.55,9.54,20.72,2,29.35-7.54,8.63-20.71,9.51-29.35,1.96-8.65-7.55-9.54-20.72-2-29.35ZM253.1,158.72c6.17-7.06,5.28-17.98-1.99-24.33-7.27-6.35-18.2-5.77-24.38,1.29-6.17,7.06-5.28,17.98,1.99,24.33s18.2,5.77,24.38-1.29Z"/>
              <path class="cls-1" d="M236.67,260.38c-57.42,0-104.14-46.72-104.14-104.14s46.72-104.14,104.14-104.14,104.14,46.72,104.14,104.14-46.72,104.14-104.14,104.14ZM240.33,56.36c-53.76,0-97.51,42.52-97.51,94.78s43.74,94.78,97.51,94.78,97.51-42.52,97.51-94.78-43.74-94.78-97.51-94.78Z"/>
            </g>
          </svg>
      `);
            // document.getElementById("map").style.outlineStyle = "none";
            return divContainer;
        }
    });
    map.addControl(new wildfireLogo());
    return map;
}


// Function to colour polygons
const $79b07287552de364$export$13746b04065d45d9 = function(d, variable, scale, colPalette) {
    // Define the color for "Insufficient Data"
    const noDataColor = "#808080";
    // Check if d is null or undefined
    if (d === null || d === undefined) return noDataColor;
    // Burned Area Anomaly in Final Year
    // prettier-ignore
    return d < scale[8] ? colPalette[8] : d >= scale[8] && d < scale[7] ? colPalette[7] : d >= scale[7] && d < scale[6] ? colPalette[6] : d >= scale[6] && d <= scale[5] ? colPalette[5] : d > scale[5] && d < scale[4] ? colPalette[5] : d >= scale[4] && d < scale[3] ? colPalette[4] : d >= scale[3] && d < scale[2] ? colPalette[3] : d >= scale[2] && d < scale[1] ? colPalette[2] : d >= scale[1] && d < scale[0] ? colPalette[1] : colPalette[0];
};
const $79b07287552de364$export$ebcd05299db66cf5 = function(properties) {
    return `
    <h4 class="text-start">${properties.reg_name}</h4>
    <h6 class="text-start">2025-26 fire season anomalies from the average fire season and rankings amongst all fire seasons.</h6>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-start" scope="col">Variable</th>
          <th class="text-end" scope="col">%</th>
          <th class="text-end" scope="col">Rank</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-start">Burned Area Anomaly</td>
          <td class="text-end">${properties.ba_anom !== null ? properties.ba_anom > 0 ? `+${properties.ba_anom}` : properties.ba_anom : `Insufficient Data`}</td>
          <td class="text-end">${properties.ba_rank !== null ? properties.ba_rank : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">Carbon Emitted Anomaly</td>
          <td class="text-end">${properties.cem_emAn !== null ? properties.cem_emAn > 0 ? `+${properties.cem_emAn}` : properties.cem_emAn : `Insufficient Data`}</td>
          <td class="text-end">${properties.cem_emRk !== null ? properties.cem_emRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">Number of Fires Anomaly</td>
          <td class="text-end">${properties.gfa_nFAnP !== null ? properties.gfa_nFAnP > 0 ? `+${properties.gfa_nFAnP}` : properties.gfa_nFAnP : `Insufficient Data`}</td>
          <td class="text-end">${properties.gfa_nFRk !== null ? properties.gfa_nFRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">95\u{1D57}\u{2B0} Percentile Fire Size Anomaly</td>
          <td class="text-end">${properties.gfa_95FAP !== null ? properties.gfa_95FAP > 0 ? `+${properties.gfa_95FAP}` : properties.gfa_95FAP : `Insufficient Data`}</td>
          <td class="text-end">${properties.gfa_95FRk !== null ? properties.gfa_95FRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">95\u{1D57}\u{2B0} Percentile Rate of Growth Anomaly</td>
          <td class="text-end">${properties.gfa_95RAP !== null ? properties.gfa_95RAP > 0 ? `+${properties.gfa_95RAP}` : properties.gfa_95RAP : `Insufficient Data`}</td>
          <td class="text-end">${properties.gfa_95RRk !== null ? properties.gfa_95RRk : "n/a"}</td>
        </tr>
        ${properties.frp_95dPc !== null && properties.frp_95dPc !== undefined ? `
        <tr>
          <td class="text-start">Average Fire's 95\u{1D57}\u{2B0} Percentile FRP (MW) Anomaly</td>
          <td class="text-end">${properties.frp_95dPc > 0 ? `+${properties.frp_95dPc}` : properties.frp_95dPc}</td>
          <td class="text-end">${properties.frp_95r !== null ? properties.frp_95r : "n/a"}</td>
        </tr>` : ""}
      </tbody>
    </table>
    `;
};




let $feb869132f09ccd0$var$geojsonArray = [];
let $feb869132f09ccd0$var$map, $feb869132f09ccd0$var$geojsonLayer, $feb869132f09ccd0$var$legend, $feb869132f09ccd0$var$displayInfo;
// prettier-ignore
const $feb869132f09ccd0$var$colPalette = [
    "#C7403D",
    "#D6675E",
    "#E28B81",
    "#EBAEA6",
    "#F1D1CC",
    "#F3F3F3",
    "#ACB0C7",
    "#67729C",
    "#163A72",
    "#163A72"
];
const $feb869132f09ccd0$var$scale = [
    200,
    100,
    50,
    25,
    10,
    0,
    -10,
    -25,
    -50
];
// Main function to start app
window.addEventListener("load", async ()=>{
    // Initialise Choices selector instances
    const layer = document.getElementById("layer-selector");
    const variable = document.getElementById("variable-selector");
    const options = {
        searchEnabled: false,
        allowHTML: true,
        shouldSort: false,
        itemSelectText: "click to select"
    };
    const choicesVar = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(variable, options);
    const choicesLayer = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(layer, options);
    // Wait for data to load
    $feb869132f09ccd0$var$geojsonArray = await (0, $057bcfcec5498507$export$2e2bcd8739ae039)();
    // Disable spinner
    document.querySelector(".spinner").style.display = "none";
    // Add name property to each layer
    $feb869132f09ccd0$var$geojsonArray[0]["name"] = "Countries";
    $feb869132f09ccd0$var$geojsonArray[1]["name"] = "Continental_Biomes";
    $feb869132f09ccd0$var$geojsonArray[2]["name"] = "Ecoregions";
    $feb869132f09ccd0$var$geojsonArray[3]["name"] = "GADM_UCDavis_L1";
    // console.log(geojsonArray);
    // Initialise map
    $feb869132f09ccd0$var$map = (0, $2428c827a8ed55fc$export$2e2bcd8739ae039)("2024-2025");
    // Add default layer to map
    $feb869132f09ccd0$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($feb869132f09ccd0$var$activeLayer(), {
        style: $feb869132f09ccd0$var$stylePolygons("ba_anom"),
        onEachFeature: $feb869132f09ccd0$var$onEachFeature
    }).addTo($feb869132f09ccd0$var$map);
    // Inititate legend control
    $feb869132f09ccd0$var$legend = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        position: "bottomleft"
    });
    // Function when element is added to map
    $feb869132f09ccd0$var$legend.onAdd = function(map) {
        const activeVariable = layer.value;
        const unit = "%";
        // console.log(scaleObj[activeVariable]);
        const div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo legend"), grades = $feb869132f09ccd0$var$scale, labels = $feb869132f09ccd0$var$scale;
        // Legend title
        div.innerHTML += `
      <span id="legend-title">
        <h6 class="text-start legendTooltip" style="display: none;">% Deviation from the Average Fire Season</h6>
        <h6 class="text-start">
          Key
          <span>(${unit})</span>
        </h6>
      </span>
    `;
        for(let i = 0; i < grades.length - 1; i++)div.innerHTML += `
        <i style="background:${$feb869132f09ccd0$var$colPalette[i]}"></i>
        <span class="legend-text">${grades[i] > 0 ? `+${grades[i]}` : grades[i]}</span>
        <br>
      `;
        div.innerHTML += `
      <i style="background:${$feb869132f09ccd0$var$colPalette[grades.length]}"></i>
      <span class="legend-text">${grades[grades.length - 1]}</span>
    `;
        return div;
    };
    $feb869132f09ccd0$var$legend.addTo($feb869132f09ccd0$var$map);
    // Layer change control
    document.getElementById("layer-selector").addEventListener("change", ()=>{
        // Remove active layer from map
        $feb869132f09ccd0$var$map.removeLayer($feb869132f09ccd0$var$geojsonLayer);
        // Extract active second selector
        let activeVariable = document.getElementById("variable-selector").value;
        // Add new layer to map
        $feb869132f09ccd0$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($feb869132f09ccd0$var$activeLayer(), {
            style: $feb869132f09ccd0$var$stylePolygons(activeVariable),
            onEachFeature: $feb869132f09ccd0$var$onEachFeature
        }).addTo($feb869132f09ccd0$var$map);
    });
    // Variable change control
    document.getElementById("variable-selector").addEventListener("change", ()=>{
        // Remove active layer from map
        $feb869132f09ccd0$var$map.removeLayer($feb869132f09ccd0$var$geojsonLayer);
        // Extract active second selector
        let activeVariable = document.getElementById("variable-selector").value;
        // Add new layer to map
        $feb869132f09ccd0$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($feb869132f09ccd0$var$activeLayer(), {
            style: $feb869132f09ccd0$var$stylePolygons(activeVariable),
            onEachFeature: $feb869132f09ccd0$var$onEachFeature
        }).addTo($feb869132f09ccd0$var$map);
        // Change title of displayInfo text content on top-right widget
        // prettier-ignore
        const activeVariableText = document.getElementById("variable-selector").textContent;
        // prettier-ignore
        document.querySelector(".displayInfo > h4").textContent = activeVariableText;
    });
    // Add a custom control to display the region and value on the top-right of the map
    $feb869132f09ccd0$var$displayInfo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control();
    // Text to display when user hovers over polygons (initialise)
    $feb869132f09ccd0$var$displayInfo.onAdd = function(map) {
        this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo");
        this._div.setAttribute("id", "display-info-widget");
        this.update();
        return this._div;
    };
    // Text to display when user hovers over polygons (update)
    $feb869132f09ccd0$var$displayInfo.update = function(property) {
        const element = document.getElementById("variable-selector");
        const text = element.options[element.selectedIndex].text;
        const unit = "%";
        if (property) this._div.innerHTML = `<h4>${text}</h4> <b>${property.reg_name}:
      ${property[element.value] !== null ? property[element.value] > 0 ? `+${property[element.value]}` : property[element.value] : "Insufficient Data"}
      ${property[element.value] !== null ? unit : ""}</b>`;
        else this._div.innerHTML = `<h4>${text}</h4> <span>Hover over a polygon</span>`;
    };
    $feb869132f09ccd0$var$displayInfo.addTo($feb869132f09ccd0$var$map);
    // Additional event listeners
    // prettier-ignore
    document.getElementById("btn-download-data").addEventListener("click", $feb869132f09ccd0$var$exportCSV);
    $feb869132f09ccd0$var$attachEventListeners();
});
// ------------------- //
// Styling Functions
// ------------------- //
// Function to find the active layer in the first selector
function $feb869132f09ccd0$var$activeLayer() {
    const firstSelectorValue = document.getElementById("layer-selector").value;
    const activeLayerIndex = $feb869132f09ccd0$var$geojsonArray.map((arr)=>arr.name).indexOf(firstSelectorValue);
    const activeLayerData = $feb869132f09ccd0$var$geojsonArray[activeLayerIndex];
    return activeLayerData;
}
// Function to style polygons
function $feb869132f09ccd0$var$stylePolygons(variable) {
    return function(feature) {
        return {
            fillColor: (0, $79b07287552de364$export$13746b04065d45d9)(feature.properties[variable], variable, $feb869132f09ccd0$var$scale, $feb869132f09ccd0$var$colPalette),
            weight: 0.5,
            opacity: 1,
            color: "black",
            dashArray: "1",
            fillOpacity: 1
        };
    };
}
// Function to highlight polygon borders and show popup on mouseover (when mouse hovers over them)
function $feb869132f09ccd0$var$highlightPolygon(e) {
    const polygon = e.target;
    // Polygon borders
    polygon.setStyle({
        weight: 2,
        color: "black",
        fillOpacity: 1
    });
    // Update display information in top-right box
    $feb869132f09ccd0$var$displayInfo.update(polygon.feature.properties);
    polygon.bringToFront();
}
// Functions to trigger white and black transition when a polygon is clicked
const $feb869132f09ccd0$var$triggerWhite = (e)=>{
    e.target.setStyle({
        color: "white"
    });
};
const $feb869132f09ccd0$var$triggerBlack = (e)=>{
    e.target.setStyle({
        color: "black"
    });
};
// Popup options
// https://leafletjs.com/reference.html#popup
const $feb869132f09ccd0$var$popupOptions = {
    className: "popupCustom",
    closeButton: true,
    autoPan: true
};
// Function to show popup on mouse click
function $feb869132f09ccd0$var$showPopup(e) {
    const polygon = e.target;
    // Popup content
    const popupContentHtml = (0, $79b07287552de364$export$ebcd05299db66cf5)(polygon.feature.properties);
    // Create popup that stays within map boundary
    const popup = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).responsivePopup({
        offset: [
            0,
            0
        ]
    }).setContent(popupContentHtml);
    // Bind the popup with unique content
    polygon.bindPopup(popup, $feb869132f09ccd0$var$popupOptions).openPopup();
}
// Function to reset border to original style on mouseout (when mouse is not hovering over a polygon)
function $feb869132f09ccd0$var$resetHighlight(e) {
    $feb869132f09ccd0$var$geojsonLayer.resetStyle(e.target);
    $feb869132f09ccd0$var$displayInfo.update();
}
// Function to add highlighting parameters to a layer
function $feb869132f09ccd0$var$onEachFeature(feature, layer) {
    layer.on({
        mouseover: $feb869132f09ccd0$var$highlightPolygon,
        mouseout: $feb869132f09ccd0$var$resetHighlight,
        click: $feb869132f09ccd0$var$showPopup,
        mousedown: $feb869132f09ccd0$var$triggerWhite,
        mouseup: $feb869132f09ccd0$var$triggerBlack
    });
}
// Function to attach tooltip event listeners
function $feb869132f09ccd0$var$attachEventListeners() {
    document.querySelector("#legend-title").addEventListener("mouseenter", function() {
        document.querySelector(".legendTooltip").style.display = "flex";
    });
    document.querySelector("#legend-title").addEventListener("mouseleave", function() {
        document.querySelector(".legendTooltip").style.display = "none";
    });
}
// Function to download data when download button is clicked
function $feb869132f09ccd0$var$exportCSV() {
    // 1. Prepare layer data for download
    let csv = "";
    let row = "";
    // Programmatically extract keys from the first object to use as headers
    const keys = Object.keys($feb869132f09ccd0$var$activeLayer().features[0].properties);
    // Change order of keys
    const keysOrder = [
        "reg_layer",
        "reg_ID",
        "reg_name",
        "start_yr",
        "end_yr",
        "start_mo",
        "end_mo",
        "land_cov"
    ];
    // Filter out the keys items from the original array
    const remainingItems = keys.filter((item)=>!keysOrder.includes(item));
    // Sort the remaining items alphabetically
    remainingItems.sort();
    // Concatenate the keys items with the sorted remaining items
    const keysHeader = keysOrder.concat(remainingItems);
    // Prepare array with new column names based on condition
    let newHeader = keysHeader.map((element)=>{
        if (element === "reg_layer") return "Regional Layer";
        if (element === "reg_ID") return "Region ID";
        if (element === "reg_name") return "Region Name";
        if (element === "start_yr") return "Fire Season Start Year";
        if (element === "end_yr") return "Fire Season End Year";
        if (element === "start_mo") return "Fire Season Start Month";
        if (element === "end_mo") return "Fire Season End Month";
        if (element === "land_cov") return "Land Cover";
        if (element === "ba_anom") return "Burned Area Anomaly in 2023-24 Fire Season (%)";
        if (element === "ba_final") return "Burned Area in 2023-24 Fire Season (km^2)";
        if (element === "ba_mean") return "Burned Area Mean Annual (km^2)";
        if (element === "ba_moAf") return "Months After Peak with Above-Average Burned Area";
        if (element === "ba_moBf") return "Months Prior to Peak with Above-Average Burned Area";
        if (element === "ba_moPk") return "Month with Peak in Burned Area Anomaly";
        if (element === "ba_rank") return "Burned Area Rank in 2023-24 Fire Season";
        if (element === "cem_emAn") return "Carbon Emitted Anomaly in 2023-24 Fire Season (%)";
        if (element === "cem_emFl") return "Carbon Emitted in 2023-24 Fire Season";
        if (element === "cem_emMn") return "Carbon Emitted Mean Annual (kg)";
        if (element === "cem_emRk") return "Carbon Emitted Rank in 2023-24 Fire Season";
        if (element === "frp_95dPc") return "Average Fire's 95th Percentile FRP Anomaly (%)";
        if (element === "frp_95r") return "Average Fire's 95th Percentile FRP Rank (MW)";
        if (element === "cem_moAf") return "Months After Peak with Above-Average Carbon Emitted";
        if (element === "cem_moBf") return "Months Prior to Peak with Above-Average Carbon Emitted";
        if (element === "cem_moPk") return "Month with Peak in Carbon Emitted Anomaly";
        if (element === "gfa_95FAP") return "95th Percentile Fire Size Anomaly in 2023-24 Fire Season (%)";
        if (element === "gfa_95FRk") return "95th Percentile Fire Size Rank in 2023-24 Fire Season";
        if (element === "gfa_95Fz") return "95th Percentile Fire Size in 2023-24 Fire Season (km^2)";
        if (element === "gfa_95RAP") return "95th Percentile Rate of Growth Anomaly in 2023-24 Fire Season (%)";
        if (element === "gfa_95RRk") return "95th Percentile Rate of Growth Rank in 2023-24 Fire Season";
        if (element === "gfa_95Ros") return "95th Percentile Rate of Growth in 2023-24 Fire Season (km^2 day^-1)";
        if (element === "gfa_mxFz") return "Maximum Fire Size in 2023-24 Fire Season (km^2)";
        if (element === "gfa_mxRos") return "Maximum Rate of Growth in 2023-24 Fire Season (km^2 day^-1)";
        if (element === "gfa_nF") return "Number of Fires Rank in 2023-24 Fire Season";
        if (element === "gfa_nFAnP") return "Number of Fires Anomaly in 2023-24 Fire Season (%)";
        if (element === "gfa_nFRk") return "Number of Fires Rank in 2023-24 Fire Season";
        return element;
    });
    // console.log(newHeader)
    // Add keys to CSV as first row
    row = newHeader.join(",");
    csv += row + "\r\n";
    // Loop through each feature, extract values and add to csv
    for(let i = 0; i < $feb869132f09ccd0$var$activeLayer().features.length; i++){
        let line = "";
        for(let j = 0; j < keysHeader.length; j++){
            if (line !== "") line += ",";
            // For region names, remove any commas that may be present
            let value = "";
            if (keysHeader[j] === "reg_name") value = $feb869132f09ccd0$var$activeLayer().features[i].properties[keysHeader[j]].replace(",", "");
            else value = $feb869132f09ccd0$var$activeLayer().features[i].properties[keysHeader[j]];
            line += value;
        }
        csv += line + "\r\n";
    }
    // console.log(csv.split("\n")[0])
    // 2. Create a blob, configure it, create an object URL and pass the blob object into the object URL
    const blob = new Blob([
        csv
    ], {
        type: "text/csv;charset=utf-8,"
    });
    // 3. Create temporary link to download in the browser
    const downloadLink = document.createElement("a");
    downloadLink.download = `${$feb869132f09ccd0$var$activeLayer().name}`;
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.style.display = "none"; // hide temporary link in browser
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}


//# sourceMappingURL=State-of-Wildfires-Map.3e26259d.js.map
